/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Action": [
      "ApiCallAction",
      "ApiCallGraphqlAction",
      "CalculationAction",
      "ChecklistAction",
      "ClinicalNoteAction",
      "ExtensionAction",
      "FormAction",
      "MessageAction",
      "PushToEmrAction"
    ],
    "ExtensionActionField": [
      "BooleanField",
      "DateField",
      "HtmlField",
      "JsonField",
      "NumericArrayField",
      "NumericField",
      "StringArrayField",
      "StringField",
      "TextField"
    ],
    "PaginationAndSortingPayload": [
      "ActivitiesPayload"
    ],
    "Payload": [
      "ActionPayload",
      "ActivateTriggerPayload",
      "AddActionToStepPayload",
      "AddChecklistToStepPayload",
      "AddConditionToRulePayload",
      "AddConstantPayload",
      "AddDataPointDefinitionToPathwayPayload",
      "AddDataPointMappingToExtensionActionPayload",
      "AddDerivedDataPointDefinitionPayload",
      "AddLabelToStepPayload",
      "AddLocationToPathwayPayload",
      "AddMappingToApiCallPayload",
      "AddMessageToStepPayload",
      "AddQuestionToFormPayload",
      "AddQuestionsToFormPayload",
      "AddRuleToQuestionPayload",
      "AddStepFromLibraryToTrackPayload",
      "AddStepToLibraryPayload",
      "AddStepToTrackPayload",
      "AddStickyNoteToTrackPayload",
      "AddTrackToPathwayPayload",
      "AddTransformationToDynamicVariablePayload",
      "AddTriggerToPathwayPayload",
      "AddTriggerToTrackPayload",
      "AddWebhookPayload",
      "AgentPayload",
      "AgentsPayload",
      "AhpLinkPayload",
      "AhpLinkPayloads",
      "BaselineInfoPayload",
      "CalculationResultPayload",
      "CalculationsPayload",
      "CareflowComponentsPayload",
      "CheckpointPayload",
      "CheckpointsPayload",
      "ClearActionDueDatePayload",
      "ClearActionExpirationPayload",
      "ClearActionIdleTimePayload",
      "ClearTimingDelayPayload",
      "ClearTimingReferencePayload",
      "ClinicalNotePayload",
      "CodeBlockPayload",
      "CodeBlocksPayload",
      "ConfigureExtensionPayload",
      "ConnectStepsPayload",
      "ConstantPayload",
      "ConstantsPayload",
      "CreateDynamicVariablePayload",
      "CreateFormPayload",
      "CreateMessagePayload",
      "CreatePathwayCasePayload",
      "CreatePathwayPayload",
      "CreateTransitionPayload",
      "CreateTriggerPayload",
      "DataCatalogCollectionContextsPayload",
      "DataCatalogJsonPayload",
      "DataCatalogPayload",
      "DataPointDefinitionPayload",
      "DataPointDefinitionsPayload",
      "DecisionOutputsPayload",
      "DecisionTablePayload",
      "DecisionTablesPayload",
      "DeleteDecisionTablePayload",
      "DeleteLogicPayload",
      "DeletePathwayCasePayload",
      "DomainEventsPayload",
      "DuplicateCareflowPayload",
      "DuplicateFormPayload",
      "DuplicateQuestionPayload",
      "DuplicateStepPayload",
      "DynamicVariablePayload",
      "DynamicVariablesPayload",
      "EditRulePayload",
      "EditTriggerPayload",
      "ElementsPayload",
      "EmptyPayload",
      "EmrReportPayload",
      "EndTrackAfterStepPayload",
      "EvaluatedRulePayload",
      "ExecuteTestApiCallPayload",
      "ExtensionActivityRecordPayload",
      "ExtensionConfigurationsPayload",
      "ExtensionsPayload",
      "FileStorageConfigPayload",
      "FormPayload",
      "FormResponsePayload",
      "FormsPayload",
      "GeneratedClinicalNotePayload",
      "GeneratedEmrReportPayload",
      "GeneratedMessagePayload",
      "JsonPathPayload",
      "LocationsPayload",
      "LogicPayload",
      "LogicsPayload",
      "MakeFormSharedPayload",
      "MarkReleaseAsLivePayload",
      "MessagePayload",
      "OntologyNodePayload",
      "OntologyPayload",
      "PathwayCaseApiCallPayload",
      "PathwayCaseApiCallsPayload",
      "PathwayCasePayload",
      "PathwayCaseWebhookCallPayload",
      "PathwayCaseWebhookCallsPayload",
      "PathwayCasesPayload",
      "PathwayDiffPayload",
      "PathwayPayload",
      "PathwaySettingsPayload",
      "PathwayValidationStatusPayload",
      "PathwayVersionPayload",
      "PathwayVersionsPayload",
      "PathwaysPayload",
      "PreviewExtensionActionPayload",
      "PublishPathwayPayload",
      "ReadMessagePayload",
      "RebuildViewModelsPayload",
      "RefreshExtensionPayload",
      "RemoveActionFromStepPayload",
      "RemoveClinicalNoteNarrativePayload",
      "RemoveConditionFromRulePayload",
      "RemoveConstantPayload",
      "RemoveDataPointMappingFromExtensionActionPayload",
      "RemoveLabelsFromStepPayload",
      "RemoveMappingFromApiCallPayload",
      "RemoveQuestionFromFormPayload",
      "RemoveRuleFromQuestionPayload",
      "RemoveStepFromTrackPayload",
      "RemoveTrackFromPathwayPayload",
      "RemoveTransformationsFromDynamicVariablePayload",
      "RemoveTransitionPayload",
      "RemoveWebhookPayload",
      "ReorderActionsPayload",
      "ReorderQuestionsPayload",
      "RepairPathwaysPayload",
      "ResetPreviewPayload",
      "RetryWebhookCallPayload",
      "RulePayload",
      "SchemaPayload",
      "SetActionCalculationIdPayload",
      "SetActionCalculationInputPayload",
      "SetActionCalculationLanguagePayload",
      "SetActionChecklistItemsPayload",
      "SetActionDueDatePayload",
      "SetActionExpirationPayload",
      "SetActionFormDisplayModePayload",
      "SetActionFormIdPayload",
      "SetActionIdleTimePayload",
      "SetActionMessageIdPayload",
      "SetActionStakeholdersPayload",
      "SetActionTitlePayload",
      "SetApiCallBodyPayload",
      "SetApiCallEndpointPayload",
      "SetApiCallHeadersPayload",
      "SetApiCallMethodPayload",
      "SetBrandingAccentColorPayload",
      "SetBrandingCustomThemePayload",
      "SetBrandingHostedPageAutoProgressPayload",
      "SetBrandingHostedPageAutosavePayload",
      "SetBrandingHostedPageTitlePayload",
      "SetBrandingLogoUrlPayload",
      "SetCalculationPrerequisiteFormPayload",
      "SetConditionOperandPayload",
      "SetConditionOperatorPayload",
      "SetConditionReferencePayload",
      "SetCustomActionFieldPayload",
      "SetDataPointDefinitionMetaDataFieldPayload",
      "SetDataPointDefinitionOptionalFieldPayload",
      "SetDataPointDefinitionPiiFieldPayload",
      "SetDateQuestionConfigPayload",
      "SetDynamicVariableDataPointDefinitionPayload",
      "SetDynamicVariableDataPointPropertyPayload",
      "SetDynamicVariableFallbackPayload",
      "SetDynamicVariableLabelPayload",
      "SetExtensionActionDataPointMappingDataPointPayload",
      "SetExtensionActionDataPointMappingKeyPayload",
      "SetExtensionActionDataPointMappingsPayload",
      "SetExtensionActionErrorHandlingPayload",
      "SetExtensionActionFieldPayload",
      "SetFileQuestionConfigPayload",
      "SetFormKeyPayload",
      "SetFormMetadataPayload",
      "SetFormTitlePayload",
      "SetFormTrademarkPayload",
      "SetInputValidationQuestionConfigPayload",
      "SetLogicCoordinatesPayload",
      "SetMultipleSelectQuestionConfigPayload",
      "SetNumberQuestionConfigPayload",
      "SetPathwayCaseTitlePayload",
      "SetPathwayTitlePayload",
      "SetPhoneQuestionConfigPayload",
      "SetQuestionConfigPayload",
      "SetQuestionKeyPayload",
      "SetQuestionMetadataPayload",
      "SetQuestionOptionValueTypePayload",
      "SetQuestionsConfigPayload",
      "SetRemindersAmountPayload",
      "SetRemindersDelayPayload",
      "SetRuleBooleanOperatorPayload",
      "SetRuleTypePayload",
      "SetSliderQuestionConfigPayload",
      "SetStakeholderEmailsPayload",
      "SetStepCoordinatesPayload",
      "SetStepDocumentationPayload",
      "SetStepTitlePayload",
      "SetStickyNoteCoordinatesPayload",
      "SetTimingDelayPayload",
      "SetTimingReferencePayload",
      "SetTrackDescriptionPayload",
      "SetTrackEndCoordinatesPayload",
      "SetTrackLoopConfigurationPayload",
      "SetTrackStartCoordinatesPayload",
      "SetTrackTitlePayload",
      "SetTransformationParamsPayload",
      "SetTransformationTypePayload",
      "SetTransitionDestinationPayload",
      "StakeholdersPayload",
      "StartPreviewPayload",
      "StartTrackFromStepPayload",
      "StartTransitionFromStepPayload",
      "StepLibraryPayload",
      "StepPayload",
      "StepsPayload",
      "StickyNotePayload",
      "StickyNotesPayload",
      "SubmitChecklistPayload",
      "SubmitFormResponsePayload",
      "TenantPayload",
      "TenantsPayload",
      "TestSourceControlPayload",
      "TimerPayload",
      "TimersPayload",
      "TimingPayload",
      "TrackPayload",
      "TracksPayload",
      "TransitionPayload",
      "TransitionsPayload",
      "TriggerActivationPayload",
      "TriggerActivationsPayload",
      "TriggerApiCallPayload",
      "TriggerPayload",
      "UpdateApiCallMappingDataPointPayload",
      "UpdateApiCallMappingFirstMatchOnlyPayload",
      "UpdateApiCallMappingKeyPayload",
      "UpdateCareFlowApiCallRetrySettingsPayload",
      "UpdateCareFlowSourceControlSettingsPayload",
      "UpdateClinicalNoteContextPayload",
      "UpdateConstantPayload",
      "UpdateDataPointDefinitionPayload",
      "UpdateDynamicVariablePayload",
      "UpdateEmailNotificationStatusPayload",
      "UpdateLabelTextPayload",
      "UpdateQuestionPayload",
      "UpdateStickyNoteBodyPayload",
      "UpdateWebhookEndpointPayload",
      "UpdateWebhookHeadersPayload",
      "UpdateWebhookNamePayload",
      "UpdateWebhookPayload",
      "UpdateWebhookStatusPayload",
      "UpdateWebhookSubscribedEventsPayload",
      "UpdateWebhookTestEndpointPayload",
      "UserPayload",
      "WebhookPayload"
    ],
    "TimerConfig": [
      "DataPointAwaitedTimerConfig",
      "DataPointReferenceTimerConfig",
      "DelayTimerConfig",
      "ExtensionResourceUpdatedTimerConfig"
    ],
    "Transformation": [
      "AddDurationTransformation",
      "AddPrefixTransformation",
      "AddSuffixTransformation",
      "AddWeekdaysTransformation",
      "FormatDateTransformation",
      "FormatPhoneNumberTransformation",
      "RoundToTransformation",
      "SubtractDurationTransformation"
    ],
    "TriggerActivationReference": [
      "AdHocActivationReference",
      "DataPointCollectedActivationReference",
      "PathwayStartedActivationReference",
      "StepCompletedActivationReference",
      "TrackCompletedActivationReference",
      "TrackStartedActivationReference"
    ],
    "TriggerSettings": [
      "AdHocTriggerSettings",
      "DataPointCollectedTriggerSettings",
      "DataPointNotCollectedTriggerSettings",
      "DesignatedTriggerTimer",
      "EventBasedTriggerSettings",
      "ExtensionWebhookTriggerSettings",
      "PathwayStartedTriggerSettings",
      "StepCompletedTriggerSettings",
      "TrackCompletedTriggerSettings"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Safe date scalar that can serialize string or date */
  SafeDate: { input: any; output: any; }
};

export type Action = {
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type ActionComponent = {
  __typename?: 'ActionComponent';
  definition_id?: Maybe<Scalars['String']['output']>;
  release_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionCustomFieldInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ActionData = {
  __typename?: 'ActionData';
  prevent_duplicate_enrollment?: Maybe<Scalars['Boolean']['output']>;
  track_definition_id?: Maybe<Scalars['String']['output']>;
  track_name?: Maybe<Scalars['String']['output']>;
};

export type ActionDueDateInput = {
  action_id: Scalars['String']['input'];
  due_date?: InputMaybe<DueDateInput>;
};

export type ActionExpirationInput = {
  action_id: Scalars['String']['input'];
  expiration?: InputMaybe<ExpirationInput>;
};

export type ActionPayload = Payload & {
  __typename?: 'ActionPayload';
  /**
   *
   *   An action is a ? TBD ? at a specific date.
   *   Actions are caused by a human(manual) or system(automated).
   *   Something or someone causing actions is referred to as an agent (https://english.stackexchange.com/a/96105).
   *   Action only exist in a context of a step.
   *   By humans we mean patients or care teams.
   *   By system we mean the Awell engine.
   *   Typical actions done by humans are filing in forms and checklists.
   *   Typical actions done by systems are calculations and sending messages.
   *
   *   An action definition is the set of information needed to perform an action.
   *   information can be:
   *   - static
   *   - dynamic
   *
   *   Information is static when it is not expected to change during the time a pathway is active
   *   Examples of static information:
   *   - constants. e.g., specific email "foo@gmail.com" in a send message action
   *   - gender of the patient
   *   - name of the organisation
   *   - preferences of the organisation like preferred reminder channel
   *
   *   Information is dynamic when it is collected during an execution:
   *   Examples of dynamic information:
   *   - Form submissions
   *   - step completion and activation dates
   *   - Calculation results
   *
   *
   */
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export enum ActionType {
  ApiCall = 'API_CALL',
  ApiCallGraphql = 'API_CALL_GRAPHQL',
  Calculation = 'CALCULATION',
  Checklist = 'CHECKLIST',
  ClinicalNote = 'CLINICAL_NOTE',
  Form = 'FORM',
  Message = 'MESSAGE',
  Plugin = 'PLUGIN',
  PushToEmr = 'PUSH_TO_EMR'
}

export type ActivateTriggerInput = {
  trigger_activation_id: Scalars['String']['input'];
};

export type ActivateTriggerPayload = Payload & {
  __typename?: 'ActivateTriggerPayload';
  activated: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  evaluated_rule_id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ActivitiesDeleted = {
  __typename?: 'ActivitiesDeleted';
  activity_ids: Array<Scalars['String']['output']>;
};

export type ActivitiesPayload = PaginationAndSortingPayload & {
  __typename?: 'ActivitiesPayload';
  activities: Array<Activity>;
  code: Scalars['String']['output'];
  metadata?: Maybe<ActivityMetadata>;
  pagination?: Maybe<PaginationOutput>;
  sorting?: Maybe<SortingOutput>;
  success: Scalars['Boolean']['output'];
};

export type Activity = {
  __typename?: 'Activity';
  action: ActivityAction;
  action_component?: Maybe<ActionComponent>;
  container_name?: Maybe<Scalars['String']['output']>;
  context?: Maybe<PathwayContext>;
  date: Scalars['String']['output'];
  /** Url for icon, only used by extensions custom actions */
  icon_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indirect_object?: Maybe<ActivityObject>;
  isUserActivity: Scalars['Boolean']['output'];
  label?: Maybe<ActivityLabel>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  object: ActivityObject;
  public?: Maybe<Scalars['Boolean']['output']>;
  reference_id: Scalars['String']['output'];
  reference_type: ActivityReferenceType;
  resolution?: Maybe<ActivityResolution>;
  session_id?: Maybe<Scalars['String']['output']>;
  stakeholders?: Maybe<Array<ActivityObject>>;
  status: ActivityStatus;
  stream_id: Scalars['String']['output'];
  sub_activities: Array<SubActivity>;
  subject: ActivitySubject;
  track?: Maybe<ActivityTrack>;
};

export enum ActivityAction {
  Activate = 'ACTIVATE',
  Added = 'ADDED',
  Assigned = 'ASSIGNED',
  Complete = 'COMPLETE',
  Computed = 'COMPUTED',
  Delegated = 'DELEGATED',
  Deliver = 'DELIVER',
  Discarded = 'DISCARDED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  FailedToSend = 'FAILED_TO_SEND',
  Generated = 'GENERATED',
  IsWaitingOn = 'IS_WAITING_ON',
  Paused = 'PAUSED',
  Postponed = 'POSTPONED',
  Processed = 'PROCESSED',
  Read = 'READ',
  Remind = 'REMIND',
  Reported = 'REPORTED',
  Scheduled = 'SCHEDULED',
  Send = 'SEND',
  Skipped = 'SKIPPED',
  Stopped = 'STOPPED',
  Submitted = 'SUBMITTED'
}

export type ActivityLabel = {
  __typename?: 'ActivityLabel';
  color: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ActivityMetadata = {
  __typename?: 'ActivityMetadata';
  stakeholders?: Maybe<Array<ActivityObject>>;
};

export type ActivityObject = {
  __typename?: 'ActivityObject';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preferred_language?: Maybe<Scalars['String']['output']>;
  type: ActivityObjectType;
};

export enum ActivityObjectType {
  Action = 'ACTION',
  Agent = 'AGENT',
  ApiCall = 'API_CALL',
  Calculation = 'CALCULATION',
  Checklist = 'CHECKLIST',
  ClinicalNote = 'CLINICAL_NOTE',
  EmrReport = 'EMR_REPORT',
  EmrRequest = 'EMR_REQUEST',
  EnrollmentTrigger = 'ENROLLMENT_TRIGGER',
  EvaluatedRule = 'EVALUATED_RULE',
  Form = 'FORM',
  Logic = 'LOGIC',
  Message = 'MESSAGE',
  Pathway = 'PATHWAY',
  Patient = 'PATIENT',
  Plugin = 'PLUGIN',
  PluginAction = 'PLUGIN_ACTION',
  Reminder = 'REMINDER',
  Stakeholder = 'STAKEHOLDER',
  Step = 'STEP',
  Timer = 'TIMER',
  TimerCompletion = 'TIMER_COMPLETION',
  Track = 'TRACK',
  TrackTrigger = 'TRACK_TRIGGER',
  User = 'USER'
}

export enum ActivityReferenceType {
  Agent = 'AGENT',
  Navigation = 'NAVIGATION',
  Orchestration = 'ORCHESTRATION',
  Reminder = 'REMINDER'
}

export enum ActivityResolution {
  Expired = 'EXPIRED',
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum ActivityStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Expired = 'EXPIRED',
  Failed = 'FAILED'
}

export type ActivitySubject = {
  __typename?: 'ActivitySubject';
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: ActivitySubjectType;
};

export enum ActivitySubjectType {
  Agent = 'AGENT',
  ApiCall = 'API_CALL',
  Awell = 'AWELL',
  Plugin = 'PLUGIN',
  Stakeholder = 'STAKEHOLDER',
  User = 'USER'
}

export type ActivityTrack = {
  __typename?: 'ActivityTrack';
  id?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AdHocActivationReference = TriggerActivationReference & {
  __typename?: 'AdHocActivationReference';
  type?: Maybe<TriggerActivationReferenceType>;
};

export type AdHocTriggerSettings = TriggerSettings & {
  __typename?: 'AdHocTriggerSettings';
  rule?: Maybe<Rule>;
  type?: Maybe<TriggerType>;
};

export type AddActionFromTemplateInput = {
  calculation_id?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<ExtensionActionInput>;
  stakeholder_id?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: ActionType;
};

export type AddActionToStepInput = {
  custom_action_id?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<ExtensionActionInput>;
  step_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: ActionType;
};

export type AddActionToStepPayload = Payload & {
  __typename?: 'AddActionToStepPayload';
  action: Action;
  api_call?: Maybe<ApiCall>;
  code: Scalars['String']['output'];
  emr_report?: Maybe<EmrReport>;
  error?: Maybe<ErrorObject>;
  message?: Maybe<Message>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddAgentToTrackInput = {
  coordinates: CoordinatesInput;
  track_id: Scalars['String']['input'];
};

export type AddAttachmentInput = {
  name: Scalars['String']['input'];
  type: MessageAttachmentType;
  url: Scalars['String']['input'];
};

export type AddChecklistToStepInput = {
  checklist: Array<Scalars['String']['input']>;
  stakeholder_ids: Array<Scalars['String']['input']>;
  step_id: Scalars['String']['input'];
  /** Action title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AddChecklistToStepPayload = Payload & {
  __typename?: 'AddChecklistToStepPayload';
  action: ChecklistAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddConditionToRuleInput = {
  condition?: InputMaybe<ConditionInput>;
  rule_id: Scalars['String']['input'];
};

export type AddConditionToRulePayload = Payload & {
  __typename?: 'AddConditionToRulePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type AddConstantInput = {
  constant: NewConstantInput;
  pathway_id: Scalars['String']['input'];
};

export type AddConstantPayload = Payload & {
  __typename?: 'AddConstantPayload';
  code: Scalars['String']['output'];
  constant: Constant;
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type AddCustomActionToPathwayInput = {
  custom_action: CustomActionInput;
  pathway_id: Scalars['String']['input'];
};

export type AddCustomFieldToPathwayInput = {
  labels: Array<LabelInput>;
  pathway_id: Scalars['String']['input'];
};

export type AddDataPointDefinitionInput = {
  category: DataPointSourceType;
  jsonPath?: InputMaybe<Scalars['String']['input']>;
  jsonSchemaSource?: InputMaybe<JsonSchemaSourceGraphqlTypeInput>;
  key: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  possibleValues?: InputMaybe<Array<DataPointPossibleValueInput>>;
  range?: InputMaybe<RangeInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
  valueType: DataPointValueType;
};

export type AddDataPointDefinitionToPathwayInput = {
  data_point_definition: AddDataPointDefinitionInput;
  pathway_id: Scalars['String']['input'];
};

export type AddDataPointDefinitionToPathwayPayload = Payload & {
  __typename?: 'AddDataPointDefinitionToPathwayPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AddDataPointMappingToExtensionActionInput = {
  action_id: Scalars['String']['input'];
};

export type AddDataPointMappingToExtensionActionPayload = Payload & {
  __typename?: 'AddDataPointMappingToExtensionActionPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AddDerivedDataPointDefinitionInput = {
  derived_data_point_definition: DerivedDataPointDefinitionInput;
  pathway_id: Scalars['String']['input'];
};

export type AddDerivedDataPointDefinitionPayload = Payload & {
  __typename?: 'AddDerivedDataPointDefinitionPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AddDurationParameters = {
  __typename?: 'AddDurationParameters';
  duration?: Maybe<DurationGraphQlObjectType>;
};

export type AddDurationTransformation = Transformation & {
  __typename?: 'AddDurationTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<AddDurationParameters>;
  type: TransformationType;
};

export type AddLabelToStepInput = {
  label_id: Scalars['String']['input'];
  step_id: Scalars['String']['input'];
};

export type AddLabelToStepPayload = Payload & {
  __typename?: 'AddLabelToStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddLocationToPathwayInput = {
  label: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type AddLocationToPathwayPayload = Payload & {
  __typename?: 'AddLocationToPathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  location: Location;
  success: Scalars['Boolean']['output'];
};

export type AddLogicToTrackInput = {
  config_id?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinatesInput;
  name: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
  type: LogicType;
};

export type AddMappingToApiCallInput = {
  api_call_id: Scalars['String']['input'];
  data_point_definition_id?: InputMaybe<Scalars['String']['input']>;
  response_key: Scalars['String']['input'];
};

export type AddMappingToApiCallPayload = Payload & {
  __typename?: 'AddMappingToApiCallPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AddMessageAttachmentInput = {
  attachment: AddAttachmentInput;
  message_id: Scalars['String']['input'];
};

export type AddMessageToStepInput = {
  /** Message body in either Slate or HTML format */
  body?: InputMaybe<MessageBodyInput>;
  stakeholder_ids: Array<Scalars['String']['input']>;
  step_id: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Action title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AddMessageToStepPayload = Payload & {
  __typename?: 'AddMessageToStepPayload';
  action: MessageAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  message?: Maybe<Message>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddNarrativeToClinicalNoteInput = {
  clinical_note_id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddPrefixParameters = {
  __typename?: 'AddPrefixParameters';
  prefix?: Maybe<Scalars['String']['output']>;
};

export type AddPrefixTransformation = Transformation & {
  __typename?: 'AddPrefixTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<AddPrefixParameters>;
  type: TransformationType;
};

export type AddQuestionToFormInput = {
  /** The ID of the form to add the question to. */
  form_id: Scalars['String']['input'];
  /** Use this if you want to add the question at a specific position in the form. When this is not provided, the question will be added at the end of the form. */
  previous_question_id?: InputMaybe<Scalars['String']['input']>;
  /** The type of question to add. */
  user_question_type: UserQuestionType;
};

export type AddQuestionToFormPayload = Payload & {
  __typename?: 'AddQuestionToFormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type AddQuestionsToFormInput = {
  /** The ID of the form to add the questions to. */
  form_id: Scalars['String']['input'];
  /** The list of questions to add to the form. */
  questions: Array<QuestionInput>;
};

export type AddQuestionsToFormPayload = Payload & {
  __typename?: 'AddQuestionsToFormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  questions: Array<Question>;
  success: Scalars['Boolean']['output'];
};

export type AddRuleToQuestionInput = {
  form_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
};

export type AddRuleToQuestionPayload = Payload & {
  __typename?: 'AddRuleToQuestionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type AddStepFromLibraryToTrackInput = {
  coordinates: CoordinatesInput;
  step_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type AddStepFromLibraryToTrackPayload = Payload & {
  __typename?: 'AddStepFromLibraryToTrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddStepFromTemplateInput = {
  actions: Array<AddActionFromTemplateInput>;
  coordinates: CoordinatesInput;
  title: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type AddStepToLibraryInput = {
  step_id: Scalars['String']['input'];
};

export type AddStepToLibraryPayload = Payload & {
  __typename?: 'AddStepToLibraryPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddStepToTrackInput = {
  coordinates: CoordinatesInput;
  track_id: Scalars['String']['input'];
};

export type AddStepToTrackPayload = Payload & {
  __typename?: 'AddStepToTrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type AddStickyNoteToTrackInput = {
  body?: InputMaybe<StickyNoteBodyInput>;
  coordinates: CoordinatesInput;
  track_id: Scalars['String']['input'];
};

export type AddStickyNoteToTrackPayload = Payload & {
  __typename?: 'AddStickyNoteToTrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stickyNote: StickyNote;
  success: Scalars['Boolean']['output'];
};

export type AddSuffixParameters = {
  __typename?: 'AddSuffixParameters';
  suffix?: Maybe<Scalars['String']['output']>;
};

export type AddSuffixTransformation = Transformation & {
  __typename?: 'AddSuffixTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<AddSuffixParameters>;
  type: TransformationType;
};

export type AddTimerToTrackInput = {
  coordinates: CoordinatesInput;
  name: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type AddTrackInput = {
  pathway_case_id: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  track_definition_id: Scalars['String']['input'];
};

export type AddTrackToPathwayInput = {
  pathway_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddTrackToPathwayPayload = Payload & {
  __typename?: 'AddTrackToPathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type AddTransformationToDynamicVariableInput = {
  dynamic_variable_id: Scalars['String']['input'];
  type: TransformationType;
};

export type AddTransformationToDynamicVariablePayload = Payload & {
  __typename?: 'AddTransformationToDynamicVariablePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AddTriggerTimerInput = {
  trigger_id: Scalars['String']['input'];
};

export type AddTriggerToPathwayInput = {
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type AddTriggerToPathwayPayload = Payload & {
  __typename?: 'AddTriggerToPathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger: Trigger;
};

export type AddTriggerToTrackInput = {
  track_id: Scalars['String']['input'];
};

export type AddTriggerToTrackPayload = Payload & {
  __typename?: 'AddTriggerToTrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger: Trigger;
};

export type AddWebhookInput = {
  pathway_id: Scalars['String']['input'];
  webhook: NewWebhookInput;
};

export type AddWebhookPayload = Payload & {
  __typename?: 'AddWebhookPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhook: Webhook;
};

export type AddWeekdaysParameters = {
  __typename?: 'AddWeekdaysParameters';
  days?: Maybe<Scalars['Float']['output']>;
};

export type AddWeekdaysTransformation = Transformation & {
  __typename?: 'AddWeekdaysTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<AddWeekdaysParameters>;
  type: TransformationType;
};

export type Agent = {
  __typename?: 'Agent';
  config?: Maybe<AgentConfig>;
  coordinates?: Maybe<Coordinates>;
  id: Scalars['ID']['output'];
};

export type AgentConfig = {
  __typename?: 'AgentConfig';
  agent_uuid: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inputs: Array<AgentConfigMapping>;
  name: Scalars['String']['output'];
  outputs: Array<AgentConfigMapping>;
  stakeholders: Array<AgentStakeholder>;
  tools: AgentTool;
  version: Scalars['Float']['output'];
};

export type AgentConfigInput = {
  agent_uuid: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  inputs: Array<AgentConfigMappingInput>;
  name: Scalars['String']['input'];
  outputs: Array<AgentConfigMappingInput>;
  stakeholders: Array<AgentStakeholderInput>;
  tools: AgentToolInput;
  version: Scalars['Float']['input'];
};

export type AgentConfigMapping = {
  __typename?: 'AgentConfigMapping';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  static_value?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AgentConfigMappingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  static_value: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AgentPayload = Payload & {
  __typename?: 'AgentPayload';
  agent: Agent;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AgentStakeholder = {
  __typename?: 'AgentStakeholder';
  definition_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AgentStakeholderInput = {
  definition_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AgentTool = {
  __typename?: 'AgentTool';
  calculations: Array<Scalars['String']['output']>;
  extensions: Array<AgentToolExtension>;
  forms: Array<Scalars['String']['output']>;
  messages: Scalars['Boolean']['output'];
};

export type AgentToolExtension = {
  __typename?: 'AgentToolExtension';
  action: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type AgentToolExtensionInput = {
  action: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type AgentToolInput = {
  calculations: Array<Scalars['String']['input']>;
  extensions: Array<AgentToolExtensionInput>;
  forms: Array<Scalars['String']['input']>;
  messages: Scalars['Boolean']['input'];
};

export type AgentsPayload = Payload & {
  __typename?: 'AgentsPayload';
  agents: Array<Agent>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AhpLink = {
  __typename?: 'AhpLink';
  base_url: Scalars['String']['output'];
  cancel_url?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  language: Language;
  pathway_definition_id: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  stakeholder?: Maybe<Stakeholder>;
  stakeholder_definition_id: Scalars['String']['output'];
  success_url?: Maybe<Scalars['String']['output']>;
};

export type AhpLinkInput = {
  cancel_url?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  language: Language;
  pathway_definition_id: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  stakeholder_definition_id: Scalars['String']['input'];
  success_url?: InputMaybe<Scalars['String']['input']>;
};

export type AhpLinkPayload = Payload & {
  __typename?: 'AhpLinkPayload';
  ahp_link: AhpLink;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AhpLinkPayloads = Payload & {
  __typename?: 'AhpLinkPayloads';
  ahp_links: Array<AhpLink>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type AllowedCharsInput = {
  letters: Scalars['Boolean']['input'];
  numbers: Scalars['Boolean']['input'];
  special: Scalars['Boolean']['input'];
  whitespace: Scalars['Boolean']['input'];
};

export enum AllowedDatesOptions {
  All = 'ALL',
  Future = 'FUTURE',
  Past = 'PAST'
}

export type Answer = {
  __typename?: 'Answer';
  question_id: Scalars['String']['output'];
  value: Scalars['String']['output'];
  value_type: DataPointValueType;
};

export type AnswerInput = {
  question_id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ApiCall = {
  __typename?: 'ApiCall';
  body?: Maybe<MessageBodyTemplate>;
  endpoint?: Maybe<Scalars['String']['output']>;
  headers: Array<ApiCallHeader>;
  id: Scalars['ID']['output'];
  mappings: Array<ApiCallMapping>;
  method: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ApiCallAction = Action & {
  __typename?: 'ApiCallAction';
  api_call?: Maybe<ApiCall>;
  api_call_id: Scalars['ID']['output'];
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type ApiCallBodyInput = {
  html: Scalars['String']['input'];
  plaintext: Scalars['String']['input'];
  slate: Scalars['String']['input'];
};

export type ApiCallGraphqlAction = Action & {
  __typename?: 'ApiCallGraphqlAction';
  api_call?: Maybe<ApiCall>;
  api_call_id: Scalars['ID']['output'];
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type ApiCallHeader = {
  __typename?: 'ApiCallHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ApiCallHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ApiCallMapping = {
  __typename?: 'ApiCallMapping';
  data_point_definition_id?: Maybe<Scalars['String']['output']>;
  first_match_only?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  response_key: Scalars['String']['output'];
};

export type ApiCallRequest = {
  __typename?: 'ApiCallRequest';
  body?: Maybe<Scalars['String']['output']>;
  endpoint: Scalars['String']['output'];
  headers: Array<ApiCallHeader>;
  method: ApiCallRequestMethod;
};

export enum ApiCallRequestMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type ApiCallResponse = {
  __typename?: 'ApiCallResponse';
  body: Scalars['String']['output'];
  date: Scalars['String']['output'];
  status: Scalars['Float']['output'];
};

export type ApiCallRetrySettings = {
  __typename?: 'ApiCallRetrySettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  initial_delay_ms?: Maybe<Scalars['Float']['output']>;
  max_attempts?: Maybe<Scalars['Float']['output']>;
  max_delay_ms?: Maybe<Scalars['Float']['output']>;
};

export type ApiCallRetrySettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  initial_delay_ms?: InputMaybe<Scalars['Float']['input']>;
  max_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_delay_ms?: InputMaybe<Scalars['Float']['input']>;
};

export enum ApiCallStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  PermanentlyFailed = 'PermanentlyFailed',
  Skipped = 'Skipped',
  Success = 'Success'
}

export type ApiPathwayContext = {
  __typename?: 'ApiPathwayContext';
  id: Scalars['String']['output'];
  pathway_definition_id: Scalars['String']['output'];
  patient_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
};

export type Audit = {
  __typename?: 'Audit';
  at: Scalars['String']['output'];
  by: Scalars['String']['output'];
};

export type AuditTrail = {
  __typename?: 'AuditTrail';
  date: Scalars['SafeDate']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type AvailableWebhook = {
  __typename?: 'AvailableWebhook';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type BaselineDataPoint = {
  __typename?: 'BaselineDataPoint';
  definition: DataPointDefinition;
  value?: Maybe<Scalars['String']['output']>;
};

export type BaselineInfoInput = {
  data_point_definition_id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BaselineInfoPayload = Payload & {
  __typename?: 'BaselineInfoPayload';
  baselineDataPoints: Array<BaselineDataPoint>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type BooleanField = ExtensionActionField & {
  __typename?: 'BooleanField';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
  /** Value is kept as string because it can contain data point definition id in handlebars template, otherwise it can be "true" or "false" */
  value?: Maybe<Scalars['String']['output']>;
};

export enum BooleanOperator {
  And = 'AND',
  Or = 'OR'
}

export type BrandingSettings = {
  __typename?: 'BrandingSettings';
  accent_color?: Maybe<Scalars['String']['output']>;
  custom_theme?: Maybe<FormattedJson>;
  hosted_page_auto_progress?: Maybe<Scalars['Boolean']['output']>;
  hosted_page_autosave?: Maybe<Scalars['Boolean']['output']>;
  hosted_page_title?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
};

/**
 *
 *  Calculations are functions that take data points as input and output new data points
 *  For the definition of a data point, see DataPointsPayload.ts
 *
 *  Most often these calculations are scores used to diagnose patients.
 *  Examples are:
 *  - Mayo score
 *  - PRO2 score
 *  - Oxford hip score
 *  - EORTC score
 *  ...
 *
 *  Calculations can also be customer specific algorithms that are used for example to triage patients
 *  A calculation consists of scores.
 *
 *  Calculation definitions include:
 *  - a list of score definitions
 *  - the calculation title
 *  - the calculation key. This is human readable id
 *
 *  A score definition consists of a:
 *  - type
 *  - id
 *  - title
 *  - if type = integer, range
 *
 *  The implementation of the calculation is **not** included in the calculation definition
 *
 */
export type Calculation = {
  __typename?: 'Calculation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  results: Array<CalculationResult>;
  title: Scalars['String']['output'];
};

export type CalculationAction = Action & {
  __typename?: 'CalculationAction';
  calculation_id?: Maybe<Scalars['ID']['output']>;
  calculation_inputs: Array<CalculationInput>;
  calculation_language?: Maybe<Scalars['String']['output']>;
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  prerequisite_form_action_id?: Maybe<Scalars['ID']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type CalculationInput = {
  __typename?: 'CalculationInput';
  calculation_input_id: Scalars['String']['output'];
  data_point_definition_id: Scalars['String']['output'];
};

export type CalculationResult = {
  __typename?: 'CalculationResult';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  range?: Maybe<Range>;
  title: Scalars['String']['output'];
  valueType: DataPointValueType;
};

export type CalculationResultInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
};

export type CalculationResultPayload = Payload & {
  __typename?: 'CalculationResultPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  result: Array<CalculationSingleResult>;
  success: Scalars['Boolean']['output'];
};

export type CalculationSingleResult = {
  __typename?: 'CalculationSingleResult';
  status?: Maybe<Scalars['String']['output']>;
  subresult_id: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  value_type?: Maybe<DataPointValueType>;
};

export type CalculationsPayload = Payload & {
  __typename?: 'CalculationsPayload';
  calculations: Array<Calculation>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type CareflowComponentsPayload = Payload & {
  __typename?: 'CareflowComponentsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  json: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CareflowSummarizationEvent = {
  __typename?: 'CareflowSummarizationEvent';
  careflow_definition_id: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event_name: CareflowSummarizationEventName;
  event_type?: Maybe<Scalars['String']['output']>;
  final_output?: Maybe<Scalars['JSON']['output']>;
  member_id: Scalars['String']['output'];
  organization_id: Scalars['String']['output'];
  release_id?: Maybe<Scalars['String']['output']>;
  run_id: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  thread_id: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum CareflowSummarizationEventName {
  RunCompleted = 'RUN_COMPLETED',
  RunError = 'RUN_ERROR',
  RunFlushed = 'RUN_FLUSHED',
  RunProgress = 'RUN_PROGRESS',
  RunStarted = 'RUN_STARTED'
}

export type ChecklistAction = Action & {
  __typename?: 'ChecklistAction';
  /**
   *
   * A checklist is a set of todos for a human to complete
   * A todo is an instruction
   * A checklist is part of a checklist action
   *
   * Example of checklist:
   * - Safety checklist before surgery:
   * -- review medical file of the patient
   * -- check heart-rate
   *
   *
   * Notes regarding execution domain
   * --------------------------------
   * A checklist action is done when all the todos of the checklist are marked as completed
   * In the execution domain each todo will have a complete / not complete state
   *
   * Remaining questions to answer:
   * - Are todos simple strings or will they be more complex? e.g., to be filled in by specific role? to be completed by specific date? can be skipped? can they be grouped?
   *
   */
  checklist?: Maybe<Array<Scalars['String']['output']>>;
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type Checkpoint = {
  __typename?: 'Checkpoint';
  careflow_id: Scalars['String']['output'];
  description?: Maybe<FormattedText>;
  id: Scalars['ID']['output'];
  metadata: CheckpointMetadata;
  version: Scalars['Int']['output'];
};

export type CheckpointMessage = {
  __typename?: 'CheckpointMessage';
  checkpoint: Checkpoint;
  message: Scalars['String']['output'];
};

export type CheckpointMetadata = {
  __typename?: 'CheckpointMetadata';
  created_at: Scalars['SafeDate']['output'];
};

export type CheckpointPayload = Payload & {
  __typename?: 'CheckpointPayload';
  checkpoint: Checkpoint;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type CheckpointsPayload = Payload & {
  __typename?: 'CheckpointsPayload';
  checkpoints: Array<Checkpoint>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type ChoiceRangeConfig = {
  __typename?: 'ChoiceRangeConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type ChoiceRangeConfigInput = {
  /** Enable this flag to limit the number of choices the user can make. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum number of choices the user can make. */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum number of choices the user has to make. */
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type ClearActionDueDateInput = {
  action_id: Scalars['String']['input'];
};

export type ClearActionDueDatePayload = Payload & {
  __typename?: 'ClearActionDueDatePayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type ClearActionExpirationInput = {
  action_id: Scalars['String']['input'];
};

export type ClearActionExpirationPayload = Payload & {
  __typename?: 'ClearActionExpirationPayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type ClearActionIdleTimeInput = {
  action_id: Scalars['String']['input'];
};

export type ClearActionIdleTimePayload = Payload & {
  __typename?: 'ClearActionIdleTimePayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type ClearTimingDelayInput = {
  timing_id: Scalars['String']['input'];
};

export type ClearTimingDelayPayload = Payload & {
  __typename?: 'ClearTimingDelayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timing: Timing;
};

export type ClearTimingReferenceInput = {
  timing_id: Scalars['String']['input'];
};

export type ClearTimingReferencePayload = Payload & {
  __typename?: 'ClearTimingReferencePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timing: Timing;
};

export type ClinicalNote = {
  __typename?: 'ClinicalNote';
  context: Array<ClinicalNoteContextField>;
  id: Scalars['ID']['output'];
  narratives: Array<ClinicalNoteNarrative>;
};

export type ClinicalNoteAction = Action & {
  __typename?: 'ClinicalNoteAction';
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type ClinicalNoteContextField = {
  __typename?: 'ClinicalNoteContextField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ClinicalNoteContextFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ClinicalNoteNarrative = {
  __typename?: 'ClinicalNoteNarrative';
  body?: Maybe<Scalars['String']['output']>;
  html_body?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ClinicalNotePayload = Payload & {
  __typename?: 'ClinicalNotePayload';
  clinical_note: ClinicalNote;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

/** A code block component that executes JavaScript code with inputs and produces outputs */
export type CodeBlock = {
  __typename?: 'CodeBlock';
  /** LangGraph thread ID for AI-assisted code editing conversations */
  agentThreadId?: Maybe<Scalars['String']['output']>;
  /** The care flow this code block belongs to */
  care_flow_definition_id: Scalars['String']['output'];
  /** JavaScript code defining run(input) function. Available globals: _ (lodash), dateFns, z (zod), env (constants), console. Must return { outputs: {...}, result: "RESULT_VALUE" }. */
  code: Scalars['String']['output'];
  /** Unique identifier for this code block */
  definition_id: Scalars['ID']['output'];
  /** Input data points available to the code via the input object */
  inputDefinitions: Array<CodeBlockInput>;
  /** Output data points that the code produces */
  outputDefinitions: Array<CodeBlockOutput>;
  /** Possible result values the code can return. Each creates a possible transition path. Code returns { result: "VALUE" }. */
  resultValues: Array<Scalars['String']['output']>;
  /** Display name for the code block */
  title: Scalars['String']['output'];
};

/** An input data point mapped to the code block, available via input.alias in user code */
export type CodeBlockInput = {
  __typename?: 'CodeBlockInput';
  /** Variable name to access this input in code (e.g., "age" for input.age) */
  alias?: Maybe<Scalars['String']['output']>;
  /** Reference to a data point definition ID in the care flow */
  dataPointDefinitionId: Scalars['String']['output'];
  /** Unique identifier for this input definition */
  id: Scalars['String']['output'];
};

/** Defines an input data point that will be available in the code via input.alias */
export type CodeBlockInputInput = {
  /** Variable name to access this input in code (e.g., "age" allows input.age). If not provided, the data point key is used. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Reference to an existing data point definition ID in the care flow */
  dataPointDefinitionId: Scalars['String']['input'];
  /** Unique identifier for this input definition (use nanoid or uuid) */
  id: Scalars['String']['input'];
};

/** An output data point produced by the code block */
export type CodeBlockOutput = {
  __typename?: 'CodeBlockOutput';
  /** Human-readable description of what this output represents */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this output definition */
  id: Scalars['String']['output'];
  /** Key name for this output - must match the key returned in outputs object */
  key: Scalars['String']['output'];
  /** If true, the code must return this output or execution fails */
  required: Scalars['Boolean']['output'];
  /** Data type: STRING, NUMBER, BOOLEAN, DATE, STRINGS_ARRAY, NUMBERS_ARRAY, or JSON */
  valueType: DataPointValueType;
};

/** Defines an output data point that the code will produce */
export type CodeBlockOutputInput = {
  /** Human-readable description of what this output represents */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for this output definition (use nanoid or uuid) */
  id: Scalars['String']['input'];
  /** Key name for this output - must match the key in the outputs object returned by the code */
  key: Scalars['String']['input'];
  /** If true, the code MUST return this output or execution will fail */
  required: Scalars['Boolean']['input'];
  /** Data type of the output value: STRING, NUMBER, BOOLEAN, DATE, STRINGS_ARRAY, NUMBERS_ARRAY, or JSON */
  valueType: DataPointValueType;
};

export type CodeBlockPayload = Payload & {
  __typename?: 'CodeBlockPayload';
  code: Scalars['String']['output'];
  codeBlock: CodeBlock;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type CodeBlocksPayload = Payload & {
  __typename?: 'CodeBlocksPayload';
  code: Scalars['String']['output'];
  codeBlocks: Array<CodeBlock>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type CollectionContext = {
  __typename?: 'CollectionContext';
  action?: Maybe<CollectionContextItem>;
  stakeholder?: Maybe<Stakeholder>;
  step?: Maybe<CollectionContextItem>;
  track?: Maybe<CollectionContextItem>;
  uses?: Maybe<Array<UsesContextItem>>;
};

export type CollectionContextItem = {
  __typename?: 'CollectionContextItem';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Condition = {
  __typename?: 'Condition';
  id: Scalars['ID']['output'];
  operand?: Maybe<Operand>;
  operator?: Maybe<ConditionOperator>;
  reference?: Maybe<Scalars['String']['output']>;
  reference_key?: Maybe<Scalars['String']['output']>;
  status: ConfigurationStatus;
};

export type ConditionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  operand?: InputMaybe<OperandInput>;
  operator: ConditionOperator;
  reference: Scalars['String']['input'];
};

export enum ConditionOperandType {
  Boolean = 'BOOLEAN',
  DataPoint = 'DATA_POINT',
  DataSource = 'DATA_SOURCE',
  Number = 'NUMBER',
  NumbersArray = 'NUMBERS_ARRAY',
  String = 'STRING',
  StringsArray = 'STRINGS_ARRAY'
}

export enum ConditionOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  HasFileUploaded = 'HAS_FILE_UPLOADED',
  HasNoFileUploaded = 'HAS_NO_FILE_UPLOADED',
  IsAnyOf = 'IS_ANY_OF',
  IsEmpty = 'IS_EMPTY',
  IsEqualTo = 'IS_EQUAL_TO',
  IsGreaterThan = 'IS_GREATER_THAN',
  IsGreaterThanOrEqualTo = 'IS_GREATER_THAN_OR_EQUAL_TO',
  IsInRange = 'IS_IN_RANGE',
  IsLessThan = 'IS_LESS_THAN',
  IsLessThanOrEqualTo = 'IS_LESS_THAN_OR_EQUAL_TO',
  IsLessThanXDaysAgo = 'IS_LESS_THAN_X_DAYS_AGO',
  IsMoreThanXDaysAgo = 'IS_MORE_THAN_X_DAYS_AGO',
  IsNoneOf = 'IS_NONE_OF',
  IsNotEmpty = 'IS_NOT_EMPTY',
  IsNotEqualTo = 'IS_NOT_EQUAL_TO',
  IsNotTrue = 'IS_NOT_TRUE',
  IsToday = 'IS_TODAY',
  IsTrue = 'IS_TRUE'
}

export type ConfigurationStatus = {
  __typename?: 'ConfigurationStatus';
  errors: Array<Scalars['String']['output']>;
  status: Status;
};

export type ConfigureAhpLinkInput = {
  ahp_link: AhpLinkInput;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigureExtensionInput = {
  extension_key: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  properties: Array<ExtensionPropertyInput>;
};

export type ConfigureExtensionPayload = Payload & {
  __typename?: 'ConfigureExtensionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  extension: ExtensionConfiguration;
  success: Scalars['Boolean']['output'];
};

export type ConnectStepsInput = {
  destination_connector_id: TransitionConnectorId;
  destination_step_id: Scalars['String']['input'];
  origin_connector_id: TransitionConnectorId;
  origin_step_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type ConnectStepsPayload = Payload & {
  __typename?: 'ConnectStepsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  origin_step: Step;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export type Constant = {
  __typename?: 'Constant';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  obfuscated: Scalars['Boolean']['output'];
  readonly?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type ConstantInput = {
  constant_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type ConstantPayload = Payload & {
  __typename?: 'ConstantPayload';
  code: Scalars['String']['output'];
  constant?: Maybe<Constant>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type ConstantsPayload = Payload & {
  __typename?: 'ConstantsPayload';
  code: Scalars['String']['output'];
  constants: Array<Constant>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type Constraint = {
  __typename?: 'Constraint';
  field: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateCodeBlockInput = {
  care_flow_definition_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDecisionTableInput = {
  allowMultipleOutcomes?: InputMaybe<Scalars['Boolean']['input']>;
  care_flow_definition_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDynamicVariableInput = {
  dynamic_variable?: InputMaybe<DynamicVariableInput>;
  pathway_id: Scalars['String']['input'];
};

export type CreateDynamicVariablePayload = Payload & {
  __typename?: 'CreateDynamicVariablePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type CreateFormInput = {
  careflow_definition_id?: InputMaybe<Scalars['String']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFormPayload = Payload & {
  __typename?: 'CreateFormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type CreateMessagePayload = Payload & {
  __typename?: 'CreateMessagePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  message: Message;
  success: Scalars['Boolean']['output'];
};

export type CreatePathwayCaseInput = {
  pathway_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreatePathwayCasePayload = Payload & {
  __typename?: 'CreatePathwayCasePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_case: PathwayCaseSummary;
  success: Scalars['Boolean']['output'];
};

export type CreatePathwayInput = {
  title: Scalars['String']['input'];
};

export type CreatePathwayPayload = Payload & {
  __typename?: 'CreatePathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type CreateRuleInput = {
  boolean_operator: BooleanOperator;
  conditions: Array<ConditionInput>;
  type?: InputMaybe<RuleType>;
};

export type CreateTransitionInput = {
  destination: TransitionNodeInput;
  origin: TransitionNodeInput;
  track_id: Scalars['String']['input'];
};

export type CreateTransitionPayload = Payload & {
  __typename?: 'CreateTransitionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export type CreateTriggerInput = {
  rule?: InputMaybe<CreateRuleInput>;
  track_id: Scalars['String']['input'];
  trigger: TriggerInput;
};

export type CreateTriggerPayload = Payload & {
  __typename?: 'CreateTriggerPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger: Trigger;
};

export type CreatedByGraphQlType = {
  __typename?: 'CreatedByGraphQLType';
  at: Scalars['String']['output'];
  by: Scalars['String']['output'];
};

export type CustomAction = {
  __typename?: 'CustomAction';
  category: Scalars['String']['output'];
  created: AuditTrail;
  fields: Array<CustomActionField>;
  id: Scalars['ID']['output'];
  last_updated?: Maybe<AuditTrail>;
  name: Scalars['String']['output'];
  type: ActionType;
};

export type CustomActionField = {
  __typename?: 'CustomActionField';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<CustomActionFieldOption>>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  type: CustomActionFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomActionFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<CustomActionFieldOptionInput>>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  type: CustomActionFieldType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomActionFieldOption = {
  __typename?: 'CustomActionFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomActionFieldOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum CustomActionFieldType {
  Select = 'SELECT',
  Text = 'TEXT'
}

export type CustomActionInput = {
  category: Scalars['String']['input'];
  fields: Array<CustomActionFieldInput>;
  name: Scalars['String']['input'];
  type: ActionType;
};

export type DataCatalogCollectionContextsInput = {
  data_point_definition_id: Scalars['String']['input'];
  pathway_definition_id: Scalars['String']['input'];
};

export type DataCatalogCollectionContextsPayload = Payload & {
  __typename?: 'DataCatalogCollectionContextsPayload';
  code: Scalars['String']['output'];
  collection_contexts: Array<CollectionContext>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DataCatalogInput = {
  pathway_definition_id: Scalars['String']['input'];
};

export type DataCatalogItem = {
  __typename?: 'DataCatalogItem';
  category: DataPointSourceType;
  /** Additonal context on data point */
  data_point_metadata?: Maybe<Array<DataPointMetaDataItem>>;
  /** Flag that is true when the data value is defined in ICD Classificaton Standard */
  icd_classification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jsonPath?: Maybe<Scalars['String']['output']>;
  /** For json valueType we can use this field to specify schema of json object */
  jsonSchemaSource?: Maybe<JsonSchemaSourceGraphqlType>;
  key: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** Personally identifiable information */
  pii?: Maybe<Scalars['Boolean']['output']>;
  possibleValues?: Maybe<Array<DataPointPossibleValue>>;
  range?: Maybe<Range>;
  source_definition_id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  valueType: DataPointValueType;
};

export type DataCatalogJsonPayload = Payload & {
  __typename?: 'DataCatalogJsonPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  json: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DataCatalogPayload = Payload & {
  __typename?: 'DataCatalogPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  items: Array<DataCatalogItem>;
  success: Scalars['Boolean']['output'];
};

export type DataCatalogUpdatedPayload = {
  __typename?: 'DataCatalogUpdatedPayload';
  affected_definition_ids?: Maybe<Array<Scalars['String']['output']>>;
  change_type: Scalars['String']['output'];
  pathway_definition_id: Scalars['String']['output'];
};

export type DataPointAwaitedTimeout = {
  __typename?: 'DataPointAwaitedTimeout';
  unit: DelayUnitType;
  value: Scalars['Float']['output'];
};

export type DataPointAwaitedTimerConfig = TimerConfig & {
  __typename?: 'DataPointAwaitedTimerConfig';
  data_point_definition_id: Scalars['String']['output'];
  data_point_key: Scalars['String']['output'];
  description: Scalars['String']['output'];
  timeout: DataPointAwaitedTimeout;
  type: TimerType;
};

export type DataPointCollectedActivationReference = TriggerActivationReference & {
  __typename?: 'DataPointCollectedActivationReference';
  data_point_definition_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerActivationReferenceType>;
};

export type DataPointCollectedActivationReferenceInput = {
  data_point_definition_id: Scalars['String']['input'];
  type: TriggerActivationReferenceType;
};

export type DataPointCollectedTriggerSettings = TriggerSettings & {
  __typename?: 'DataPointCollectedTriggerSettings';
  data_point_definition_id?: Maybe<Scalars['ID']['output']>;
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerType>;
};

export type DataPointDefinition = {
  __typename?: 'DataPointDefinition';
  category: DataPointSourceType;
  /** Additonal context on data point */
  data_point_metadata?: Maybe<Array<DataPointMetaDataItem>>;
  /** Flag that is true when the data value is defined in ICD Classificaton Standard */
  icd_classification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jsonPath?: Maybe<Scalars['String']['output']>;
  /** For json valueType we can use this field to specify schema of json object */
  jsonSchemaSource?: Maybe<JsonSchemaSourceGraphqlType>;
  key: Scalars['String']['output'];
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** Personally identifiable information */
  pii?: Maybe<Scalars['Boolean']['output']>;
  possibleValues?: Maybe<Array<DataPointPossibleValue>>;
  range?: Maybe<Range>;
  source_definition_id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  valueType: DataPointValueType;
};

export type DataPointDefinitionInput = {
  jsonPath?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  possibleValues?: InputMaybe<Array<DataPointPossibleValueInput>>;
  range?: InputMaybe<RangeInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
  valueType: DataPointValueType;
};

export type DataPointDefinitionPayload = Payload & {
  __typename?: 'DataPointDefinitionPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DataPointDefinitionsInput = {
  categories?: InputMaybe<Array<DataPointSourceType>>;
  pathway_definition_id: Scalars['String']['input'];
  valueTypes?: InputMaybe<Array<DataPointValueType>>;
};

export type DataPointDefinitionsPayload = Payload & {
  __typename?: 'DataPointDefinitionsPayload';
  code: Scalars['String']['output'];
  data_point_definitions: Array<DataPointDefinition>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DataPointMapping = {
  __typename?: 'DataPointMapping';
  data_point_definition_id: Scalars['String']['output'];
  incoming_data_point_key: Scalars['String']['output'];
};

export type DataPointMetaDataInputType = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataPointMetaDataItem = {
  __typename?: 'DataPointMetaDataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DataPointNotCollectedTriggerSettings = TriggerSettings & {
  __typename?: 'DataPointNotCollectedTriggerSettings';
  data_point_definition_id?: Maybe<Scalars['ID']['output']>;
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerType>;
};

export type DataPointPossibleValue = {
  __typename?: 'DataPointPossibleValue';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type DataPointPossibleValueInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum DataPointPropertyType {
  CollectionDate = 'COLLECTION_DATE',
  Label = 'LABEL',
  Value = 'VALUE'
}

export type DataPointReferenceTimerConfig = TimerConfig & {
  __typename?: 'DataPointReferenceTimerConfig';
  data_point_definition_id: Scalars['String']['output'];
  data_point_key: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hour?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Float']['output']>;
  offsetDirection?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  type: TimerType;
  unit?: Maybe<Scalars['String']['output']>;
  usePatientTimezone?: Maybe<Scalars['Boolean']['output']>;
};

export enum DataPointSourceType {
  Agent = 'AGENT',
  ApiCall = 'API_CALL',
  ApiCallStatus = 'API_CALL_STATUS',
  Calculation = 'CALCULATION',
  Code = 'CODE',
  DataPoint = 'DATA_POINT',
  Decision = 'DECISION',
  ExtensionAction = 'EXTENSION_ACTION',
  ExtensionActionResolution = 'EXTENSION_ACTION_RESOLUTION',
  ExtensionWebhook = 'EXTENSION_WEBHOOK',
  Form = 'FORM',
  Logic = 'LOGIC',
  Pathway = 'PATHWAY',
  PatientIdentifier = 'PATIENT_IDENTIFIER',
  PatientProfile = 'PATIENT_PROFILE',
  Step = 'STEP',
  System = 'SYSTEM',
  Track = 'TRACK'
}

export enum DataPointValueType {
  Attachment = 'ATTACHMENT',
  AttachmentsArray = 'ATTACHMENTS_ARRAY',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Json = 'JSON',
  Number = 'NUMBER',
  NumbersArray = 'NUMBERS_ARRAY',
  String = 'STRING',
  StringsArray = 'STRINGS_ARRAY',
  Telephone = 'TELEPHONE'
}

export type DateConfig = {
  __typename?: 'DateConfig';
  allowed_dates?: Maybe<AllowedDatesOptions>;
  include_date_of_response?: Maybe<Scalars['Boolean']['output']>;
};

export type DateConfigInput = {
  /** The type of allowed dates for the question. One of: PAST, FUTURE, ALL. */
  allowed_dates?: InputMaybe<AllowedDatesOptions>;
  /** Enable this flag to allow the user to pick the current date when filling out the form. */
  include_date_of_response?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateField = ExtensionActionField & {
  __typename?: 'DateField';
  delay?: Maybe<Delay>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
  /** Date in ISO 8601 format */
  value?: Maybe<Scalars['String']['output']>;
};

export type DateQuestionConfigInput = {
  /** The new date specific configuration for the question. */
  date: DateConfigInput;
};

export type DecisionOutputsInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
};

export type DecisionOutputsPayload = Payload & {
  __typename?: 'DecisionOutputsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  outputs: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DecisionRule = {
  __typename?: 'DecisionRule';
  /** Conditions object with typed values */
  conditions: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  /** True for catch-all rules that match any input */
  isCatchAll?: Maybe<Scalars['Boolean']['output']>;
  /** Outputs object with typed values */
  outputs: Scalars['JSON']['output'];
  priority: Scalars['Float']['output'];
};

export type DecisionRuleInput = {
  /** Conditions object with typed values */
  conditions: Scalars['JSON']['input'];
  id: Scalars['String']['input'];
  /** True for catch-all rules that match any input */
  isCatchAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Outputs object with typed values */
  outputs: Scalars['JSON']['input'];
  priority: Scalars['Float']['input'];
};

export type DecisionTable = {
  __typename?: 'DecisionTable';
  /** If true, evaluation continues through all rules instead of stopping at first match */
  allowMultipleOutcomes?: Maybe<Scalars['Boolean']['output']>;
  care_flow_definition_id: Scalars['String']['output'];
  definition_id: Scalars['ID']['output'];
  inputColumns: Array<InputColumn>;
  outputColumns: Array<OutputColumn>;
  rows: Array<DecisionRule>;
  title: Scalars['String']['output'];
};

export type DecisionTablePayload = Payload & {
  __typename?: 'DecisionTablePayload';
  code: Scalars['String']['output'];
  decisionTable: DecisionTable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DecisionTablesPayload = Payload & {
  __typename?: 'DecisionTablesPayload';
  code: Scalars['String']['output'];
  decisionTables: Array<DecisionTable>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type Delay = {
  __typename?: 'Delay';
  amount: Scalars['Int']['output'];
  unit: DelayUnitType;
};

export type DelayInput = {
  amount: Scalars['Int']['input'];
  unit: DelayUnitType;
};

export type DelayTimerConfig = TimerConfig & {
  __typename?: 'DelayTimerConfig';
  delay: TimerDelay;
  description: Scalars['String']['output'];
  type: TimerType;
};

export enum DelayUnitType {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type DeleteAgentInput = {
  agent_id: Scalars['String']['input'];
};

export type DeleteDecisionTableInput = {
  decision_table_id: Scalars['String']['input'];
};

export type DeleteDecisionTablePayload = Payload & {
  __typename?: 'DeleteDecisionTablePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DeleteLogicInput = {
  logic_id: Scalars['String']['input'];
};

export type DeleteLogicPayload = Payload & {
  __typename?: 'DeleteLogicPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DeletePathwayCaseInput = {
  pathway_case_id: Scalars['String']['input'];
};

export type DeletePathwayCasePayload = Payload & {
  __typename?: 'DeletePathwayCasePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DeletePrivateFormInput = {
  /** The ID of the private form to delete. */
  form_id: Scalars['String']['input'];
};

export type DeleteSharedFormInput = {
  /** The ID of the shared form to delete. */
  form_id: Scalars['String']['input'];
};

export type DeleteTimerInput = {
  timer_id: Scalars['String']['input'];
};

export type DerivedDataPointDefinitionInput = {
  jsonPath?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  source_id: Scalars['String']['input'];
  valueType: DataPointValueType;
};

export type DesignatedTriggerTimer = TriggerSettings & {
  __typename?: 'DesignatedTriggerTimer';
  delay?: Maybe<Delay>;
  id: Scalars['ID']['output'];
  reference?: Maybe<TriggerActivationReference>;
  rule?: Maybe<Rule>;
  type?: Maybe<TriggerType>;
};

export type DesignatedTriggerTimerInput = {
  delay?: InputMaybe<DelayInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<TriggerActivationReferenceInput>;
};

export type DestinationInput = {
  connector_id?: InputMaybe<Scalars['String']['input']>;
  node_id: Scalars['String']['input'];
  type: TransitionNodeType;
};

/**
 *
 * We use event-sourcing in our app. In event-sourcing event are used to record state changes.
 * Event is a record of some state change that is a result of executing a command.
 * Events are always named with a verb in past tense, is something that already happened. (StepCreated, StepUpdated …)
 * Event is a record of state change with all the information that is necessary to replay it.
 * Events are immutable and stored into event store which is append only.
 * By being immutable and sequentially stored makes them suitable for audit log and history.
 * You must never delete an event.
 *
 */
export type DomainEvent = {
  __typename?: 'DomainEvent';
  aggregate_class: Scalars['String']['output'];
  aggregate_id: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: DomainEventMetadata;
  stream: Scalars['String']['output'];
};

export type DomainEventMetadata = {
  __typename?: 'DomainEventMetadata';
  caused_by?: Maybe<Scalars['String']['output']>;
  saga_id?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type DomainEventsPayload = Payload & {
  __typename?: 'DomainEventsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  events: Array<DomainEvent>;
  success: Scalars['Boolean']['output'];
};

export type DueDate = {
  __typename?: 'DueDate';
  delay?: Maybe<Delay>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type DueDateInput = {
  delay?: InputMaybe<DelayInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateCareflowInput = {
  careflow_id: Scalars['String']['input'];
};

export type DuplicateCareflowPayload = Payload & {
  __typename?: 'DuplicateCareflowPayload';
  careflow_id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DuplicateFormInput = {
  form_id: Scalars['String']['input'];
  replace_all_instances?: InputMaybe<Scalars['Boolean']['input']>;
  target_careflow_id: Scalars['String']['input'];
};

export type DuplicateFormPayload = Payload & {
  __typename?: 'DuplicateFormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  replaceDataPointReferencesErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DuplicateQuestionInput = {
  form_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
};

export type DuplicateQuestionPayload = Payload & {
  __typename?: 'DuplicateQuestionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type DuplicateStepInput = {
  step_id: Scalars['String']['input'];
};

export type DuplicateStepPayload = Payload & {
  __typename?: 'DuplicateStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type DurationGraphQlObjectType = {
  __typename?: 'DurationGraphQlObjectType';
  days?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
  months?: Maybe<Scalars['Float']['output']>;
  weeks?: Maybe<Scalars['Float']['output']>;
  years?: Maybe<Scalars['Float']['output']>;
};

export type DynamicVariable = {
  __typename?: 'DynamicVariable';
  data_point_definition?: Maybe<DynamicVariableReference>;
  data_point_definition_id?: Maybe<Scalars['String']['output']>;
  data_point_property?: Maybe<DataPointPropertyType>;
  fallback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_actionable_property: Scalars['Boolean']['output'];
  is_hyperlink?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  status: ConfigurationStatus;
  transformations?: Maybe<Array<Transformation>>;
  usages?: Maybe<Array<DynamicVariableUsage>>;
};

export type DynamicVariableInput = {
  data_point_definition_id: Scalars['String']['input'];
  data_point_property?: InputMaybe<DataPointPropertyType>;
  fallback?: InputMaybe<Scalars['String']['input']>;
  is_hyperlink?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  transformations?: InputMaybe<Array<TransformationInput>>;
};

export type DynamicVariablePayload = Payload & {
  __typename?: 'DynamicVariablePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type DynamicVariableReference = {
  __typename?: 'DynamicVariableReference';
  category?: Maybe<DataPointSourceType>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  valueType: Scalars['String']['output'];
};

export type DynamicVariableUsage = {
  __typename?: 'DynamicVariableUsage';
  builder_path?: Maybe<Scalars['String']['output']>;
  component_collection: Scalars['String']['output'];
  definition_id: Scalars['String']['output'];
  display_label: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  track_id?: Maybe<Scalars['String']['output']>;
};

export type DynamicVariablesPayload = Payload & {
  __typename?: 'DynamicVariablesPayload';
  code: Scalars['String']['output'];
  dynamic_variables: Array<DynamicVariable>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

/** Input for editing an existing code block component */
export type EditCodeBlockInput = {
  /** LangGraph thread ID for AI-assisted code editing conversations. Set to persist agent conversation history. */
  agentThreadId?: InputMaybe<Scalars['String']['input']>;
  /** JavaScript code that defines a run(input) function. The function receives input data points and must return { outputs: {...}, result: "RESULT_VALUE" }. Available globals: _ (lodash), dateFns, z (zod), env (constants), console. */
  code: Scalars['String']['input'];
  /** The unique identifier of the code block to edit */
  code_block_id: Scalars['String']['input'];
  /** Input data points available to the code via the input object. Each input references an existing data point and optionally provides an alias. */
  inputDefinitions: Array<CodeBlockInputInput>;
  /** Output data points that the code will produce. Each output becomes a new data point in the care flow. */
  outputDefinitions: Array<CodeBlockOutputInput>;
  /** Possible result values the code can return. Each result value creates a possible transition path. The code must return { result: "VALUE" } where VALUE is one of these strings. */
  resultValues: Array<Scalars['String']['input']>;
  /** Display name for the code block */
  title: Scalars['String']['input'];
};

export type EditDecisionTableInput = {
  allowMultipleOutcomes?: InputMaybe<Scalars['Boolean']['input']>;
  decision_table_id: Scalars['String']['input'];
  inputColumns: Array<InputColumnInput>;
  outputColumns: Array<OutputColumnInput>;
  rows: Array<DecisionRuleInput>;
  title: Scalars['String']['input'];
};

export type EditRuleInput = {
  boolean_operator: BooleanOperator;
  conditions: Array<ConditionInput>;
  type?: InputMaybe<RuleType>;
};

export type EditRulePayload = Payload & {
  __typename?: 'EditRulePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type EditRuleRequestInput = {
  rule: EditRuleInput;
  rule_id: Scalars['String']['input'];
};

export type EditTriggerInput = {
  rule?: InputMaybe<EditRuleInput>;
  settings: TriggerSettingsInput;
  timers?: InputMaybe<Array<DesignatedTriggerTimerInput>>;
  trigger_id: Scalars['String']['input'];
};

export type EditTriggerPayload = Payload & {
  __typename?: 'EditTriggerPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger: Trigger;
};

export type Element = {
  __typename?: 'Element';
  activity_type?: Maybe<ActionType>;
  context: PathwayContext;
  definition_id?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<ActivityLabel>;
  name: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['ID']['output']>;
  stakeholders: Array<ElementStakeholder>;
  start_date: Scalars['String']['output'];
  status: ElementStatus;
  type: ElementType;
};

export type ElementStakeholder = {
  __typename?: 'ElementStakeholder';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ElementStatus {
  Active = 'ACTIVE',
  Discarded = 'DISCARDED',
  Done = 'DONE',
  Postponed = 'POSTPONED',
  Scheduled = 'SCHEDULED',
  Stopped = 'STOPPED'
}

export enum ElementType {
  Action = 'ACTION',
  Agent = 'AGENT',
  Pathway = 'PATHWAY',
  Step = 'STEP',
  Track = 'TRACK',
  Trigger = 'TRIGGER'
}

export type ElementsPayload = Payload & {
  __typename?: 'ElementsPayload';
  code: Scalars['String']['output'];
  elements: Array<Element>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type EmptyPayload = Payload & {
  __typename?: 'EmptyPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type EmrBodyInput = {
  html: Scalars['String']['input'];
  plaintext: Scalars['String']['input'];
  slate: Scalars['String']['input'];
};

/**
 *
 *   EMR Reports are templates that use data points to create EMR report instances.
 *   EMR Reports that use 0 data points are called static EMR reports.
 *
 *   A EMR report instance is created by filling a EMR report template with data point instances
 *
 *   An illustrative example:
 *   - EMR report:
 *     - report template: "Hello |patient_first_name|"
 *     - data points:
 *       - patient_first_name is a data point of type patient with property first name
 *   If a patient has a first name Ben then the report instance would be "Hello Ben"
 *
 *   Explanation of EMR report field:
 *    - body: The content that goes in the report
 *
 */
export type EmrReport = {
  __typename?: 'EmrReport';
  body?: Maybe<Scalars['String']['output']>;
  html_body?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type EmrReportMetadataField = {
  __typename?: 'EmrReportMetadataField';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EmrReportPayload = Payload & {
  __typename?: 'EmrReportPayload';
  code: Scalars['String']['output'];
  emr_report: EmrReport;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type EndTrackAfterStepInput = {
  destination_connector_id: TransitionConnectorId;
  origin_connector_id: TransitionConnectorId;
  origin_step_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type EndTrackAfterStepPayload = Payload & {
  __typename?: 'EndTrackAfterStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  origin_step: Step;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export type EnrollmentTrigger = {
  __typename?: 'EnrollmentTrigger';
  action_data?: Maybe<ActionData>;
  action_type?: Maybe<Scalars['String']['output']>;
  careflow_definition_id: Scalars['String']['output'];
  conditions?: Maybe<Array<EnrollmentTriggerConditions>>;
  created: Audit;
  data_point_mapping: Array<DataPointMapping>;
  data_point_mapping_strategy: Scalars['String']['output'];
  documentation: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  incoming_source_id: Scalars['String']['output'];
  incoming_source_type: Scalars['String']['output'];
  last_updated: Audit;
  name: Scalars['String']['output'];
  organization_slug: Scalars['String']['output'];
  patient_identifier_system?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['String']['output'];
};

export type EnrollmentTriggerConditions = {
  __typename?: 'EnrollmentTriggerConditions';
  all?: Maybe<Array<Constraint>>;
  any?: Maybe<Array<Constraint>>;
  none?: Maybe<Array<Constraint>>;
};

export type EnrollmentTriggerPayload = {
  __typename?: 'EnrollmentTriggerPayload';
  code: Scalars['String']['output'];
  enrollmentTriggers: Array<EnrollmentTrigger>;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  stack: Scalars['String']['output'];
};

export type ErrorObject = {
  __typename?: 'ErrorObject';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type EvaluateFormRulesInput = {
  answers: Array<AnswerInput>;
  form_id: Scalars['String']['input'];
};

export type EvaluateFormRulesPayload = {
  __typename?: 'EvaluateFormRulesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  results: Array<QuestionRuleResult>;
  success: Scalars['Boolean']['output'];
};

export type EvaluatedRule = {
  __typename?: 'EvaluatedRule';
  conditions: Array<EvaluatedRuleCondition>;
  satisfied: Scalars['Boolean']['output'];
};

export type EvaluatedRuleCondition = {
  __typename?: 'EvaluatedRuleCondition';
  id: Scalars['String']['output'];
  operand?: Maybe<Operand>;
  operator: ConditionOperator;
  reference: EvaluatedRuleReference;
  satisfied: Scalars['Boolean']['output'];
};

export type EvaluatedRulePayload = Payload & {
  __typename?: 'EvaluatedRulePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  evaluatedRule: EvaluatedRule;
  success: Scalars['Boolean']['output'];
};

export type EvaluatedRuleReference = {
  __typename?: 'EvaluatedRuleReference';
  data_point_definition_id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type EventBasedTriggerSettings = TriggerSettings & {
  __typename?: 'EventBasedTriggerSettings';
  event_config?: Maybe<TriggerEventConfig>;
  event_suggestions?: Maybe<Array<TriggerEventSuggestion>>;
  rule?: Maybe<Rule>;
  type?: Maybe<TriggerType>;
};

export type EventBasedTriggerSettingsInput = {
  description: Scalars['String']['input'];
  expression: Scalars['String']['input'];
  shelly_thread_id: Scalars['String']['input'];
  source: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type EventsInput = {
  event_type?: InputMaybe<Scalars['String']['input']>;
  saga_id?: InputMaybe<Scalars['String']['input']>;
  stream?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ExclusiveOptionConfig = {
  __typename?: 'ExclusiveOptionConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  option_id?: Maybe<Scalars['String']['output']>;
};

export type ExclusiveOptionConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExecuteTestApiCallInput = {
  api_call_id: Scalars['String']['input'];
  pathway_definition_id: Scalars['String']['input'];
  variable_inputs: Array<GraphqlTestApiCallVariableDataPoint>;
};

export type ExecuteTestApiCallPayload = Payload & {
  __typename?: 'ExecuteTestApiCallPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  mappings: Array<GraphqlTestApiCallMapping>;
  metadata: GraphqlTestApiCallMetadata;
  request: GraphqlTestApiCallRequest;
  response: GraphqlTestApiCallResponse;
  success: Scalars['Boolean']['output'];
};

export type ExistingWebhookInput = {
  enabled: Scalars['Boolean']['input'];
  endpoint: Scalars['String']['input'];
  endpoint_test?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Array<WebhookHeaderInput>>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subscribed_events?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Expiration = {
  __typename?: 'Expiration';
  delay?: Maybe<Delay>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type ExpirationInput = {
  delay?: InputMaybe<DelayInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type ExportPathwayEventsCount = {
  __typename?: 'ExportPathwayEventsCount';
  event_count: Scalars['Float']['output'];
  exported_count: Scalars['Float']['output'];
};

export type ExportPathwayInput = {
  pathway_id: Scalars['String']['input'];
};

export type ExportPathwayStatus = {
  __typename?: 'ExportPathwayStatus';
  content?: Maybe<Scalars['String']['output']>;
  count?: Maybe<ExportPathwayEventsCount>;
  message: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Extension = {
  __typename?: 'Extension';
  actions: Array<ExtensionActionBlueprint>;
  /** Key and description of the webhooks defined in the extension repository */
  available_webhooks?: Maybe<Array<AvailableWebhook>>;
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  settings?: Maybe<ExtensionSettings>;
  title: Scalars['String']['output'];
  webhooks: Array<ExtensionWebhook>;
};


export type ExtensionWebhooksArgs = {
  pathway_id: Scalars['String']['input'];
};

export type ExtensionAction = Action & {
  __typename?: 'ExtensionAction';
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  error_handling_settings?: Maybe<ExtensionActionErrorHandling>;
  expiration?: Maybe<Expiration>;
  extension_action_key?: Maybe<Scalars['ID']['output']>;
  extension_data_point_mappings?: Maybe<Array<ExtensionDataPointMapping>>;
  extension_data_points?: Maybe<Array<ExtensionDataPointDefinition>>;
  extension_fields: Array<ExtensionActionField>;
  extension_key?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  stakeholders_select_settings?: Maybe<StakeholdersSelectSettings>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type ExtensionActionBlueprint = {
  __typename?: 'ExtensionActionBlueprint';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<ExtensionActionField>;
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  previewable?: Maybe<Scalars['Boolean']['output']>;
  stakeholders_select_settings?: Maybe<StakeholdersSelectSettings>;
  supports_automated_retries?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

/** Error behavior for extension actions */
export enum ExtensionActionErrorBehavior {
  Continue = 'CONTINUE',
  Stop = 'STOP'
}

export type ExtensionActionErrorHandling = {
  __typename?: 'ExtensionActionErrorHandling';
  automated_retries_enabled?: Maybe<Scalars['Boolean']['output']>;
  error_behavior?: Maybe<ExtensionActionErrorBehavior>;
  initial_retry_delay_ms?: Maybe<Scalars['Int']['output']>;
  max_retry_attempts?: Maybe<Scalars['Int']['output']>;
  max_retry_delay_ms?: Maybe<Scalars['Int']['output']>;
};

export type ExtensionActionErrorHandlingInput = {
  automated_retries_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  error_behavior?: InputMaybe<ExtensionActionErrorBehavior>;
  initial_retry_delay_ms?: InputMaybe<Scalars['Float']['input']>;
  max_retry_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_retry_delay_ms?: InputMaybe<Scalars['Float']['input']>;
};

export type ExtensionActionField = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
};

export type ExtensionActionFieldInput = {
  id: Scalars['String']['input'];
  options?: InputMaybe<ExtensionOptionsInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ExtensionActionFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Html = 'HTML',
  Json = 'JSON',
  Numeric = 'NUMERIC',
  NumericArray = 'NUMERIC_ARRAY',
  String = 'STRING',
  StringArray = 'STRING_ARRAY',
  Text = 'TEXT'
}

export type ExtensionActionInput = {
  extension_action_key: Scalars['String']['input'];
  extension_key: Scalars['String']['input'];
};

export type ExtensionActionPreviewEvent = {
  __typename?: 'ExtensionActionPreviewEvent';
  correlation_id: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event_type: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type ExtensionActivityField = {
  __typename?: 'ExtensionActivityField';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  type: ExtensionActionFieldType;
  value: Scalars['String']['output'];
};

export type ExtensionActivityRecord = {
  __typename?: 'ExtensionActivityRecord';
  activity_id: Scalars['String']['output'];
  data_points: Array<ExtensionDataPoint>;
  date: Scalars['String']['output'];
  fields: Array<ExtensionActivityField>;
  id: Scalars['ID']['output'];
  pathway_id: Scalars['String']['output'];
  plugin_action_key: Scalars['String']['output'];
  plugin_key: Scalars['String']['output'];
  settings?: Maybe<Array<PluginActionSettingsProperty>>;
};

export type ExtensionActivityRecordPayload = Payload & {
  __typename?: 'ExtensionActivityRecordPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  record: ExtensionActivityRecord;
  success: Scalars['Boolean']['output'];
};

export type ExtensionConfiguration = {
  __typename?: 'ExtensionConfiguration';
  extension_key: Scalars['String']['output'];
  properties?: Maybe<Array<ExtensionProperty>>;
};

export type ExtensionConfigurationsPayload = Payload & {
  __typename?: 'ExtensionConfigurationsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  extensions?: Maybe<Array<ExtensionConfiguration>>;
  success: Scalars['Boolean']['output'];
};

export type ExtensionConstantInput = {
  label: Scalars['String']['input'];
  obfuscated: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type ExtensionDataPoint = {
  __typename?: 'ExtensionDataPoint';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueType: Scalars['String']['output'];
};

export type ExtensionDataPointDefinition = {
  __typename?: 'ExtensionDataPointDefinition';
  /** For data points derived from objects or arrays, we use this prop to specify the path to the scalar value. */
  jsonPath?: Maybe<Scalars['String']['output']>;
  /** Complex data points are stored in json format but require a schema to validate them. This prop specifies the source of the schema. */
  jsonSchemaSource?: Maybe<JsonSchemaSourceGraphqlType>;
  key: Scalars['String']['output'];
  valueType: DataPointValueType;
};

export type ExtensionDataPointMapping = {
  __typename?: 'ExtensionDataPointMapping';
  data_point_definition_id?: Maybe<Scalars['String']['output']>;
  extension_data_point_key?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ExtensionDateFieldDelayInput = {
  amount: Scalars['Int']['input'];
  unit: DelayUnitType;
};

export type ExtensionDropdownOption = {
  __typename?: 'ExtensionDropdownOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExtensionFieldInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ExtensionOptionsInput = {
  delay?: InputMaybe<ExtensionDateFieldDelayInput>;
  slate?: InputMaybe<Scalars['String']['input']>;
};

export type ExtensionProperty = {
  __typename?: 'ExtensionProperty';
  constant: Constant;
  key: Scalars['String']['output'];
};

export type ExtensionPropertyInput = {
  constant: ExtensionConstantInput;
  key: Scalars['String']['input'];
};

export type ExtensionResourceId = {
  __typename?: 'ExtensionResourceId';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExtensionResourceIdInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ExtensionResourceUpdatedTimerConfig = TimerConfig & {
  __typename?: 'ExtensionResourceUpdatedTimerConfig';
  action_definition_id: Scalars['String']['output'];
  action_key: Scalars['String']['output'];
  description: Scalars['String']['output'];
  extension_key: Scalars['String']['output'];
  resource_id: ExtensionResourceId;
  timer_key: Scalars['String']['output'];
  type: TimerType;
};

export type ExtensionSettings = {
  __typename?: 'ExtensionSettings';
  description: Scalars['String']['output'];
  fields: Array<ExtensionSettingsField>;
};

export type ExtensionSettingsField = {
  __typename?: 'ExtensionSettingsField';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  obfuscated: Scalars['Boolean']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type ExtensionWebhook = {
  __typename?: 'ExtensionWebhook';
  data_point_definitions: Array<DataPointDefinition>;
  endpoint_url: Scalars['String']['output'];
  id: Scalars['String']['output'];
  webhook_key: Scalars['String']['output'];
};

export type ExtensionWebhookTriggerSettings = TriggerSettings & {
  __typename?: 'ExtensionWebhookTriggerSettings';
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerType>;
  webhook_id?: Maybe<Scalars['ID']['output']>;
};

export type ExtensionsPayload = Payload & {
  __typename?: 'ExtensionsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  extensions: Array<Extension>;
  success: Scalars['Boolean']['output'];
};

export type FileQuestionConfigInput = {
  /** Comma-separated list of accepted file types (e.g., "image/*,.pdf,.doc"). */
  accepted_file_types?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the file storage destination where files will be stored. */
  file_storage_config_slug?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type FileStorageConfig = {
  __typename?: 'FileStorageConfig';
  bucket_name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FileStorageConfigPayload = Payload & {
  __typename?: 'FileStorageConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  fileStorageConfigs: Array<FileStorageConfig>;
  success: Scalars['Boolean']['output'];
};

export type FileStorageQuestionConfig = {
  __typename?: 'FileStorageQuestionConfig';
  accepted_file_types?: Maybe<Array<Scalars['String']['output']>>;
  file_storage_config_slug?: Maybe<Scalars['String']['output']>;
};

export type FilterSearch = {
  property?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/**
 *
 *   Forms are a set of questions
 *   Example of types of questions:
 *     - Text field (stored as string)
 *     - Multiple choice question (stored as array of answer ids)
 *     - image field (stored as string that is an URL where the image is stored)
 *     - Scale question (stored as a floating point number between 0 and 1)
 *     - ...
 *   Forms are usually filled in by caregivers or patients.
 *   When filled in, forms generate:
 *     - answer data points
 *     - metadata such as submission date, user id of user doing submission
 *
 */
export type Form = {
  __typename?: 'Form';
  created?: Maybe<AuditTrail>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_shared: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<AuditTrail>;
  metadata?: Maybe<FormattedJson>;
  pathways_used_in: Array<Pathway>;
  permissions: Permissions;
  question_ids: Array<Scalars['String']['output']>;
  questions: Array<Question>;
  team_ids: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trademark?: Maybe<Scalars['String']['output']>;
};

export type FormAction = Action & {
  __typename?: 'FormAction';
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  form_display_mode?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type FormDataPointDefinitionsInput = {
  form_definition_id: Scalars['String']['input'];
};

export type FormPayload = Payload & {
  __typename?: 'FormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type FormResponse = {
  __typename?: 'FormResponse';
  answers: Array<Answer>;
};

export type FormResponseInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
};

export type FormResponsePayload = Payload & {
  __typename?: 'FormResponsePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  response: FormResponse;
  success: Scalars['Boolean']['output'];
};

export type FormatDateParameters = {
  __typename?: 'FormatDateParameters';
  format?: Maybe<Scalars['String']['output']>;
};

export type FormatDateTransformation = Transformation & {
  __typename?: 'FormatDateTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<FormatDateParameters>;
  type: TransformationType;
};

export type FormatPhoneNumberParameters = {
  __typename?: 'FormatPhoneNumberParameters';
  format?: Maybe<Scalars['String']['output']>;
};

export type FormatPhoneNumberTransformation = Transformation & {
  __typename?: 'FormatPhoneNumberTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<FormatPhoneNumberParameters>;
  type: TransformationType;
};

export type FormattedJson = {
  __typename?: 'FormattedJson';
  plaintext: Scalars['String']['output'];
  slate: Scalars['String']['output'];
};

export type FormattedJsonInput = {
  plaintext: Scalars['String']['input'];
  slate: Scalars['String']['input'];
};

export type FormattedText = {
  __typename?: 'FormattedText';
  content: TranslatedText;
  format: Scalars['String']['output'];
};

export type FormattedTextInput = {
  content: TranslatedTextInput;
  format: Scalars['String']['input'];
};

export type FormsPayload = Payload & {
  __typename?: 'FormsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  forms: Array<Form>;
  success: Scalars['Boolean']['output'];
};

export type GenerateCareflowSummaryPayload = {
  __typename?: 'GenerateCareflowSummaryPayload';
  code: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  summary_run?: Maybe<SummaryRun>;
};

export type GeneratedClinicalNoteContextField = {
  __typename?: 'GeneratedClinicalNoteContextField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GeneratedClinicalNoteNarrative = {
  __typename?: 'GeneratedClinicalNoteNarrative';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GeneratedClinicalNotePayload = Payload & {
  __typename?: 'GeneratedClinicalNotePayload';
  clinical_note: PreviewClinicalNote;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type GeneratedEmrReportPayload = Payload & {
  __typename?: 'GeneratedEmrReportPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  report: PreviewEmrReport;
  success: Scalars['Boolean']['output'];
};

export type GeneratedMessagePayload = Payload & {
  __typename?: 'GeneratedMessagePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  message: PreviewMessage;
  success: Scalars['Boolean']['output'];
};

export type GraphqlTestApiCallMapping = {
  __typename?: 'GraphqlTestApiCallMapping';
  data_point_definition_id: Scalars['String']['output'];
  response_key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  value_type: Scalars['String']['output'];
};

export type GraphqlTestApiCallMetadata = {
  __typename?: 'GraphqlTestApiCallMetadata';
  response_size: Scalars['Float']['output'];
  response_time: Scalars['Float']['output'];
};

export type GraphqlTestApiCallRequest = {
  __typename?: 'GraphqlTestApiCallRequest';
  body?: Maybe<Scalars['String']['output']>;
  endpoint: Scalars['String']['output'];
  headers: Array<ApiCallHeader>;
  method: Scalars['String']['output'];
};

export type GraphqlTestApiCallResponse = {
  __typename?: 'GraphqlTestApiCallResponse';
  body: Scalars['String']['output'];
  date: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  headers: Scalars['String']['output'];
  status: Scalars['Float']['output'];
};

export type GraphqlTestApiCallVariableDataPoint = {
  data_point_definition_id: Scalars['String']['input'];
  value: Scalars['String']['input'];
  value_type: Scalars['String']['input'];
};

export type HtmlField = ExtensionActionField & {
  __typename?: 'HtmlField';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  slate?: Maybe<Scalars['String']['output']>;
  type: ExtensionActionFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type ImportPathwayEventsCount = {
  __typename?: 'ImportPathwayEventsCount';
  event_count: Scalars['Float']['output'];
  event_id: Scalars['String']['output'];
  imported_count: Scalars['Float']['output'];
};

export type ImportPathwayInput = {
  base64Json: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};

export type ImportPathwayStatus = {
  __typename?: 'ImportPathwayStatus';
  count?: Maybe<ImportPathwayEventsCount>;
  message: Scalars['String']['output'];
};

export type InputColumn = {
  __typename?: 'InputColumn';
  dataPoint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InputColumnInput = {
  dataPoint: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InputValidationAllowed = {
  __typename?: 'InputValidationAllowed';
  letters?: Maybe<Scalars['Boolean']['output']>;
  numbers?: Maybe<Scalars['Boolean']['output']>;
  special?: Maybe<Scalars['Boolean']['output']>;
  whitespace?: Maybe<Scalars['Boolean']['output']>;
};

export type InputValidationConfig = {
  __typename?: 'InputValidationConfig';
  helper_text?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  simpleConfig?: Maybe<InputValidationSimpleConfig>;
};

export type InputValidationConfigInput = {
  helper_text?: InputMaybe<Scalars['String']['input']>;
  mode: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
  simpleConfig?: InputMaybe<SimpleConfigInput>;
};

export type InputValidationQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  input_validation?: InputMaybe<InputValidationConfigInput>;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type InputValidationSimpleConfig = {
  __typename?: 'InputValidationSimpleConfig';
  allowed?: Maybe<InputValidationAllowed>;
  exactLength?: Maybe<Scalars['Float']['output']>;
};

export type InvalidStatusReason = {
  __typename?: 'InvalidStatusReason';
  error?: Maybe<Scalars['String']['output']>;
  type: PathwayValidationStatusReasonType;
};

export type IsSlugUniquePayload = {
  __typename?: 'IsSlugUniquePayload';
  is_slug_unique: Scalars['Boolean']['output'];
};

export type JsonField = ExtensionActionField & {
  __typename?: 'JsonField';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** For json fields we can use this prop to specify schema of json object */
  jsonSchemaSource?: Maybe<JsonSchemaSourceGraphqlType>;
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  slate?: Maybe<Scalars['String']['output']>;
  type: ExtensionActionFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type JsonPathPayload = Payload & {
  __typename?: 'JsonPathPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  jsonPath: Scalars['String']['output'];
  mockObject: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type JsonSchemaSourceGraphqlType = {
  __typename?: 'JsonSchemaSourceGraphqlType';
  qualifiedKey: Scalars['String']['output'];
  system: JsonSchemaSourceSystem;
};

export type JsonSchemaSourceGraphqlTypeInput = {
  qualifiedKey: Scalars['String']['input'];
  system: JsonSchemaSourceSystem;
};

export enum JsonSchemaSourceSystem {
  Awell = 'AWELL',
  Extension = 'EXTENSION',
  FhirProxy = 'FHIR_PROXY'
}

export type Label = {
  __typename?: 'Label';
  color: Scalars['String']['output'];
  created: AuditTrail;
  id: Scalars['ID']['output'];
  last_updated?: Maybe<AuditTrail>;
  text: Scalars['String']['output'];
};

export type LabelInput = {
  color: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum Language {
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Estonian = 'ESTONIAN',
  French = 'FRENCH',
  Polish = 'POLISH',
  Romanian = 'ROMANIAN',
  Russian = 'RUSSIAN',
  Spanish = 'SPANISH'
}

/**
 *
 *   Some actions are performed in specific locations.
 *   Pathway studio allows pathway builders to create and assign locations to each action.
 *   Example:
 *   - Filling an intake form during the doctor's visit
 *   - Filling a follow-up questionnaire at home
 *   ...
 *
 */
export type Location = {
  __typename?: 'Location';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type LocationsPayload = Payload & {
  __typename?: 'LocationsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  locations: Array<Location>;
  success: Scalars['Boolean']['output'];
};

export type Logic = {
  __typename?: 'Logic';
  code_block?: Maybe<CodeBlock>;
  config_id?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  decision_table?: Maybe<DecisionTable>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: LogicType;
};

export type LogicPayload = Payload & {
  __typename?: 'LogicPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  logic: Logic;
  success: Scalars['Boolean']['output'];
};

export enum LogicType {
  Codeblock = 'CODEBLOCK',
  Decision = 'DECISION'
}

export type LogicsPayload = Payload & {
  __typename?: 'LogicsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  logics: Array<Logic>;
  success: Scalars['Boolean']['output'];
};

export type LoopCondition = {
  __typename?: 'LoopCondition';
  id: Scalars['String']['output'];
  operand: Operand;
  operator: ConditionOperator;
  reference: Scalars['String']['output'];
};

export type LoopConditionInput = {
  id: Scalars['String']['input'];
  operand: OperandInput;
  operator: ConditionOperator;
  reference: Scalars['String']['input'];
};

export type LoopConfiguration = {
  __typename?: 'LoopConfiguration';
  enabled: Scalars['Boolean']['output'];
  exit_condition?: Maybe<LoopExitCondition>;
  max_iterations?: Maybe<Scalars['Int']['output']>;
};

export type LoopExitCondition = {
  __typename?: 'LoopExitCondition';
  boolean_operator: Scalars['String']['output'];
  conditions: Array<LoopCondition>;
  type: Scalars['String']['output'];
};

export type LoopExitConditionInput = {
  boolean_operator: Scalars['String']['input'];
  conditions: Array<LoopConditionInput>;
  type: Scalars['String']['input'];
};

export type MakeFormSharedInput = {
  form_id: Scalars['String']['input'];
};

export type MakeFormSharedPayload = Payload & {
  __typename?: 'MakeFormSharedPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type MappingDataPointDefinitionInput = {
  data_point_definition_id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  new_data_point_definition?: InputMaybe<NewMappingDataPointDefinitionInput>;
};

export type MarkReleaseAsLiveInput = {
  definition_id: Scalars['String']['input'];
  release_id: Scalars['String']['input'];
};

export type MarkReleaseAsLivePayload = Payload & {
  __typename?: 'MarkReleaseAsLivePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type MassResetTeamInput = {
  team_id: Scalars['String']['input'];
};

/**
 *
 *   Messages are templates that use data points to create message instances.
 *   Messages that use 0 data points are called static messages.
 *
 *   A message instance is created by filling a message template with data point instances
 *
 *   An illustrative example:
 *   - Message:
 *     - message template: "Hello |patient_first_name|"
 *     - data points:
 *       - patient_first_name is a data point of type patient with property first name
 *   If a patient has a first name Ben then the message instance would be "Hello Ben"
 *
 *   Explanation of Message fields:
 *    - subject: Short explanation of what goes in the message
 *    - body: The content that goes in the message
 *
 */
export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<MessageAttachment>>;
  body?: Maybe<Scalars['String']['output']>;
  format: MessageFormat;
  html_body?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type MessageAction = Action & {
  __typename?: 'MessageAction';
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  due_date?: Maybe<DueDate>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message?: Maybe<Message>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: MessageAttachmentType;
  url: Scalars['String']['output'];
};

export type MessageAttachmentInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: MessageAttachmentType;
  url: Scalars['String']['input'];
};

export enum MessageAttachmentType {
  File = 'FILE',
  Link = 'LINK',
  Video = 'VIDEO'
}

export type MessageBodyInput = {
  html: Scalars['String']['input'];
  slate: Scalars['String']['input'];
};

export type MessageBodyTemplate = {
  __typename?: 'MessageBodyTemplate';
  html: Scalars['String']['output'];
  plaintext: Scalars['String']['output'];
  slate: Scalars['String']['output'];
};

export enum MessageFormat {
  Html = 'HTML',
  Slate = 'SLATE'
}

export type MessagePayload = Payload & {
  __typename?: 'MessagePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  message: Message;
  success: Scalars['Boolean']['output'];
};

export type MockContextInput = {
  /** Mock activity ID for testing */
  activity_id?: InputMaybe<Scalars['String']['input']>;
  /** Mock careflow ID for testing */
  careflow_id?: InputMaybe<Scalars['String']['input']>;
  /** Mock patient ID for testing */
  patient_id?: InputMaybe<Scalars['String']['input']>;
  /** Mock patient profile (name, identifiers, etc.) */
  patient_profile?: InputMaybe<Scalars['JSON']['input']>;
};

export type MultipleSelectConfig = {
  __typename?: 'MultipleSelectConfig';
  exclusive_option?: Maybe<ExclusiveOptionConfig>;
  range?: Maybe<ChoiceRangeConfig>;
};

export type MultipleSelectConfigInput = {
  exclusive_option?: InputMaybe<ExclusiveOptionConfigInput>;
  /** The range configuration limits the number of choices the user can make. */
  range?: InputMaybe<ChoiceRangeConfigInput>;
};

export type MultipleSelectQuestionConfigInput = {
  /** The multiple-select specific configuration for the question. */
  multiple_select: MultipleSelectConfigInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddChecklistToStep: AddChecklistToStepPayload;
  AddMessageToStep: AddMessageToStepPayload;
  activateTrigger: ActivateTriggerPayload;
  addActionToStep: AddActionToStepPayload;
  addAgentToTrack: AgentPayload;
  addConditionToRule: AddConditionToRulePayload;
  addConstant: AddConstantPayload;
  addCustomActionToPathway: EmptyPayload;
  addCustomFieldToPathway: EmptyPayload;
  addDataPointDefinitionToPathway: AddDataPointDefinitionToPathwayPayload;
  addDataPointMappingToExtensionAction: AddDataPointMappingToExtensionActionPayload;
  addDerivedDataPointDefinition: AddDerivedDataPointDefinitionPayload;
  addLabelToStep: AddLabelToStepPayload;
  addLocationToPathway: AddLocationToPathwayPayload;
  addLogicToTrack: LogicPayload;
  addMappingToApiCall: AddMappingToApiCallPayload;
  addMessageAttachment: MessagePayload;
  addNarrativeToClinicalNote: ClinicalNotePayload;
  /**
   *
   * Adds a single question to a specific form. By default, the question will be added at the end of the form. If the previous_question_id is provided, the question will be added after the question with that ID.
   *
   * Tags: form-design.
   *
   */
  addQuestionToForm: AddQuestionToFormPayload;
  /**
   *
   * Adds multiple questions to a specific form in a batch operation.
   *
   * Tags: form-design.
   * AI hint: Use this method to efficiently update a form with multiple questions, optimizing performance and consistency. The questions will be added to the form in the order they are provided in the input. Use a succinct but descriptive value in camelCase for each question key that is easy to understand and remember by humans.
   *
   */
  addQuestionsToForm: AddQuestionsToFormPayload;
  addRuleToQuestion: AddRuleToQuestionPayload;
  addStepFromLibraryToTrack: AddStepFromLibraryToTrackPayload;
  addStepFromTemplate: StepPayload;
  addStepToLibrary: AddStepToLibraryPayload;
  addStepToTrack: AddStepToTrackPayload;
  addStickyNoteToTrack: AddStickyNoteToTrackPayload;
  addTimerToTrack: TimerPayload;
  addTrack: EmptyPayload;
  addTrackToPathway: AddTrackToPathwayPayload;
  addTransformationToDynamicVariable: AddTransformationToDynamicVariablePayload;
  addTriggerTimer: TriggerPayload;
  addTriggerToPathway: AddTriggerToPathwayPayload;
  addTriggerToTrack: AddTriggerToTrackPayload;
  addWebhook: AddWebhookPayload;
  clearActionDueDate: ClearActionDueDatePayload;
  clearActionExpiration: ClearActionExpirationPayload;
  clearActionIdleTime: ClearActionIdleTimePayload;
  clearTimingDelay: ClearTimingDelayPayload;
  clearTimingReference: ClearTimingReferencePayload;
  clearViewModels: EmptyPayload;
  configureAhpLink: AhpLinkPayload;
  configureExtension: ConfigureExtensionPayload;
  connectSteps: ConnectStepsPayload;
  createCodeBlock: CodeBlockPayload;
  createDecisionTable: DecisionTablePayload;
  createDynamicVariable: CreateDynamicVariablePayload;
  createForm: CreateFormPayload;
  createMessage: CreateMessagePayload;
  createPathway: CreatePathwayPayload;
  /**
   * Creates pathway case for a pathway.
   *       Pathway Case represents a single execution course in a pathway
   *       that is determined by evaluating transition and timing conditions
   *       based on provided input by the stakeholders of a pathway (patient, doctors, etc.)
   */
  createPathwayCase: CreatePathwayCasePayload;
  createTransition: CreateTransitionPayload;
  createTrigger: CreateTriggerPayload;
  deleteAgent: EmptyPayload;
  deleteCodeBlock: EmptyPayload;
  deleteDecisionTable: DeleteDecisionTablePayload;
  deleteLogic: DeleteLogicPayload;
  /** Delete the pathway case */
  deletePathwayCase: DeletePathwayCasePayload;
  /**
   *
   * Deletes a private form and all its associated components.
   *
   * This operation will:
   * - Delete all questions in the form
   * - Delete all rules associated with questions
   * - Remove the form component
   * - Clean up any related relationships
   *
   * This is a destructive operation that cannot be undone.
   *
   * Tags: form-design.
   *
   */
  deletePrivateForm: EmptyPayload;
  /**
   *
   * Deletes a shared form that is not currently used by any care flow.
   *
   * This operation will:
   * - Verify the form is shared (is_shared = true)
   * - Check that no care flows are using this form
   * - Delete all questions in the form
   * - Delete all rules associated with questions
   * - Remove the form component
   * - Clean up data point definitions and relationships
   *
   * This is a destructive operation that cannot be undone.
   *
   * Tags: form-design.
   *
   */
  deleteSharedForm: EmptyPayload;
  deleteTimer: EmptyPayload;
  duplicateCareflow: DuplicateCareflowPayload;
  duplicateForm: DuplicateFormPayload;
  duplicateQuestion: DuplicateQuestionPayload;
  duplicateStep: DuplicateStepPayload;
  editCodeBlock: CodeBlockPayload;
  editDecisionTable: DecisionTablePayload;
  editRule: EditRulePayload;
  editTrigger: EditTriggerPayload;
  endTrackAfterStep: EndTrackAfterStepPayload;
  evaluateFormRules: EvaluateFormRulesPayload;
  executeTestApiCall: ExecuteTestApiCallPayload;
  exportPathway: EmptyPayload;
  generateCareflowSummary: GenerateCareflowSummaryPayload;
  importPathway: EmptyPayload;
  /** Converts a private care flow-scoped form to a shared form that can be used across multiple care flows. */
  makeFormShared: MakeFormSharedPayload;
  markReleaseAsLive: MarkReleaseAsLivePayload;
  massResetTeam: EmptyPayload;
  previewExtensionAction: PreviewExtensionActionPayload;
  publishPathway: PublishPathwayPayload;
  readMessage: ReadMessagePayload;
  rebuildGraph: EmptyPayload;
  rebuildGraphs: RebuildViewModelsPayload;
  rebuildViewModels: RebuildViewModelsPayload;
  recomputeCalculationDataSources: EmptyPayload;
  refreshDefinitionReferences: EmptyPayload;
  refreshExtension: RefreshExtensionPayload;
  removeActionFromStep: RemoveActionFromStepPayload;
  removeClinicalNoteNarrative: RemoveClinicalNoteNarrativePayload;
  removeConditionFromRule: RemoveConditionFromRulePayload;
  removeConstant: RemoveConstantPayload;
  removeDataPointDefinitionFromPathway: EmptyPayload;
  removeDataPointMappingFromExtensionAction: RemoveDataPointMappingFromExtensionActionPayload;
  removeDynamicVariable: EmptyPayload;
  removeExtensionConfiguration: EmptyPayload;
  removeLabelsFromStep: RemoveLabelsFromStepPayload;
  removeMappingFromApiCall: RemoveMappingFromApiCallPayload;
  removeMessageAttachment: MessagePayload;
  /**
   *
   * Removes one specific question from a form.
   *
   * Tags: form-design.
   *
   */
  removeQuestionFromForm: RemoveQuestionFromFormPayload;
  removeRuleFromQuestion: RemoveRuleFromQuestionPayload;
  removeStepFromLibrary: EmptyPayload;
  removeStepFromTrack: RemoveStepFromTrackPayload;
  removeStickyNoteFromTrack: EmptyPayload;
  removeTrackFromPathway: RemoveTrackFromPathwayPayload;
  removeTransformationsFromDynamicVariable: RemoveTransformationsFromDynamicVariablePayload;
  removeTransition: RemoveTransitionPayload;
  removeTriggerFromPathway: EmptyPayload;
  removeTriggerFromTrack: EmptyPayload;
  removeTriggerTimer: TriggerPayload;
  removeWebhook: RemoveWebhookPayload;
  reorderActions: ReorderActionsPayload;
  reorderMessageAttachments: MessagePayload;
  /**
   *
   * Reorders one specific question within a form. When previous_question_id is provided, the question will be reordered after the question with that ID. When previous_question_id is not provided, the question will be reordered to the first position.
   *
   * Tags: form-design.
   *
   */
  reorderQuestions: ReorderQuestionsPayload;
  repairPathways: RepairPathwaysPayload;
  resetPatientProfileDataPointDefinitions: EmptyPayload;
  resetPreview: ResetPreviewPayload;
  restoreCheckpoint: CheckpointPayload;
  retryAllFailedWebhookCalls: EmptyPayload;
  retryAllWebhookCalls: EmptyPayload;
  retryApiCall: EmptyPayload;
  retryWebhookCall: RetryWebhookCallPayload;
  saveCheckpoint: CheckpointPayload;
  saveMessage: MessagePayload;
  setActionCalculationId: SetActionCalculationIdPayload;
  setActionCalculationInput: SetActionCalculationInputPayload;
  setActionCalculationLanguage: SetActionCalculationLanguagePayload;
  setActionChecklistItems: SetActionChecklistItemsPayload;
  setActionDueDate: SetActionDueDatePayload;
  setActionExpiration: SetActionExpirationPayload;
  setActionFormDisplayMode: SetActionFormDisplayModePayload;
  setActionFormId: SetActionFormIdPayload;
  setActionIdleTime: SetActionIdleTimePayload;
  setActionMessageId: SetActionMessageIdPayload;
  setActionStakeholders: SetActionStakeholdersPayload;
  setActionTitle: SetActionTitlePayload;
  setAgentCoordinates: AgentPayload;
  setApiCallBody: SetApiCallBodyPayload;
  setApiCallEndpoint: SetApiCallEndpointPayload;
  setApiCallHeaders: SetApiCallHeadersPayload;
  setApiCallMethod: SetApiCallMethodPayload;
  setBrandingAccentColor: SetBrandingAccentColorPayload;
  setBrandingCustomTheme: SetBrandingCustomThemePayload;
  setBrandingHostedPageAutoProgress: SetBrandingHostedPageAutoProgressPayload;
  setBrandingHostedPageAutosave: SetBrandingHostedPageAutosavePayload;
  setBrandingHostedPageTitle: SetBrandingHostedPageTitlePayload;
  setBrandingLogoUrl: SetBrandingLogoUrlPayload;
  setCalculationPrerequisiteForm: SetCalculationPrerequisiteFormPayload;
  setClinicalNoteNarrativeTitle: ClinicalNotePayload;
  setConditionOperand: SetConditionOperandPayload;
  setConditionOperator: SetConditionOperatorPayload;
  setConditionReference: SetConditionReferencePayload;
  setCustomActionField: SetCustomActionFieldPayload;
  setDataPointDefinitionMetaDataField: SetDataPointDefinitionMetaDataFieldPayload;
  setDataPointDefinitionOptionalField: SetDataPointDefinitionOptionalFieldPayload;
  setDataPointDefinitionPiiField: SetDataPointDefinitionPiiFieldPayload;
  /**
   *
   * Updates the configuration for a date-type question in a form.
   *
   * Tags: form-design.
   *
   */
  setDateQuestionConfig: SetDateQuestionConfigPayload;
  setDynamicVariableDataPointDefinition: SetDynamicVariableDataPointDefinitionPayload;
  setDynamicVariableDataPointProperty: SetDynamicVariableDataPointPropertyPayload;
  setDynamicVariableFallback: SetDynamicVariableFallbackPayload;
  setDynamicVariableLabel: SetDynamicVariableLabelPayload;
  setEmrReportBody: EmrReportPayload;
  setExtensionActionDataPointMappingDataPoint: SetExtensionActionDataPointMappingDataPointPayload;
  setExtensionActionDataPointMappingKey: SetExtensionActionDataPointMappingKeyPayload;
  setExtensionActionDataPointMappings: SetExtensionActionDataPointMappingsPayload;
  setExtensionActionErrorHandling: SetExtensionActionErrorHandlingPayload;
  setExtensionActionField: SetExtensionActionFieldPayload;
  /**
   *
   * Updates the configuration for a file-type question in a form.
   *
   * Tags: form-design.
   *
   */
  setFileQuestionConfig: SetFileQuestionConfigPayload;
  /**
   *
   * Updates the unique key associated with a form.
   *
   * Tags: form-design.
   * AI hint: Use a succinct but descriptive key that is easy to understand and remember by humans. It should be in camelCase.
   *
   */
  setFormKey: SetFormKeyPayload;
  setFormMetadata: SetFormMetadataPayload;
  /**
   *
   * Updates the title of a form.
   *
   * Tags: form-design.
   * AI hint: Use a name that is associated with the content of the form and has no more than 4 words.
   *
   */
  setFormTitle: SetFormTitlePayload;
  setFormTrademark: SetFormTrademarkPayload;
  /**
   *
   * Updates the input validation configuration for a short text question in a form.
   *
   * Tags: form-design.
   *
   */
  setInputValidationQuestionConfig: SetInputValidationQuestionConfigPayload;
  setLogicCoordinates: SetLogicCoordinatesPayload;
  setMessageAttachmentName: MessagePayload;
  setMessageAttachmentUrl: MessagePayload;
  setMessageBody: MessagePayload;
  setMessageSubject: MessagePayload;
  /**
   *
   * Updates the configuration for a multiple-select question in a form.
   *
   * Tags: form-design.
   * AI hint: Use the range configuration to limit the number of choices the user can make. Do not use the exclusive option configuration as it is deprecated.
   *
   */
  setMultipleSelectQuestionConfig: SetMultipleSelectQuestionConfigPayload;
  /**
   *
   * Updates the configuration for a number-type question in a form.
   *
   * Tags: form-design.
   *
   */
  setNumberQuestionConfig: SetNumberQuestionConfigPayload;
  setPathwayCaseTitle: SetPathwayCaseTitlePayload;
  setPathwayTitle: SetPathwayTitlePayload;
  /**
   *
   * Updates the configuration for a phone-type question in a form.
   *
   * Tags: form-design.
   *
   */
  setPhoneQuestionConfig: SetPhoneQuestionConfigPayload;
  /**
   *
   * Updates the general configuration for a single question in a form.
   *
   * Tags: form-design.
   *
   */
  setQuestionConfig: SetQuestionConfigPayload;
  /**
   *
   * Updates the unique key associated with a question in a form.
   *
   * Tags: form-design.
   * AI hint: Use a succinct but descriptive key that is easy to understand and remember by humans. It should be in camelCase.
   *
   */
  setQuestionKey: SetQuestionKeyPayload;
  setQuestionMetadata: SetQuestionMetadataPayload;
  /**
   *
   * Updates the value type for a specific question. The value type determines the type of data that will be collected for this question when a user answers it. Note that changing the value type is a potentially destructive operation as it invalidates all the existing usage of the answer in transitions, variables, conditions etc.
   *
   */
  setQuestionOptionValueType: SetQuestionOptionValueTypePayload;
  /**
   *
   * Updates the general configuration for multiple questions in a form.
   *
   * Tags: form-design.
   * AI hint: Use this method to efficiently make multiple questions mandatory or optional.
   *
   */
  setQuestionsConfig: SetQuestionsConfigPayload;
  setRemindersAmount: SetRemindersAmountPayload;
  setRemindersDelay: SetRemindersDelayPayload;
  setRuleBooleanOperator: SetRuleBooleanOperatorPayload;
  setRuleType: SetRuleTypePayload;
  /**
   *
   * Updates the configuration for a slider-type question in a form.
   *
   * Tags: form-design.
   *
   */
  setSliderQuestionConfig: SetSliderQuestionConfigPayload;
  setStakeholderEmails: SetStakeholderEmailsPayload;
  setStepCoordinates: SetStepCoordinatesPayload;
  setStepDocumentation: SetStepDocumentationPayload;
  setStepTitle: SetStepTitlePayload;
  setStickyNoteCoordinates: SetStickyNoteCoordinatesPayload;
  setTimerCoordinates: TimerPayload;
  setTimerName: TimerPayload;
  setTimingDelay: SetTimingDelayPayload;
  setTimingReference: SetTimingReferencePayload;
  /** Sets a plain text description of the track */
  setTrackDescription: SetTrackDescriptionPayload;
  setTrackEndCoordinates: SetTrackEndCoordinatesPayload;
  /** Sets the loop configuration for a track */
  setTrackLoopConfiguration: SetTrackLoopConfigurationPayload;
  setTrackStartCoordinates: SetTrackStartCoordinatesPayload;
  /** Setting track title */
  setTrackTitle: SetTrackTitlePayload;
  setTransformationParams: SetTransformationParamsPayload;
  setTransformationType: SetTransformationTypePayload;
  setTransitionDestination: SetTransitionDestinationPayload;
  setTriggerDataPointDefinition: TriggerPayload;
  setTriggerDelay: TriggerPayload;
  setTriggerSettings: TriggerPayload;
  setTriggerStep: TriggerPayload;
  setTriggerTimerDataPointDefinition: TriggerPayload;
  setTriggerTimerStep: TriggerPayload;
  setTriggerTimerTrack: TriggerPayload;
  setTriggerTimerType: TriggerPayload;
  setTriggerTrack: TriggerPayload;
  setTriggerType: TriggerPayload;
  shareForms: EmptyPayload;
  sharePathways: EmptyPayload;
  startPreview: StartPreviewPayload;
  startTrackFromStep: StartTrackFromStepPayload;
  startTransitionFromStep: StartTransitionFromStepPayload;
  submitChecklist: SubmitChecklistPayload;
  submitFormResponse: SubmitFormResponsePayload;
  testCareFlowSourceControlSettings: TestSourceControlPayload;
  testCodeBlock: TestCodeBlockResult;
  transferPathway: EmptyPayload;
  trashPathway: EmptyPayload;
  triggerApiCall: TriggerApiCallPayload;
  updateAgentConfig: AgentPayload;
  updateApiCallMappingDataPoint: UpdateApiCallMappingDataPointPayload;
  updateApiCallMappingFirstMatchOnly: UpdateApiCallMappingFirstMatchOnlyPayload;
  updateApiCallMappingKey: UpdateApiCallMappingKeyPayload;
  updateCareFlowApiCallRetrySettings: UpdateCareFlowApiCallRetrySettingsPayload;
  updateCareFlowSourceControlSettings: UpdateCareFlowSourceControlSettingsPayload;
  updateClinicalNoteContext: UpdateClinicalNoteContextPayload;
  updateClinicalNoteNarrativeBody: ClinicalNotePayload;
  updateConstant: UpdateConstantPayload;
  updateDataPointDefinition: UpdateDataPointDefinitionPayload;
  updateDynamicVariable: UpdateDynamicVariablePayload;
  updateEmailNotificationStatus: UpdateEmailNotificationStatusPayload;
  updateLabelText: UpdateLabelTextPayload;
  updateLogicConfig: LogicPayload;
  updateLogicName: LogicPayload;
  /**
   *
   * Updates the title and options for a question in a form.
   *
   * Tags: form-design.
   *
   */
  updateQuestion: UpdateQuestionPayload;
  updateStickyNoteBody: UpdateStickyNoteBodyPayload;
  updateTimerConfig: TimerPayload;
  updateWebhook: UpdateWebhookPayload;
  updateWebhookEndpoint: UpdateWebhookEndpointPayload;
  updateWebhookHeaders: UpdateWebhookHeadersPayload;
  updateWebhookName: UpdateWebhookNamePayload;
  updateWebhookStatus: UpdateWebhookStatusPayload;
  updateWebhookSubscribedEvents: UpdateWebhookSubscribedEventsPayload;
  updateWebhookTestEndpoint: UpdateWebhookTestEndpointPayload;
};


export type MutationAddChecklistToStepArgs = {
  input: AddChecklistToStepInput;
};


export type MutationAddMessageToStepArgs = {
  input: AddMessageToStepInput;
};


export type MutationActivateTriggerArgs = {
  input: ActivateTriggerInput;
};


export type MutationAddActionToStepArgs = {
  input: AddActionToStepInput;
};


export type MutationAddAgentToTrackArgs = {
  input: AddAgentToTrackInput;
};


export type MutationAddConditionToRuleArgs = {
  input: AddConditionToRuleInput;
};


export type MutationAddConstantArgs = {
  input: AddConstantInput;
};


export type MutationAddCustomActionToPathwayArgs = {
  input: AddCustomActionToPathwayInput;
};


export type MutationAddCustomFieldToPathwayArgs = {
  input: AddCustomFieldToPathwayInput;
};


export type MutationAddDataPointDefinitionToPathwayArgs = {
  input: AddDataPointDefinitionToPathwayInput;
};


export type MutationAddDataPointMappingToExtensionActionArgs = {
  input: AddDataPointMappingToExtensionActionInput;
};


export type MutationAddDerivedDataPointDefinitionArgs = {
  input: AddDerivedDataPointDefinitionInput;
};


export type MutationAddLabelToStepArgs = {
  input: AddLabelToStepInput;
};


export type MutationAddLocationToPathwayArgs = {
  input: AddLocationToPathwayInput;
};


export type MutationAddLogicToTrackArgs = {
  input: AddLogicToTrackInput;
};


export type MutationAddMappingToApiCallArgs = {
  input: AddMappingToApiCallInput;
};


export type MutationAddMessageAttachmentArgs = {
  input: AddMessageAttachmentInput;
};


export type MutationAddNarrativeToClinicalNoteArgs = {
  input: AddNarrativeToClinicalNoteInput;
};


export type MutationAddQuestionToFormArgs = {
  input: AddQuestionToFormInput;
};


export type MutationAddQuestionsToFormArgs = {
  input: AddQuestionsToFormInput;
};


export type MutationAddRuleToQuestionArgs = {
  input: AddRuleToQuestionInput;
};


export type MutationAddStepFromLibraryToTrackArgs = {
  input: AddStepFromLibraryToTrackInput;
};


export type MutationAddStepFromTemplateArgs = {
  input: AddStepFromTemplateInput;
};


export type MutationAddStepToLibraryArgs = {
  input: AddStepToLibraryInput;
};


export type MutationAddStepToTrackArgs = {
  input: AddStepToTrackInput;
};


export type MutationAddStickyNoteToTrackArgs = {
  input: AddStickyNoteToTrackInput;
};


export type MutationAddTimerToTrackArgs = {
  input: AddTimerToTrackInput;
};


export type MutationAddTrackArgs = {
  input: AddTrackInput;
};


export type MutationAddTrackToPathwayArgs = {
  input: AddTrackToPathwayInput;
};


export type MutationAddTransformationToDynamicVariableArgs = {
  input: AddTransformationToDynamicVariableInput;
};


export type MutationAddTriggerTimerArgs = {
  input: AddTriggerTimerInput;
};


export type MutationAddTriggerToPathwayArgs = {
  input: AddTriggerToPathwayInput;
};


export type MutationAddTriggerToTrackArgs = {
  input: AddTriggerToTrackInput;
};


export type MutationAddWebhookArgs = {
  input: AddWebhookInput;
};


export type MutationClearActionDueDateArgs = {
  input: ClearActionDueDateInput;
};


export type MutationClearActionExpirationArgs = {
  input: ClearActionExpirationInput;
};


export type MutationClearActionIdleTimeArgs = {
  input: ClearActionIdleTimeInput;
};


export type MutationClearTimingDelayArgs = {
  input: ClearTimingDelayInput;
};


export type MutationClearTimingReferenceArgs = {
  input: ClearTimingReferenceInput;
};


export type MutationConfigureAhpLinkArgs = {
  input: ConfigureAhpLinkInput;
};


export type MutationConfigureExtensionArgs = {
  input: ConfigureExtensionInput;
};


export type MutationConnectStepsArgs = {
  input: ConnectStepsInput;
};


export type MutationCreateCodeBlockArgs = {
  input: CreateCodeBlockInput;
};


export type MutationCreateDecisionTableArgs = {
  input: CreateDecisionTableInput;
};


export type MutationCreateDynamicVariableArgs = {
  input: CreateDynamicVariableInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreatePathwayArgs = {
  input: CreatePathwayInput;
};


export type MutationCreatePathwayCaseArgs = {
  input: CreatePathwayCaseInput;
};


export type MutationCreateTransitionArgs = {
  input: CreateTransitionInput;
};


export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput;
};


export type MutationDeleteAgentArgs = {
  input: DeleteAgentInput;
};


export type MutationDeleteCodeBlockArgs = {
  code_block_id: Scalars['String']['input'];
};


export type MutationDeleteDecisionTableArgs = {
  input: DeleteDecisionTableInput;
};


export type MutationDeleteLogicArgs = {
  input: DeleteLogicInput;
};


export type MutationDeletePathwayCaseArgs = {
  input: DeletePathwayCaseInput;
};


export type MutationDeletePrivateFormArgs = {
  input: DeletePrivateFormInput;
};


export type MutationDeleteSharedFormArgs = {
  input: DeleteSharedFormInput;
};


export type MutationDeleteTimerArgs = {
  input: DeleteTimerInput;
};


export type MutationDuplicateCareflowArgs = {
  input: DuplicateCareflowInput;
};


export type MutationDuplicateFormArgs = {
  input: DuplicateFormInput;
};


export type MutationDuplicateQuestionArgs = {
  input: DuplicateQuestionInput;
};


export type MutationDuplicateStepArgs = {
  input: DuplicateStepInput;
};


export type MutationEditCodeBlockArgs = {
  input: EditCodeBlockInput;
};


export type MutationEditDecisionTableArgs = {
  input: EditDecisionTableInput;
};


export type MutationEditRuleArgs = {
  input: EditRuleRequestInput;
};


export type MutationEditTriggerArgs = {
  input: EditTriggerInput;
};


export type MutationEndTrackAfterStepArgs = {
  input: EndTrackAfterStepInput;
};


export type MutationEvaluateFormRulesArgs = {
  input: EvaluateFormRulesInput;
};


export type MutationExecuteTestApiCallArgs = {
  input: ExecuteTestApiCallInput;
};


export type MutationExportPathwayArgs = {
  input: ExportPathwayInput;
};


export type MutationGenerateCareflowSummaryArgs = {
  careflow_definition_id: Scalars['String']['input'];
};


export type MutationImportPathwayArgs = {
  input: ImportPathwayInput;
};


export type MutationMakeFormSharedArgs = {
  input: MakeFormSharedInput;
};


export type MutationMarkReleaseAsLiveArgs = {
  input: MarkReleaseAsLiveInput;
};


export type MutationMassResetTeamArgs = {
  input: MassResetTeamInput;
};


export type MutationPreviewExtensionActionArgs = {
  input: PreviewExtensionActionInput;
};


export type MutationPublishPathwayArgs = {
  input: PublishPathwayInput;
};


export type MutationReadMessageArgs = {
  input: ReadMessageInput;
};


export type MutationRebuildGraphArgs = {
  pathway_definition_id: Scalars['String']['input'];
};


export type MutationRebuildGraphsArgs = {
  input: RebuildInput;
};


export type MutationRebuildViewModelsArgs = {
  input: RebuildInput;
};


export type MutationRefreshExtensionArgs = {
  input: RefreshExtensionInput;
};


export type MutationRemoveActionFromStepArgs = {
  input: RemoveActionFromStepInput;
};


export type MutationRemoveClinicalNoteNarrativeArgs = {
  input: RemoveClinicalNoteNarrativeInput;
};


export type MutationRemoveConditionFromRuleArgs = {
  input: RemoveConditionFromRuleInput;
};


export type MutationRemoveConstantArgs = {
  input: RemoveConstantInput;
};


export type MutationRemoveDataPointDefinitionFromPathwayArgs = {
  input: RemoveDataPointDefinitionFromPathwayInput;
};


export type MutationRemoveDataPointMappingFromExtensionActionArgs = {
  input: RemoveDataPointMappingFromExtensionActionInput;
};


export type MutationRemoveDynamicVariableArgs = {
  input: RemoveDynamicVariableInput;
};


export type MutationRemoveExtensionConfigurationArgs = {
  input: RemoveExtensionConfigurationInput;
};


export type MutationRemoveLabelsFromStepArgs = {
  input: RemoveLabelsFromStepInput;
};


export type MutationRemoveMappingFromApiCallArgs = {
  input: RemoveMappingFromApiCallInput;
};


export type MutationRemoveMessageAttachmentArgs = {
  input: RemoveMessageAttachmentInput;
};


export type MutationRemoveQuestionFromFormArgs = {
  input: RemoveQuestionFromFormInput;
};


export type MutationRemoveRuleFromQuestionArgs = {
  input: RemoveRuleFromQuestionInput;
};


export type MutationRemoveStepFromLibraryArgs = {
  input: RemoveStepFromLibraryInput;
};


export type MutationRemoveStepFromTrackArgs = {
  input: RemoveStepFromTrackInput;
};


export type MutationRemoveStickyNoteFromTrackArgs = {
  input: RemoveStickyNoteFromTrackInput;
};


export type MutationRemoveTrackFromPathwayArgs = {
  input: RemoveTrackFromPathwayInput;
};


export type MutationRemoveTransformationsFromDynamicVariableArgs = {
  input: RemoveTransformationsFromDynamicVariableInput;
};


export type MutationRemoveTransitionArgs = {
  input: RemoveTransitionInput;
};


export type MutationRemoveTriggerFromPathwayArgs = {
  input: RemoveTriggerFromPathwayInput;
};


export type MutationRemoveTriggerFromTrackArgs = {
  input: RemoveTriggerFromTrackInput;
};


export type MutationRemoveTriggerTimerArgs = {
  input: RemoveTriggerTimerInput;
};


export type MutationRemoveWebhookArgs = {
  input: RemoveWebhookInput;
};


export type MutationReorderActionsArgs = {
  input: ReorderActionsInput;
};


export type MutationReorderMessageAttachmentsArgs = {
  input: ReorderMessageAttachmentsInput;
};


export type MutationReorderQuestionsArgs = {
  input: ReorderQuestionsInput;
};


export type MutationRepairPathwaysArgs = {
  input: RepairPathwaysInput;
};


export type MutationResetPatientProfileDataPointDefinitionsArgs = {
  input: ResetPatientProfileDataPointDefinitionsInput;
};


export type MutationResetPreviewArgs = {
  input: ResetPreviewInput;
};


export type MutationRestoreCheckpointArgs = {
  input: RestoreCheckpointInput;
};


export type MutationRetryAllFailedWebhookCallsArgs = {
  input: RetryAllFailedWebhookCallsInput;
};


export type MutationRetryAllWebhookCallsArgs = {
  input: RetryAllWebhookCallsInput;
};


export type MutationRetryApiCallArgs = {
  input: RetryApiCallInput;
};


export type MutationRetryWebhookCallArgs = {
  input: RetryWebhookCallInput;
};


export type MutationSaveCheckpointArgs = {
  input: SaveCheckpointInput;
};


export type MutationSaveMessageArgs = {
  input: SaveMessageInput;
};


export type MutationSetActionCalculationIdArgs = {
  input: SetActionCalculationIdInput;
};


export type MutationSetActionCalculationInputArgs = {
  input: SetCalculationDataPointInput;
};


export type MutationSetActionCalculationLanguageArgs = {
  input: SetActionCalculationLanguageInput;
};


export type MutationSetActionChecklistItemsArgs = {
  input: SetActionChecklistItemsInput;
};


export type MutationSetActionDueDateArgs = {
  input: ActionDueDateInput;
};


export type MutationSetActionExpirationArgs = {
  input: ActionExpirationInput;
};


export type MutationSetActionFormDisplayModeArgs = {
  input: SetActionFormDisplayModeInput;
};


export type MutationSetActionFormIdArgs = {
  input: SetActionFormIdInput;
};


export type MutationSetActionIdleTimeArgs = {
  input: SetActionIdleTimeInput;
};


export type MutationSetActionMessageIdArgs = {
  input: SetActionMessageIdInput;
};


export type MutationSetActionStakeholdersArgs = {
  input: SetActionStakeholdersInput;
};


export type MutationSetActionTitleArgs = {
  input: SetActionTitleInput;
};


export type MutationSetAgentCoordinatesArgs = {
  input: SetAgentCoordinatesInput;
};


export type MutationSetApiCallBodyArgs = {
  input: SetApiCallBodyInput;
};


export type MutationSetApiCallEndpointArgs = {
  input: SetApiCallEndpointInput;
};


export type MutationSetApiCallHeadersArgs = {
  input: SetApiCallHeadersInput;
};


export type MutationSetApiCallMethodArgs = {
  input: SetApiCallMethodInput;
};


export type MutationSetBrandingAccentColorArgs = {
  input: SetBrandingAccentColorInput;
};


export type MutationSetBrandingCustomThemeArgs = {
  input: SetBrandingCustomThemeInput;
};


export type MutationSetBrandingHostedPageAutoProgressArgs = {
  input: SetBrandingHostedPageAutoProgressInput;
};


export type MutationSetBrandingHostedPageAutosaveArgs = {
  input: SetBrandingHostedPageAutosaveInput;
};


export type MutationSetBrandingHostedPageTitleArgs = {
  input: SetBrandingHostedPageTitleInput;
};


export type MutationSetBrandingLogoUrlArgs = {
  input: SetBrandingLogoUrlInput;
};


export type MutationSetCalculationPrerequisiteFormArgs = {
  input: SetCalculationPrerequisiteFormInput;
};


export type MutationSetClinicalNoteNarrativeTitleArgs = {
  input: SetClinicalNoteNarrativeTitleInput;
};


export type MutationSetConditionOperandArgs = {
  input: SetConditionOperandInput;
};


export type MutationSetConditionOperatorArgs = {
  input: SetConditionOperatorInput;
};


export type MutationSetConditionReferenceArgs = {
  input: SetConditionReferenceInput;
};


export type MutationSetCustomActionFieldArgs = {
  input: SetCustomActionFieldInput;
};


export type MutationSetDataPointDefinitionMetaDataFieldArgs = {
  input: SetDataPointDefinitionMetaDataFieldInput;
};


export type MutationSetDataPointDefinitionOptionalFieldArgs = {
  input: SetDataPointDefinitionOptionalFieldInput;
};


export type MutationSetDataPointDefinitionPiiFieldArgs = {
  input: SetDataPointDefinitionPiiFieldInput;
};


export type MutationSetDateQuestionConfigArgs = {
  input: SetDateQuestionConfigInput;
};


export type MutationSetDynamicVariableDataPointDefinitionArgs = {
  input: SetDynamicVariableDataPointDefinitionInput;
};


export type MutationSetDynamicVariableDataPointPropertyArgs = {
  input: SetDynamicVariableDataPointPropertyInput;
};


export type MutationSetDynamicVariableFallbackArgs = {
  input: SetDynamicVariableFallbackInput;
};


export type MutationSetDynamicVariableLabelArgs = {
  input: SetDynamicVariableLabelInput;
};


export type MutationSetEmrReportBodyArgs = {
  input: SetEmrReportBodyInput;
};


export type MutationSetExtensionActionDataPointMappingDataPointArgs = {
  input: SetExtensionActionDataPointMappingDataPointInput;
};


export type MutationSetExtensionActionDataPointMappingKeyArgs = {
  input: SetExtensionActionDataPointMappingKeyInput;
};


export type MutationSetExtensionActionDataPointMappingsArgs = {
  input: SetExtensionActionDataPointMappingsInput;
};


export type MutationSetExtensionActionErrorHandlingArgs = {
  input: SetExtensionActionErrorHandlingInput;
};


export type MutationSetExtensionActionFieldArgs = {
  input: SetExtensionActionFieldInput;
};


export type MutationSetFileQuestionConfigArgs = {
  input: FileQuestionConfigInput;
};


export type MutationSetFormKeyArgs = {
  input: SetFormKeyInput;
};


export type MutationSetFormMetadataArgs = {
  input: SetFormMetadataInput;
};


export type MutationSetFormTitleArgs = {
  input: SetFormTitleInput;
};


export type MutationSetFormTrademarkArgs = {
  input: SetFormTrademarkInput;
};


export type MutationSetInputValidationQuestionConfigArgs = {
  input: InputValidationQuestionConfigInput;
};


export type MutationSetLogicCoordinatesArgs = {
  input: SetLogicCoordinatesInput;
};


export type MutationSetMessageAttachmentNameArgs = {
  input: SetMessageAttachmentNameInput;
};


export type MutationSetMessageAttachmentUrlArgs = {
  input: SetMessageAttachmentUrlInput;
};


export type MutationSetMessageBodyArgs = {
  input: SetMessageBodyInput;
};


export type MutationSetMessageSubjectArgs = {
  input: SetMessageSubjectInput;
};


export type MutationSetMultipleSelectQuestionConfigArgs = {
  input: SetMultipleSelectQuestionConfigInput;
};


export type MutationSetNumberQuestionConfigArgs = {
  input: SetNumberQuestionConfigInput;
};


export type MutationSetPathwayCaseTitleArgs = {
  input: SetPathwayCaseTitleInput;
};


export type MutationSetPathwayTitleArgs = {
  input: SetPathwayTitleInput;
};


export type MutationSetPhoneQuestionConfigArgs = {
  input: SetPhoneQuestionConfigInput;
};


export type MutationSetQuestionConfigArgs = {
  input: SetQuestionConfigInput;
};


export type MutationSetQuestionKeyArgs = {
  input: SetQuestionKeyInput;
};


export type MutationSetQuestionMetadataArgs = {
  input: SetQuestionMetadataInput;
};


export type MutationSetQuestionOptionValueTypeArgs = {
  input: SetQuestionOptionValueTypeInput;
};


export type MutationSetQuestionsConfigArgs = {
  input: SetQuestionsConfigInput;
};


export type MutationSetRemindersAmountArgs = {
  input: SetRemindersAmountInput;
};


export type MutationSetRemindersDelayArgs = {
  input: SetRemindersDelayInput;
};


export type MutationSetRuleBooleanOperatorArgs = {
  input: SetRuleBooleanOperatorInput;
};


export type MutationSetRuleTypeArgs = {
  input: SetRuleTypeInput;
};


export type MutationSetSliderQuestionConfigArgs = {
  input: SetSliderQuestionConfigInput;
};


export type MutationSetStakeholderEmailsArgs = {
  input: SetStakeholderEmailsInput;
};


export type MutationSetStepCoordinatesArgs = {
  input: SetStepCoordinatesInput;
};


export type MutationSetStepDocumentationArgs = {
  input: SetStepDocumentationInput;
};


export type MutationSetStepTitleArgs = {
  input: SetStepTitleInput;
};


export type MutationSetStickyNoteCoordinatesArgs = {
  input: SetStickyNoteCoordinatesInput;
};


export type MutationSetTimerCoordinatesArgs = {
  input: SetTimerCoordinatesInput;
};


export type MutationSetTimerNameArgs = {
  input: SetTimerNameInput;
};


export type MutationSetTimingDelayArgs = {
  input: SetTimingDelayInput;
};


export type MutationSetTimingReferenceArgs = {
  input: SetTimingReferenceInput;
};


export type MutationSetTrackDescriptionArgs = {
  input: SetTrackDescriptionInput;
};


export type MutationSetTrackEndCoordinatesArgs = {
  input: SetTrackEndCoordinatesInput;
};


export type MutationSetTrackLoopConfigurationArgs = {
  input: SetTrackLoopConfigurationInput;
};


export type MutationSetTrackStartCoordinatesArgs = {
  input: SetTrackStartCoordinatesInput;
};


export type MutationSetTrackTitleArgs = {
  input: SetTrackTitleInput;
};


export type MutationSetTransformationParamsArgs = {
  input: SetTransformationParamsInput;
};


export type MutationSetTransformationTypeArgs = {
  input: SetTransformationTypeInput;
};


export type MutationSetTransitionDestinationArgs = {
  input: SetTransitionDestinationInput;
};


export type MutationSetTriggerDataPointDefinitionArgs = {
  input: SetTriggerDataPointDefinitionInput;
};


export type MutationSetTriggerDelayArgs = {
  input: SetTriggerDelayInput;
};


export type MutationSetTriggerSettingsArgs = {
  input: SetTriggerSettingsInput;
};


export type MutationSetTriggerStepArgs = {
  input: SetTriggerStepInput;
};


export type MutationSetTriggerTimerDataPointDefinitionArgs = {
  input: SetTriggerTimerDataPointDefinitionInput;
};


export type MutationSetTriggerTimerStepArgs = {
  input: SetTriggerTimerStepInput;
};


export type MutationSetTriggerTimerTrackArgs = {
  input: SetTriggerTimerTrackInput;
};


export type MutationSetTriggerTimerTypeArgs = {
  input: SetTriggerTimerTypeInput;
};


export type MutationSetTriggerTrackArgs = {
  input: SetTriggerTrackInput;
};


export type MutationSetTriggerTypeArgs = {
  input: SetTriggerTypeInput;
};


export type MutationShareFormsArgs = {
  input: ShareFormsInput;
};


export type MutationSharePathwaysArgs = {
  input: SharePathwaysInput;
};


export type MutationStartPreviewArgs = {
  input: StartPreviewInput;
};


export type MutationStartTrackFromStepArgs = {
  input: StartTrackFromStepInput;
};


export type MutationStartTransitionFromStepArgs = {
  input: StartTransitionFromStepInput;
};


export type MutationSubmitChecklistArgs = {
  input: SubmitChecklistInput;
};


export type MutationSubmitFormResponseArgs = {
  input: SubmitFormResponseInput;
};


export type MutationTestCareFlowSourceControlSettingsArgs = {
  input: TestSourceControlInput;
};


export type MutationTestCodeBlockArgs = {
  input: TestCodeBlockInput;
};


export type MutationTransferPathwayArgs = {
  input: TransferPathwayInput;
};


export type MutationTrashPathwayArgs = {
  input: TrashPathwayInput;
};


export type MutationTriggerApiCallArgs = {
  input: TriggerApiCallInput;
};


export type MutationUpdateAgentConfigArgs = {
  input: UpdateAgentConfigInput;
};


export type MutationUpdateApiCallMappingDataPointArgs = {
  input: UpdateApiCallMappingDataPointInput;
};


export type MutationUpdateApiCallMappingFirstMatchOnlyArgs = {
  input: UpdateApiCallMappingFirstMatchOnlyInput;
};


export type MutationUpdateApiCallMappingKeyArgs = {
  input: UpdateApiCallMappingKeyInput;
};


export type MutationUpdateCareFlowApiCallRetrySettingsArgs = {
  input: UpdateCareFlowApiCallRetrySettingsInput;
};


export type MutationUpdateCareFlowSourceControlSettingsArgs = {
  input: UpdateCareFlowSourceControlSettingsInput;
};


export type MutationUpdateClinicalNoteContextArgs = {
  input: UpdateClinicalNoteContextInput;
};


export type MutationUpdateClinicalNoteNarrativeBodyArgs = {
  input: UpdateClinicalNoteNarrativeBodyInput;
};


export type MutationUpdateConstantArgs = {
  input: UpdateConstantInput;
};


export type MutationUpdateDataPointDefinitionArgs = {
  input: UpdateDataPointDefinitionInput;
};


export type MutationUpdateDynamicVariableArgs = {
  input: UpdateDynamicVariableInput;
};


export type MutationUpdateEmailNotificationStatusArgs = {
  input: UpdateEmailNotificationStatusInput;
};


export type MutationUpdateLabelTextArgs = {
  input: UpdateLabelTextInput;
};


export type MutationUpdateLogicConfigArgs = {
  input: UpdateLogicConfigInput;
};


export type MutationUpdateLogicNameArgs = {
  input: UpdateLogicNameInput;
};


export type MutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};


export type MutationUpdateStickyNoteBodyArgs = {
  input: UpdateStickyNoteBodyInput;
};


export type MutationUpdateTimerConfigArgs = {
  input: UpdateTimerConfigInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUpdateWebhookEndpointArgs = {
  input: UpdateWebhookEndpointInput;
};


export type MutationUpdateWebhookHeadersArgs = {
  input: UpdateWebhookHeadersInput;
};


export type MutationUpdateWebhookNameArgs = {
  input: UpdateWebhookNameInput;
};


export type MutationUpdateWebhookStatusArgs = {
  input: UpdateWebhookStatusInput;
};


export type MutationUpdateWebhookSubscribedEventsArgs = {
  input: UpdateWebhookSubscribedEventsInput;
};


export type MutationUpdateWebhookTestEndpointArgs = {
  input: UpdateWebhookTestEndpointInput;
};

export type NewConstantInput = {
  label: Scalars['String']['input'];
  obfuscated: Scalars['Boolean']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type NewMappingDataPointDefinitionInput = {
  key: Scalars['String']['input'];
  valueType: DataPointValueType;
};

export type NewWebhookInput = {
  enabled?: Scalars['Boolean']['input'];
  endpoint: Scalars['String']['input'];
  endpoint_test?: InputMaybe<Scalars['String']['input']>;
  headers?: Array<WebhookHeaderInput>;
  name: Scalars['String']['input'];
  subscribed_events?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotSupportedExtensionAction = {
  __typename?: 'NotSupportedExtensionAction';
  action: UsageContext;
  step: UsageContext;
  track: UsageContext;
};

export type NumberConfig = {
  __typename?: 'NumberConfig';
  range?: Maybe<RangeConfig>;
};

export type NumberConfigInput = {
  /** The range configuration limits the acceptable numerical answers for the question. */
  range?: InputMaybe<NumberRangeConfigInput>;
};

export type NumberQuestionConfigInput = {
  /** The number-specific configuration for the question. */
  number: NumberConfigInput;
};

export type NumberRangeConfigInput = {
  /** Enable this flag to limit the acceptable numerical answers for the question. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum acceptable numerical answer for the question. */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum acceptable numerical answer for the question. */
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type NumericArrayField = ExtensionActionField & {
  __typename?: 'NumericArrayField';
  description?: Maybe<Scalars['String']['output']>;
  dropdownOptions?: Maybe<Array<ExtensionDropdownOption>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
  /** Value is kept as string because it can contain data point definition id in handlebars template, otherwise it is just "array of numbers" */
  value?: Maybe<Scalars['String']['output']>;
};

export type NumericField = ExtensionActionField & {
  __typename?: 'NumericField';
  description?: Maybe<Scalars['String']['output']>;
  dropdownOptions?: Maybe<Array<ExtensionDropdownOption>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
  /** Value is kept as string because it can contain data point definition id in handlebars template, otherwise it is just "number" */
  value?: Maybe<Scalars['String']['output']>;
};

export type OntologyEdge = {
  __typename?: 'OntologyEdge';
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
  type: OntologyEdgeType;
};

export enum OntologyEdgeType {
  Contains = 'CONTAINS',
  HasChildResource = 'HAS_CHILD_RESOURCE',
  HasProperty = 'HAS_PROPERTY',
  References = 'REFERENCES'
}

export type OntologyNode = {
  __typename?: 'OntologyNode';
  actionable_properties?: Maybe<Array<OntologyNode>>;
  children?: Maybe<Array<OntologyNode>>;
  id: Scalars['String']['output'];
  /** Plain text representation of this node */
  text: Scalars['String']['output'];
  type: OntologyNodeType;
  valueType?: Maybe<DataPointValueType>;
};

export type OntologyNodePayload = Payload & {
  __typename?: 'OntologyNodePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  node?: Maybe<OntologyNode>;
  success: Scalars['Boolean']['output'];
};

export enum OntologyNodeType {
  Action = 'Action',
  ActionableProperty = 'ActionableProperty',
  CareFlow = 'CareFlow',
  ObservationDefinition = 'ObservationDefinition',
  ObservationDefinitionComponent = 'ObservationDefinitionComponent',
  Questionnaire = 'Questionnaire',
  QuestionnaireItem = 'QuestionnaireItem',
  SemanticProperty = 'SemanticProperty',
  Step = 'Step',
  Track = 'Track'
}

export type OntologyPayload = Payload & {
  __typename?: 'OntologyPayload';
  code: Scalars['String']['output'];
  edges: Array<OntologyEdge>;
  error?: Maybe<ErrorObject>;
  nodes: Array<OntologyNode>;
  success: Scalars['Boolean']['output'];
};

export enum OntologyResourceType {
  Action = 'Action',
  CareFlow = 'CareFlow',
  ObservationDefinition = 'ObservationDefinition',
  ObservationDefinitionComponent = 'ObservationDefinitionComponent',
  Step = 'Step',
  Track = 'Track'
}

export type Operand = {
  __typename?: 'Operand';
  type: ConditionOperandType;
  value: Scalars['String']['output'];
};

export type OperandInput = {
  type: ConditionOperandType;
  value: Scalars['String']['input'];
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OptionInput = {
  /** The ID of the option. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The label of the option which will be displayed to the user. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The value of the option which will be saved as a data point. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OutputColumn = {
  __typename?: 'OutputColumn';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OutputColumnInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type PaginationAndSortingPayload = {
  code: Scalars['String']['output'];
  pagination?: Maybe<PaginationOutput>;
  sorting?: Maybe<SortingOutput>;
  success: Scalars['Boolean']['output'];
};

export type PaginationOutput = {
  __typename?: 'PaginationOutput';
  count?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PaginationParams = {
  count: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/**
 *
 *   A pathway is a set of tracks.
 *   Transitions join tracks together (see definition of a transition at |TBD|)
 *   A pathway starts with a start node and ends with an end nodeS
 *
 *   A patient in a pathway generates a pathway instance
 *
 */
export type Pathway = {
  __typename?: 'Pathway';
  builder_summary?: Maybe<Scalars['JSON']['output']>;
  care_team_summary?: Maybe<Scalars['JSON']['output']>;
  created: AuditTrail;
  custom_actions?: Maybe<Array<CustomAction>>;
  id: Scalars['ID']['output'];
  isReadOnlyRecommended?: Maybe<Scalars['Boolean']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_read_only?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Label>>;
  last_published_version?: Maybe<PathwayVersion>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  patient_journey_diagram?: Maybe<Scalars['JSON']['output']>;
  publishing_status: PublishingStatus;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  settings?: Maybe<PathwaySettings>;
  stakeholders: Array<Stakeholder>;
  summary_hash?: Maybe<Scalars['String']['output']>;
  summary_status?: Maybe<Scalars['String']['output']>;
  summary_status_updated_at?: Maybe<Scalars['String']['output']>;
  team_ids?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  track_ids?: Maybe<Array<Scalars['String']['output']>>;
  tracks?: Maybe<Array<Track>>;
  trashed?: Maybe<Trashed>;
  triggers: Array<Trigger>;
};

/** A pathway case, potentially including any activities and swimlanes. */
export type PathwayCase = {
  __typename?: 'PathwayCase';
  activities: Array<Activity>;
  created_by: PathwayCollaborator;
  id: Scalars['ID']['output'];
  last_modification_date?: Maybe<Scalars['SafeDate']['output']>;
  last_modified_by?: Maybe<PathwayCollaborator>;
  pathway_id: Scalars['String']['output'];
  start_date?: Maybe<Scalars['SafeDate']['output']>;
  status: PathwayCaseStatus;
  title: Scalars['String']['output'];
};

export type PathwayCaseApiCall = {
  __typename?: 'PathwayCaseApiCall';
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  request: ApiCallRequest;
  responses: Array<ApiCallResponse>;
  status: ApiCallStatus;
  title: Scalars['String']['output'];
};

export type PathwayCaseApiCallPayload = Payload & {
  __typename?: 'PathwayCaseApiCallPayload';
  api_call: PathwayCaseApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type PathwayCaseApiCallsPayload = Payload & {
  __typename?: 'PathwayCaseApiCallsPayload';
  api_calls: Array<PathwayCaseApiCall>;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type PathwayCasePayload = Payload & {
  __typename?: 'PathwayCasePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_case: PathwayCase;
  success: Scalars['Boolean']['output'];
};

export enum PathwayCaseStatus {
  Active = 'ACTIVE',
  Blank = 'BLANK',
  Completed = 'COMPLETED',
  MissingBaselineDatapoints = 'MISSING_BASELINE_DATAPOINTS',
  WaitingForManualTrigger = 'WAITING_FOR_MANUAL_TRIGGER'
}

export type PathwayCaseStepActivitiesInput = {
  pathway_case_id: Scalars['String']['input'];
  step_id: Scalars['String']['input'];
};

/** A summary of a pathway case, which excludes activities (and swimlanes). Used for list views. */
export type PathwayCaseSummary = {
  __typename?: 'PathwayCaseSummary';
  created_by: PathwayCollaborator;
  id: Scalars['ID']['output'];
  last_modification_date?: Maybe<Scalars['SafeDate']['output']>;
  last_modified_by?: Maybe<PathwayCollaborator>;
  pathway_id: Scalars['String']['output'];
  start_date?: Maybe<Scalars['SafeDate']['output']>;
  status: PathwayCaseStatus;
  title: Scalars['String']['output'];
};

export type PathwayCaseWebhookCall = {
  __typename?: 'PathwayCaseWebhookCall';
  created_at: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pathway?: Maybe<ApiPathwayContext>;
  request: WebhookCallRequest;
  responses: Array<WebhookCallResponse>;
  status: Scalars['String']['output'];
  webhook_id: Scalars['String']['output'];
  webhook_name: Scalars['String']['output'];
};

export type PathwayCaseWebhookCallPayload = Payload & {
  __typename?: 'PathwayCaseWebhookCallPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhook_call: PathwayCaseWebhookCall;
};

export type PathwayCaseWebhookCallsPayload = Payload & {
  __typename?: 'PathwayCaseWebhookCallsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhook_calls: Array<PathwayCaseWebhookCall>;
};

export type PathwayCasesInput = {
  pathway_id: Scalars['String']['input'];
};

export type PathwayCasesPayload = Payload & {
  __typename?: 'PathwayCasesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_cases: Array<PathwayCaseSummary>;
  success: Scalars['Boolean']['output'];
};

export type PathwayCollaborator = {
  __typename?: 'PathwayCollaborator';
  user_email?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type PathwayComponentLink = {
  __typename?: 'PathwayComponentLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PathwayContext = {
  __typename?: 'PathwayContext';
  action_id?: Maybe<Scalars['String']['output']>;
  agent_config_id?: Maybe<Scalars['String']['output']>;
  agent_id?: Maybe<Scalars['String']['output']>;
  agent_thread_id?: Maybe<Scalars['String']['output']>;
  instance_id: Scalars['String']['output'];
  pathway_id: Scalars['String']['output'];
  run_id?: Maybe<Scalars['String']['output']>;
  step_id?: Maybe<Scalars['String']['output']>;
  track_id?: Maybe<Scalars['String']['output']>;
};

/**
 *
 * Diff between two care flows. Used to help understand how care flows have changed over time.
 *
 */
export type PathwayDiff = {
  __typename?: 'PathwayDiff';
  newPathway?: Maybe<Scalars['String']['output']>;
  oldPathway?: Maybe<Scalars['String']['output']>;
};

export type PathwayDiffPayload = Payload & {
  __typename?: 'PathwayDiffPayload';
  code: Scalars['String']['output'];
  diff: PathwayDiff;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type PathwayPayload = Payload & {
  __typename?: 'PathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type PathwaySettings = {
  __typename?: 'PathwaySettings';
  allow_email_notifications?: Maybe<Scalars['Boolean']['output']>;
  api_call_retry_settings?: Maybe<ApiCallRetrySettings>;
  branding?: Maybe<BrandingSettings>;
  constants?: Maybe<Array<Constant>>;
  dashboard_ids?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  reminders?: Maybe<RemindersSettings>;
  source_control?: Maybe<SourceControlSettings>;
  stakeholder_notification_language?: Maybe<Scalars['String']['output']>;
  stakeholders?: Maybe<Array<StakeholderEmail>>;
  webhooks?: Maybe<Array<Webhook>>;
};

export type PathwaySettingsPayload = Payload & {
  __typename?: 'PathwaySettingsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type PathwayStartedActivationReference = TriggerActivationReference & {
  __typename?: 'PathwayStartedActivationReference';
  type?: Maybe<TriggerActivationReferenceType>;
};

export type PathwayStartedActivationReferenceInput = {
  type: TriggerActivationReferenceType;
};

export type PathwayStartedTriggerSettings = TriggerSettings & {
  __typename?: 'PathwayStartedTriggerSettings';
  rule?: Maybe<Rule>;
  type?: Maybe<TriggerType>;
};

export type PathwayTriggersPayload = {
  __typename?: 'PathwayTriggersPayload';
  triggers: Array<Trigger>;
};

export type PathwayValidationStatus = {
  __typename?: 'PathwayValidationStatus';
  components: Array<PathwayValidationStatusComponent>;
  status: PathwayValidationStatusType;
};

export type PathwayValidationStatusComponent = {
  __typename?: 'PathwayValidationStatusComponent';
  id: Scalars['String']['output'];
  link?: Maybe<PathwayComponentLink>;
  reason?: Maybe<InvalidStatusReason>;
  status: PathwayValidationStatusType;
  type: PathwayValidationStatusComponentType;
};

export enum PathwayValidationStatusComponentType {
  Cycle = 'CYCLE',
  DefinitionNavigationGraph = 'DEFINITION_NAVIGATION_GRAPH',
  Rule = 'RULE',
  Transition = 'TRANSITION',
  Trigger = 'TRIGGER'
}

export type PathwayValidationStatusPayload = Payload & {
  __typename?: 'PathwayValidationStatusPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  status: PathwayValidationStatus;
  success: Scalars['Boolean']['output'];
};

export enum PathwayValidationStatusReasonType {
  CycleDetected = 'CYCLE_DETECTED',
  Duplicate = 'DUPLICATE',
  IncompleteCondition = 'INCOMPLETE_CONDITION',
  IncompleteTiming = 'INCOMPLETE_TIMING',
  InvalidTrigger = 'INVALID_TRIGGER',
  MissingActions = 'MISSING_ACTIONS',
  MissingDestination = 'MISSING_DESTINATION',
  MissingPathwayStartedTrigger = 'MISSING_PATHWAY_STARTED_TRIGGER',
  MissingSteps = 'MISSING_STEPS',
  MissingTrigger = 'MISSING_TRIGGER',
  NotFound = 'NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export enum PathwayValidationStatusType {
  Error = 'ERROR',
  Valid = 'VALID',
  Warning = 'WARNING'
}

/**
 *
 *   Pathway Version stores information related to publishing.
 *   It contains version/publish information of all components (Pathway/Step/Transition)
 *   in a pathway.
 *
 */
export type PathwayVersion = {
  __typename?: 'PathwayVersion';
  checkpoint_id?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<FormattedText>;
  commit_link?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['SafeDate']['output'];
  created_by: PathwayCollaborator;
  id: Scalars['ID']['output'];
  version: Scalars['Float']['output'];
  version_status: VersionStatus;
};

export type PathwayVersionPayload = Payload & {
  __typename?: 'PathwayVersionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  version: PathwayVersion;
};

export type PathwayVersionsPayload = Payload & {
  __typename?: 'PathwayVersionsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  versions: Array<PathwayVersion>;
};

export type PathwaysPayload = Payload & {
  __typename?: 'PathwaysPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathways: Array<Pathway>;
  success: Scalars['Boolean']['output'];
};

export type Payload = {
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type Permissions = {
  __typename?: 'Permissions';
  write: Scalars['Boolean']['output'];
};

export type PhoneConfig = {
  __typename?: 'PhoneConfig';
  available_countries?: Maybe<Array<Scalars['String']['output']>>;
  default_country?: Maybe<Scalars['String']['output']>;
};

export type PhoneConfigInput = {
  /** The available country codes for the phone number. */
  available_countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The default country code for the phone number. */
  default_country?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneQuestionConfigInput = {
  /** The phone-specific configuration for the question. */
  phone: PhoneConfigInput;
};

export type PluginActionSettingsProperty = {
  __typename?: 'PluginActionSettingsProperty';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PreviewClinicalNote = {
  __typename?: 'PreviewClinicalNote';
  context: Array<GeneratedClinicalNoteContextField>;
  id: Scalars['ID']['output'];
  narratives: Array<GeneratedClinicalNoteNarrative>;
};

export type PreviewEmrReport = {
  __typename?: 'PreviewEmrReport';
  id: Scalars['ID']['output'];
  message_html: Scalars['String']['output'];
  metadata?: Maybe<Array<EmrReportMetadataField>>;
};

export type PreviewExtensionActionInput = {
  action_key: Scalars['String']['input'];
  extension_key: Scalars['String']['input'];
  fields?: InputMaybe<Array<ExtensionFieldInput>>;
  pathway_id: Scalars['String']['input'];
  preview_label?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewExtensionActionPayload = Payload & {
  __typename?: 'PreviewExtensionActionPayload';
  code: Scalars['String']['output'];
  correlation_id: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type PreviewMessage = {
  __typename?: 'PreviewMessage';
  attachments?: Maybe<Array<MessageAttachment>>;
  body: Scalars['String']['output'];
  format?: Maybe<MessageFormat>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type PublishPathwayInput = {
  comments?: InputMaybe<FormattedTextInput>;
  pathway_id: Scalars['String']['input'];
};

export type PublishPathwayPayload = Payload & {
  __typename?: 'PublishPathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  published_version: PathwayVersion;
  success: Scalars['Boolean']['output'];
};

export enum PublishingStatus {
  HasUnpublishedChanges = 'HAS_UNPUBLISHED_CHANGES',
  NoUnpublishedChanges = 'NO_UNPUBLISHED_CHANGES'
}

export type PushToEmrAction = Action & {
  __typename?: 'PushToEmrAction';
  clinical_note_id?: Maybe<Scalars['ID']['output']>;
  created: AuditTrail;
  custom_fields?: Maybe<Array<CustomActionField>>;
  due_date?: Maybe<DueDate>;
  emr_report?: Maybe<EmrReport>;
  emr_report_id?: Maybe<Scalars['ID']['output']>;
  expiration?: Maybe<Expiration>;
  id: Scalars['ID']['output'];
  idle_time?: Maybe<Delay>;
  last_updated?: Maybe<AuditTrail>;
  locations?: Maybe<Array<Location>>;
  message_id?: Maybe<Scalars['ID']['output']>;
  plugin_key?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Stakeholder>;
  status: ConfigurationStatus;
  step: Step;
  title?: Maybe<Scalars['String']['output']>;
  type: ActionType;
};

export type Query = {
  __typename?: 'Query';
  action: ActionPayload;
  adHocTracks: TracksPayload;
  agent: AgentPayload;
  agents: AgentsPayload;
  ahp_link: AhpLinkPayload;
  ahp_links: AhpLinkPayloads;
  baseline_info: BaselineInfoPayload;
  calculation_results: CalculationResultPayload;
  calculations: CalculationsPayload;
  careFlowForms: FormsPayload;
  careflowCheckpoints?: Maybe<CheckpointsPayload>;
  careflow_components: CareflowComponentsPayload;
  clinical_note: ClinicalNotePayload;
  codeBlock?: Maybe<CodeBlockPayload>;
  codeBlockUsage: LogicsPayload;
  codeBlocks: CodeBlocksPayload;
  constant: ConstantPayload;
  constants: ConstantsPayload;
  data_catalog: DataCatalogPayload;
  data_catalog_collection_contexts: DataCatalogCollectionContextsPayload;
  /** Export data point definitions in JSON format */
  data_catalog_json: DataCatalogJsonPayload;
  data_point_definition: DataPointDefinitionPayload;
  data_point_definitions: DataPointDefinitionsPayload;
  decisionTable: DecisionTablePayload;
  decisionTableUsage: LogicsPayload;
  decisionTables: DecisionTablesPayload;
  decision_outputs: DecisionOutputsPayload;
  dynamic_variable: DynamicVariablePayload;
  dynamic_variables: DynamicVariablesPayload;
  emr_report: EmrReportPayload;
  enrollmentTriggers: EnrollmentTriggerPayload;
  evaluatedRule: EvaluatedRulePayload;
  events: DomainEventsPayload;
  extensionActivityRecord: ExtensionActivityRecordPayload;
  extension_configurations: ExtensionConfigurationsPayload;
  extensions: ExtensionsPayload;
  fileStorageConfigs: FileStorageConfigPayload;
  form: FormPayload;
  form_data_point_definitions: DataPointDefinitionsPayload;
  form_response: FormResponsePayload;
  forms: FormsPayload;
  generated_clinical_note: GeneratedClinicalNotePayload;
  generated_emr_report: GeneratedEmrReportPayload;
  generated_message: GeneratedMessagePayload;
  /** Get a specific node from the ontology */
  getOntologyNode: OntologyNodePayload;
  isPathwayReadyForPreview: PathwayValidationStatusPayload;
  is_slug_unique: IsSlugUniquePayload;
  jsonPathFromMockObject: JsonPathPayload;
  jsonSchema: SchemaPayload;
  listPathways: PathwaysPayload;
  locations: LocationsPayload;
  logic: LogicPayload;
  logics: LogicsPayload;
  message: MessagePayload;
  pathway: PathwayPayload;
  pathwayCaseActivities: ActivitiesPayload;
  pathwayCaseApiCall: PathwayCaseApiCallPayload;
  pathwayCaseApiCalls: PathwayCaseApiCallsPayload;
  pathwayCaseElements: ElementsPayload;
  pathwayCaseStepActivities: ActivitiesPayload;
  pathwayCaseTriggerActivation: TriggerActivationPayload;
  pathwayCaseTriggerActivations: TriggerActivationsPayload;
  pathwayCaseWebhookCall: PathwayCaseWebhookCallPayload;
  pathwayCaseWebhookCalls: PathwayCaseWebhookCallsPayload;
  pathwayDiffTree: PathwayDiffPayload;
  pathwayDiffs: PathwayDiffPayload;
  pathwayExtensions: ExtensionsPayload;
  pathwaySettings: PathwaySettingsPayload;
  pathwaySteps: StepsPayload;
  pathwayTriggers: PathwayTriggersPayload;
  pathway_case: PathwayCasePayload;
  pathway_cases: PathwayCasesPayload;
  pathway_version: PathwayVersionPayload;
  pathway_versions: PathwayVersionsPayload;
  pathways: PathwaysPayload;
  rule: RulePayload;
  /** Searches the ontology */
  searchOntology: OntologyPayload;
  stakeholders: StakeholdersPayload;
  step: StepPayload;
  stepLibrary: StepLibraryPayload;
  stepLibraryForPathway: StepLibraryPayload;
  steps: StepsPayload;
  stickyNote: StickyNotePayload;
  stickyNotes: StickyNotesPayload;
  tenant: TenantPayload;
  tenants: TenantsPayload;
  timer: TimerPayload;
  timers: TimersPayload;
  timing: TimingPayload;
  track: TrackPayload;
  transition: TransitionPayload;
  transitions: TransitionsPayload;
  user: UserPayload;
  webhook: WebhookPayload;
  webhookEndpoints: WebhookEndpointsPayload;
  workerAgentVersions: WorkerAgentsPayload;
  workerAgents: WorkerAgentsPayload;
};


export type QueryActionArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdHocTracksArgs = {
  pathway_definition_id: Scalars['String']['input'];
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentsArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryAhp_LinkArgs = {
  id: Scalars['String']['input'];
};


export type QueryAhp_LinksArgs = {
  careflow_id: Scalars['String']['input'];
};


export type QueryBaseline_InfoArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type QueryCalculation_ResultsArgs = {
  input: CalculationResultInput;
};


export type QueryCareFlowFormsArgs = {
  careflow_definition_id: Scalars['String']['input'];
};


export type QueryCareflowCheckpointsArgs = {
  careflow_id: Scalars['String']['input'];
};


export type QueryCareflow_ComponentsArgs = {
  id: Scalars['String']['input'];
};


export type QueryClinical_NoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryCodeBlockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCodeBlockUsageArgs = {
  code_block_id: Scalars['String']['input'];
};


export type QueryCodeBlocksArgs = {
  care_flow_definition_id: Scalars['String']['input'];
};


export type QueryConstantArgs = {
  input: ConstantInput;
};


export type QueryConstantsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryData_CatalogArgs = {
  input: DataCatalogInput;
};


export type QueryData_Catalog_Collection_ContextsArgs = {
  input: DataCatalogCollectionContextsInput;
};


export type QueryData_Catalog_JsonArgs = {
  input: DataCatalogInput;
};


export type QueryData_Point_DefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryData_Point_DefinitionsArgs = {
  input: DataPointDefinitionsInput;
};


export type QueryDecisionTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDecisionTableUsageArgs = {
  decision_table_id: Scalars['String']['input'];
};


export type QueryDecisionTablesArgs = {
  care_flow_definition_id: Scalars['String']['input'];
};


export type QueryDecision_OutputsArgs = {
  input: DecisionOutputsInput;
};


export type QueryDynamic_VariableArgs = {
  id: Scalars['String']['input'];
};


export type QueryDynamic_VariablesArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryEmr_ReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryEnrollmentTriggersArgs = {
  careflow_id: Scalars['String']['input'];
};


export type QueryEvaluatedRuleArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  input: EventsInput;
};


export type QueryExtensionActivityRecordArgs = {
  id: Scalars['String']['input'];
};


export type QueryExtension_ConfigurationsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryFormArgs = {
  id: Scalars['String']['input'];
};


export type QueryForm_Data_Point_DefinitionsArgs = {
  input: FormDataPointDefinitionsInput;
};


export type QueryForm_ResponseArgs = {
  input: FormResponseInput;
};


export type QueryFormsArgs = {
  careflow_definition_id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerated_Clinical_NoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryGenerated_Emr_ReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryGenerated_MessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOntologyNodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryIsPathwayReadyForPreviewArgs = {
  pathway_definition_id: Scalars['String']['input'];
};


export type QueryIs_Slug_UniqueArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryJsonPathFromMockObjectArgs = {
  jsonPath: Scalars['String']['input'];
  mockObject: Scalars['String']['input'];
};


export type QueryJsonSchemaArgs = {
  source: JsonSchemaSourceGraphqlTypeInput;
};


export type QueryLocationsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryLogicArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLogicsArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathwayArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathwayCaseActivitiesArgs = {
  pagination?: InputMaybe<PaginationParams>;
  pathway_case_id: Scalars['String']['input'];
  sorting?: InputMaybe<SortingParams>;
};


export type QueryPathwayCaseApiCallArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathwayCaseApiCallsArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type QueryPathwayCaseElementsArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type QueryPathwayCaseStepActivitiesArgs = {
  input: PathwayCaseStepActivitiesInput;
};


export type QueryPathwayCaseTriggerActivationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathwayCaseTriggerActivationsArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type QueryPathwayCaseWebhookCallArgs = {
  webhook_call_id: Scalars['String']['input'];
};


export type QueryPathwayCaseWebhookCallsArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type QueryPathwayDiffTreeArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryPathwayDiffsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryPathwayExtensionsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryPathwaySettingsArgs = {
  input: Scalars['String']['input'];
};


export type QueryPathwayStepsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryPathwayTriggersArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryPathway_CaseArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationParams>;
  sorting?: InputMaybe<SortingParams>;
};


export type QueryPathway_CasesArgs = {
  input: PathwayCasesInput;
};


export type QueryPathway_VersionArgs = {
  id: Scalars['String']['input'];
};


export type QueryPathway_VersionsArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryRuleArgs = {
  id: Scalars['String']['input'];
};


export type QuerySearchOntologyArgs = {
  args: SearchOntologyArgs;
};


export type QueryStepArgs = {
  id: Scalars['String']['input'];
};


export type QueryStepLibraryForPathwayArgs = {
  pathway_id: Scalars['String']['input'];
};


export type QueryStepsArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryStickyNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryStickyNotesArgs = {
  input: StickyNotesInput;
};


export type QueryTimerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimersArgs = {
  track_id: Scalars['String']['input'];
};


export type QueryTimingArgs = {
  id: Scalars['String']['input'];
};


export type QueryTrackArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryTransitionsArgs = {
  input: TransitionsInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWebhookArgs = {
  input: WebhookInput;
};


export type QueryWorkerAgentVersionsArgs = {
  agent_uuid: Scalars['String']['input'];
};

export type Question = {
  __typename?: 'Question';
  dataPointValueType?: Maybe<DataPointValueType>;
  form_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** A short display name for the question. Used as the card label for description fields. */
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<FormattedJson>;
  options?: Maybe<Array<Option>>;
  questionConfig?: Maybe<QuestionConfig>;
  questionType?: Maybe<QuestionType>;
  rule_id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The HTML version of the question title. Applicable for description questions. */
  title_html?: Maybe<Scalars['String']['output']>;
  userQuestionType?: Maybe<UserQuestionType>;
};

export type QuestionConfig = {
  __typename?: 'QuestionConfig';
  date?: Maybe<DateConfig>;
  file_storage?: Maybe<FileStorageQuestionConfig>;
  input_validation?: Maybe<InputValidationConfig>;
  mandatory: Scalars['Boolean']['output'];
  multiple_select?: Maybe<MultipleSelectConfig>;
  number?: Maybe<NumberConfig>;
  phone?: Maybe<PhoneConfig>;
  recode_enabled?: Maybe<Scalars['Boolean']['output']>;
  slider?: Maybe<SliderConfig>;
  use_select?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionConfigInput = {
  /** Enable this flag to make the question mandatory. */
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable this flag to use a select input when this questionnaire is rendered in a hosted sesion or in Care. */
  use_select?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionInput = {
  /** The key of the question. */
  key: Scalars['String']['input'];
  /** Additional metadata for the question as a FormattedJson object. */
  metadata?: InputMaybe<FormattedJsonInput>;
  /** The value type of the question options. Only applicable for multiple choice and multiple select questions. */
  option_value_type?: InputMaybe<Scalars['String']['input']>;
  /** The options for the question. Only applicable for multiple choice and multiple select questions. */
  options?: InputMaybe<Array<OptionInput>>;
  /** The title of the question. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The HTML version of the question title (for rich text formatting). */
  title_html?: InputMaybe<Scalars['String']['input']>;
  /** The type of the question. */
  user_question_type: UserQuestionType;
};

export type QuestionResponseInput = {
  question_id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type QuestionRuleResult = {
  __typename?: 'QuestionRuleResult';
  question_id: Scalars['String']['output'];
  rule_id: Scalars['String']['output'];
  satisfied: Scalars['Boolean']['output'];
};

export enum QuestionType {
  Input = 'INPUT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  NoInput = 'NO_INPUT'
}

export type Range = {
  __typename?: 'Range';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type RangeConfig = {
  __typename?: 'RangeConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type ReadMessageInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
  subject: SubjectInput;
};

export type ReadMessagePayload = Payload & {
  __typename?: 'ReadMessagePayload';
  activity: Activity;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RebuildGraphStatus = {
  __typename?: 'RebuildGraphStatus';
  event_count: Scalars['Float']['output'];
  pathway_definition_id: Scalars['String']['output'];
  replayed_count: Scalars['Float']['output'];
};

export type RebuildInput = {
  pathway_id?: InputMaybe<Scalars['String']['input']>;
};

export type RebuildViewModelError = {
  __typename?: 'RebuildViewModelError';
  error: Error;
  event: Scalars['String']['output'];
  id: Scalars['String']['output'];
  projection_name: Scalars['String']['output'];
};

export type RebuildViewModelStatus = {
  __typename?: 'RebuildViewModelStatus';
  event_count: Scalars['Float']['output'];
  event_id: Scalars['String']['output'];
  replayed_count: Scalars['Float']['output'];
};

export type RebuildViewModelsPayload = Payload & {
  __typename?: 'RebuildViewModelsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  event_count: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export type RefreshExtensionInput = {
  extension_key: Scalars['String']['input'];
  pathway_id: Scalars['ID']['input'];
};

export type RefreshExtensionPayload = Payload & {
  __typename?: 'RefreshExtensionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  not_supported_actions?: Maybe<Array<NotSupportedExtensionAction>>;
  success: Scalars['Boolean']['output'];
};

export type ReminderDelayInput = {
  amount: Scalars['Float']['input'];
  unit: DelayUnitType;
};

export type RemindersSettings = {
  __typename?: 'RemindersSettings';
  amount: Scalars['Float']['output'];
  delay: Delay;
};

export type RemoveActionFromStepInput = {
  action_id: Scalars['String']['input'];
  step_id: Scalars['String']['input'];
};

export type RemoveActionFromStepPayload = Payload & {
  __typename?: 'RemoveActionFromStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type RemoveClinicalNoteNarrativeInput = {
  clinical_note_id: Scalars['String']['input'];
  narrative_id: Scalars['String']['input'];
};

export type RemoveClinicalNoteNarrativePayload = Payload & {
  __typename?: 'RemoveClinicalNoteNarrativePayload';
  clinical_note: ClinicalNote;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RemoveConditionFromRuleInput = {
  condition_id: Scalars['String']['input'];
  rule_id: Scalars['String']['input'];
};

export type RemoveConditionFromRulePayload = Payload & {
  __typename?: 'RemoveConditionFromRulePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type RemoveConstantInput = {
  constant_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type RemoveConstantPayload = Payload & {
  __typename?: 'RemoveConstantPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type RemoveDataPointDefinitionFromPathwayInput = {
  data_point_definition_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type RemoveDataPointMappingFromExtensionActionInput = {
  action_id: Scalars['String']['input'];
  mapping_id: Scalars['String']['input'];
};

export type RemoveDataPointMappingFromExtensionActionPayload = Payload & {
  __typename?: 'RemoveDataPointMappingFromExtensionActionPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RemoveDynamicVariableInput = {
  dynamic_variable_id: Scalars['String']['input'];
};

export type RemoveExtensionConfigurationInput = {
  extension_key: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type RemoveLabelsFromStepInput = {
  step_id: Scalars['String']['input'];
};

export type RemoveLabelsFromStepPayload = Payload & {
  __typename?: 'RemoveLabelsFromStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type RemoveMappingFromApiCallInput = {
  api_call_id: Scalars['String']['input'];
  mapping_id: Scalars['String']['input'];
};

export type RemoveMappingFromApiCallPayload = Payload & {
  __typename?: 'RemoveMappingFromApiCallPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RemoveMessageAttachmentInput = {
  attachment_id: Scalars['String']['input'];
  message_id: Scalars['String']['input'];
};

export type RemoveQuestionFromFormInput = {
  /** The ID of the form to remove the question from. */
  form_id: Scalars['String']['input'];
  /** The ID of the question to remove from the form. */
  question_id: Scalars['String']['input'];
};

export type RemoveQuestionFromFormPayload = Payload & {
  __typename?: 'RemoveQuestionFromFormPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type RemoveRuleFromQuestionInput = {
  form_id: Scalars['String']['input'];
  question_id: Scalars['String']['input'];
};

export type RemoveRuleFromQuestionPayload = Payload & {
  __typename?: 'RemoveRuleFromQuestionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type RemoveStepFromLibraryInput = {
  step_id: Scalars['String']['input'];
};

export type RemoveStepFromTrackInput = {
  step_id: Scalars['String']['input'];
};

export type RemoveStepFromTrackPayload = Payload & {
  __typename?: 'RemoveStepFromTrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type RemoveStickyNoteFromTrackInput = {
  sticky_note_id: Scalars['String']['input'];
};

export type RemoveTrackFromPathwayInput = {
  pathway_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type RemoveTrackFromPathwayPayload = Payload & {
  __typename?: 'RemoveTrackFromPathwayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type RemoveTransformationsFromDynamicVariableInput = {
  dynamic_variable_id: Scalars['String']['input'];
  transformation_ids: Array<Scalars['String']['input']>;
};

export type RemoveTransformationsFromDynamicVariablePayload = Payload & {
  __typename?: 'RemoveTransformationsFromDynamicVariablePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RemoveTransitionInput = {
  track_id: Scalars['String']['input'];
  transition_id: Scalars['String']['input'];
};

export type RemoveTransitionPayload = Payload & {
  __typename?: 'RemoveTransitionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type RemoveTriggerFromPathwayInput = {
  trigger_id: Scalars['String']['input'];
};

export type RemoveTriggerFromTrackInput = {
  trigger_id: Scalars['String']['input'];
};

export type RemoveTriggerTimerInput = {
  timer_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type RemoveWebhookInput = {
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type RemoveWebhookPayload = Payload & {
  __typename?: 'RemoveWebhookPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type ReorderActionsInput = {
  action_ids: Array<Scalars['String']['input']>;
  step_id: Scalars['String']['input'];
};

export type ReorderActionsPayload = Payload & {
  __typename?: 'ReorderActionsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type ReorderMessageAttachmentsInput = {
  attachments: Array<MessageAttachmentInput>;
  message_id: Scalars['String']['input'];
};

export type ReorderQuestionsInput = {
  /** The ID of the form to reorder the questions in. */
  form_id: Scalars['String']['input'];
  /** The ID of the question that should be before the reordered question. */
  previous_question_id?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the question to reorder. */
  question_id: Scalars['String']['input'];
};

export type ReorderQuestionsPayload = Payload & {
  __typename?: 'ReorderQuestionsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type RepairPathwaysInput = {
  pathway_id?: InputMaybe<Scalars['String']['input']>;
};

export type RepairPathwaysPayload = Payload & {
  __typename?: 'RepairPathwaysPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_count: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export type RepairPathwaysStatus = {
  __typename?: 'RepairPathwaysStatus';
  pathway_count: Scalars['Float']['output'];
  repaired_count: Scalars['Float']['output'];
};

export type ResetPatientProfileDataPointDefinitionsInput = {
  pathway_id?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPreviewInput = {
  pathway_case_id: Scalars['String']['input'];
};

export type ResetPreviewPayload = Payload & {
  __typename?: 'ResetPreviewPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_case: PathwayCase;
  success: Scalars['Boolean']['output'];
};

export type RestoreCheckpointInput = {
  checkpoint_id: Scalars['String']['input'];
};

export type RetryAllFailedWebhookCallsInput = {
  pathway_id: Scalars['String']['input'];
};

export type RetryAllWebhookCallsInput = {
  pathway_id: Scalars['String']['input'];
};

export type RetryApiCallInput = {
  api_call_id: Scalars['String']['input'];
};

export type RetryWebhookCallInput = {
  webhook_call_id: Scalars['String']['input'];
};

export type RetryWebhookCallPayload = Payload & {
  __typename?: 'RetryWebhookCallPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhook_call: WebhookCall;
};

export type RoundToParameters = {
  __typename?: 'RoundToParameters';
  nbr_decimals?: Maybe<Scalars['Float']['output']>;
};

export type RoundToTransformation = Transformation & {
  __typename?: 'RoundToTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<RoundToParameters>;
  type: TransformationType;
};

/**
 *
 *   A rule is mathematical expression that determines will the transition be executed.
 *   A rule contains a list of conditions and a boolean operator(AND or OR).
 *   Rule will be satisfied if any of the following:
 *    - when there are no conditions
 *    - when boolean operator AND is used and all conditions are satisfied
 *    - when boolean operator OR is used and at least 1 condition is satisfied
 *
 */
export type Rule = {
  __typename?: 'Rule';
  boolean_operator: BooleanOperator;
  conditions: Array<Condition>;
  id: Scalars['ID']['output'];
  status: ConfigurationStatus;
  type?: Maybe<RuleType>;
};

export type RulePayload = Payload & {
  __typename?: 'RulePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export enum RuleType {
  DataPointBased = 'DATA_POINT_BASED',
  OntologyBased = 'ONTOLOGY_BASED'
}

export type SaveCheckpointInput = {
  careflow_id: Scalars['String']['input'];
  description: FormattedTextInput;
};

export type SaveMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  message_id: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SchemaPayload = Payload & {
  __typename?: 'SchemaPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  schema: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SearchOntologyArgs = {
  filters?: InputMaybe<Array<FilterSearch>>;
  resource_type?: InputMaybe<OntologyResourceType>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SetActionCalculationIdInput = {
  action_id: Scalars['String']['input'];
  calculation_id: Scalars['String']['input'];
  calculation_language?: InputMaybe<Scalars['String']['input']>;
};

export type SetActionCalculationIdPayload = Payload & {
  __typename?: 'SetActionCalculationIdPayload';
  action: CalculationAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionCalculationInputPayload = Payload & {
  __typename?: 'SetActionCalculationInputPayload';
  action: CalculationAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionCalculationLanguageInput = {
  action_id: Scalars['String']['input'];
  calculation_language?: InputMaybe<Scalars['String']['input']>;
};

export type SetActionCalculationLanguagePayload = Payload & {
  __typename?: 'SetActionCalculationLanguagePayload';
  action: CalculationAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionChecklistItemsInput = {
  action_id: Scalars['String']['input'];
  checklist: Array<Scalars['String']['input']>;
};

export type SetActionChecklistItemsPayload = Payload & {
  __typename?: 'SetActionChecklistItemsPayload';
  action: ChecklistAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionDueDatePayload = Payload & {
  __typename?: 'SetActionDueDatePayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionExpirationPayload = Payload & {
  __typename?: 'SetActionExpirationPayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionFormDisplayModeInput = {
  action_id: Scalars['String']['input'];
  form_display_mode: Scalars['String']['input'];
};

export type SetActionFormDisplayModePayload = Payload & {
  __typename?: 'SetActionFormDisplayModePayload';
  action: FormAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionFormIdInput = {
  action_id: Scalars['String']['input'];
  form_id: Scalars['String']['input'];
};

export type SetActionFormIdPayload = Payload & {
  __typename?: 'SetActionFormIdPayload';
  action: FormAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionIdleTimeInput = {
  action_id: Scalars['String']['input'];
  idle_time?: InputMaybe<DelayInput>;
};

export type SetActionIdleTimePayload = Payload & {
  __typename?: 'SetActionIdleTimePayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionMessageIdInput = {
  action_id: Scalars['String']['input'];
  message_id: Scalars['String']['input'];
};

export type SetActionMessageIdPayload = Payload & {
  __typename?: 'SetActionMessageIdPayload';
  action: MessageAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionStakeholdersInput = {
  action_id: Scalars['String']['input'];
  stakeholder_ids: Array<Scalars['String']['input']>;
};

export type SetActionStakeholdersPayload = Payload & {
  __typename?: 'SetActionStakeholdersPayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetActionTitleInput = {
  action_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SetActionTitlePayload = Payload & {
  __typename?: 'SetActionTitlePayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetAgentCoordinatesInput = {
  agent_id: Scalars['String']['input'];
  coordinates: CoordinatesInput;
};

export type SetApiCallBodyInput = {
  api_call_id: Scalars['String']['input'];
  body: ApiCallBodyInput;
};

export type SetApiCallBodyPayload = Payload & {
  __typename?: 'SetApiCallBodyPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetApiCallEndpointInput = {
  api_call_id: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
};

export type SetApiCallEndpointPayload = Payload & {
  __typename?: 'SetApiCallEndpointPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetApiCallHeadersInput = {
  api_call_id: Scalars['String']['input'];
  headers: Array<ApiCallHeaderInput>;
};

export type SetApiCallHeadersPayload = Payload & {
  __typename?: 'SetApiCallHeadersPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetApiCallMethodInput = {
  api_call_id: Scalars['String']['input'];
  method: Scalars['String']['input'];
};

export type SetApiCallMethodPayload = Payload & {
  __typename?: 'SetApiCallMethodPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingAccentColorInput = {
  accent_color: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingAccentColorPayload = Payload & {
  __typename?: 'SetBrandingAccentColorPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingCustomThemeInput = {
  custom_theme: FormattedJsonInput;
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingCustomThemePayload = Payload & {
  __typename?: 'SetBrandingCustomThemePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingHostedPageAutoProgressInput = {
  hosted_page_auto_progress: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingHostedPageAutoProgressPayload = Payload & {
  __typename?: 'SetBrandingHostedPageAutoProgressPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingHostedPageAutosaveInput = {
  hosted_page_autosave: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingHostedPageAutosavePayload = Payload & {
  __typename?: 'SetBrandingHostedPageAutosavePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingHostedPageTitleInput = {
  hosted_page_title: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingHostedPageTitlePayload = Payload & {
  __typename?: 'SetBrandingHostedPageTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetBrandingLogoUrlInput = {
  logo_url: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetBrandingLogoUrlPayload = Payload & {
  __typename?: 'SetBrandingLogoUrlPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetCalculationDataPointInput = {
  action_id: Scalars['String']['input'];
  calculation_input_id: Scalars['String']['input'];
  data_point_definition_id: Scalars['String']['input'];
};

export type SetCalculationPrerequisiteFormInput = {
  action_id: Scalars['String']['input'];
  prerequisite_form_action_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SetCalculationPrerequisiteFormPayload = Payload & {
  __typename?: 'SetCalculationPrerequisiteFormPayload';
  action: CalculationAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetClinicalNoteNarrativeTitleInput = {
  clinical_note_id: Scalars['String']['input'];
  narrative_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SetConditionOperandInput = {
  condition_id: Scalars['String']['input'];
  operand: OperandInput;
  rule_id: Scalars['String']['input'];
};

export type SetConditionOperandPayload = Payload & {
  __typename?: 'SetConditionOperandPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type SetConditionOperatorInput = {
  condition_id: Scalars['String']['input'];
  operator: ConditionOperator;
  rule_id: Scalars['String']['input'];
};

export type SetConditionOperatorPayload = Payload & {
  __typename?: 'SetConditionOperatorPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type SetConditionReferenceInput = {
  condition_id: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  rule_id: Scalars['String']['input'];
};

export type SetConditionReferencePayload = Payload & {
  __typename?: 'SetConditionReferencePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type SetCustomActionFieldInput = {
  action_id: Scalars['String']['input'];
  custom_field: ActionCustomFieldInput;
};

export type SetCustomActionFieldPayload = Payload & {
  __typename?: 'SetCustomActionFieldPayload';
  action: Action;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDataPointDefinitionMetaDataFieldInput = {
  data_point_definition_id: Scalars['String']['input'];
  data_point_metadata: Array<DataPointMetaDataInputType>;
  pathway_id: Scalars['String']['input'];
};

export type SetDataPointDefinitionMetaDataFieldPayload = Payload & {
  __typename?: 'SetDataPointDefinitionMetaDataFieldPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDataPointDefinitionOptionalFieldInput = {
  data_point_definition_id: Scalars['String']['input'];
  optional: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetDataPointDefinitionOptionalFieldPayload = Payload & {
  __typename?: 'SetDataPointDefinitionOptionalFieldPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDataPointDefinitionPiiFieldInput = {
  data_point_definition_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  /** Personally identifiable information */
  pii: Scalars['Boolean']['input'];
};

export type SetDataPointDefinitionPiiFieldPayload = Payload & {
  __typename?: 'SetDataPointDefinitionPiiFieldPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDateQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: DateQuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetDateQuestionConfigPayload = Payload & {
  __typename?: 'SetDateQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetDynamicVariableDataPointDefinitionInput = {
  data_point_definition_id: Scalars['String']['input'];
  dynamic_variable_id: Scalars['String']['input'];
};

export type SetDynamicVariableDataPointDefinitionPayload = Payload & {
  __typename?: 'SetDynamicVariableDataPointDefinitionPayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDynamicVariableDataPointPropertyInput = {
  data_point_property: DataPointPropertyType;
  dynamic_variable_id: Scalars['String']['input'];
};

export type SetDynamicVariableDataPointPropertyPayload = Payload & {
  __typename?: 'SetDynamicVariableDataPointPropertyPayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDynamicVariableFallbackInput = {
  dynamic_variable_id: Scalars['String']['input'];
  fallback: Scalars['String']['input'];
};

export type SetDynamicVariableFallbackPayload = Payload & {
  __typename?: 'SetDynamicVariableFallbackPayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetDynamicVariableLabelInput = {
  dynamic_variable_id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type SetDynamicVariableLabelPayload = Payload & {
  __typename?: 'SetDynamicVariableLabelPayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetEmrReportBodyInput = {
  body: EmrBodyInput;
  emr_report_id: Scalars['String']['input'];
};

export type SetExtensionActionDataPointMappingDataPointInput = {
  action_id: Scalars['String']['input'];
  data_point_definition_id: Scalars['String']['input'];
  mapping_id: Scalars['String']['input'];
};

export type SetExtensionActionDataPointMappingDataPointPayload = Payload & {
  __typename?: 'SetExtensionActionDataPointMappingDataPointPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetExtensionActionDataPointMappingKeyInput = {
  action_id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mapping_id: Scalars['String']['input'];
};

export type SetExtensionActionDataPointMappingKeyPayload = Payload & {
  __typename?: 'SetExtensionActionDataPointMappingKeyPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetExtensionActionDataPointMappingsInput = {
  action_id: Scalars['String']['input'];
  mappings: Array<MappingDataPointDefinitionInput>;
};

export type SetExtensionActionDataPointMappingsPayload = Payload & {
  __typename?: 'SetExtensionActionDataPointMappingsPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetExtensionActionErrorHandlingInput = {
  action_id: Scalars['String']['input'];
  error_handling: ExtensionActionErrorHandlingInput;
};

export type SetExtensionActionErrorHandlingPayload = Payload & {
  __typename?: 'SetExtensionActionErrorHandlingPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetExtensionActionFieldInput = {
  action_id: Scalars['String']['input'];
  field: ExtensionActionFieldInput;
};

export type SetExtensionActionFieldPayload = Payload & {
  __typename?: 'SetExtensionActionFieldPayload';
  action: ExtensionAction;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetFileQuestionConfigPayload = Payload & {
  __typename?: 'SetFileQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetFormKeyInput = {
  /** The ID of the form to update. */
  form_id: Scalars['String']['input'];
  /** The new unique key for the form. */
  key: Scalars['String']['input'];
};

export type SetFormKeyPayload = Payload & {
  __typename?: 'SetFormKeyPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type SetFormMetadataInput = {
  form_id: Scalars['String']['input'];
  metadata: FormattedJsonInput;
};

export type SetFormMetadataPayload = Payload & {
  __typename?: 'SetFormMetadataPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type SetFormTitleInput = {
  /** The ID of the form to update. */
  form_id: Scalars['String']['input'];
  /** The new title for the form. */
  title: Scalars['String']['input'];
};

export type SetFormTitlePayload = Payload & {
  __typename?: 'SetFormTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type SetFormTrademarkInput = {
  form_id: Scalars['String']['input'];
  trademark: Scalars['String']['input'];
};

export type SetFormTrademarkPayload = Payload & {
  __typename?: 'SetFormTrademarkPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  form: Form;
  success: Scalars['Boolean']['output'];
};

export type SetInputValidationQuestionConfigPayload = Payload & {
  __typename?: 'SetInputValidationQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetLogicCoordinatesInput = {
  coordinates: CoordinatesInput;
  logic_id: Scalars['String']['input'];
};

export type SetLogicCoordinatesPayload = Payload & {
  __typename?: 'SetLogicCoordinatesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  logic: Logic;
  success: Scalars['Boolean']['output'];
};

export type SetMessageAttachmentNameInput = {
  attachment_id: Scalars['String']['input'];
  message_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SetMessageAttachmentUrlInput = {
  attachment_id: Scalars['String']['input'];
  message_id: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SetMessageBodyInput = {
  body: MessageBodyInput;
  message_id: Scalars['String']['input'];
};

export type SetMessageSubjectInput = {
  message_id: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SetMultipleSelectQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: MultipleSelectQuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetMultipleSelectQuestionConfigPayload = Payload & {
  __typename?: 'SetMultipleSelectQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetNumberQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: NumberQuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetNumberQuestionConfigPayload = Payload & {
  __typename?: 'SetNumberQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetPathwayCaseTitleInput = {
  pathway_case_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SetPathwayCaseTitlePayload = Payload & {
  __typename?: 'SetPathwayCaseTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_case: PathwayCase;
  success: Scalars['Boolean']['output'];
};

export type SetPathwayTitleInput = {
  pathway_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SetPathwayTitlePayload = Payload & {
  __typename?: 'SetPathwayTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type SetPhoneQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: PhoneQuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetPhoneQuestionConfigPayload = Payload & {
  __typename?: 'SetPhoneQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: QuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetQuestionConfigPayload = Payload & {
  __typename?: 'SetQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionKeyInput = {
  /** The ID of the form containing the question to update. */
  form_id: Scalars['String']['input'];
  /** The new unique key for the question. */
  key: Scalars['String']['input'];
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetQuestionKeyPayload = Payload & {
  __typename?: 'SetQuestionKeyPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionMetadataInput = {
  form_id: Scalars['String']['input'];
  metadata: FormattedJsonInput;
  question_id: Scalars['String']['input'];
};

export type SetQuestionMetadataPayload = Payload & {
  __typename?: 'SetQuestionMetadataPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionOptionValueTypeInput = {
  /** The new value type for the question. Only string and strings_array are supported. */
  dataPointValueType: DataPointValueType;
  /** The ID of the form containing the question to update. */
  form_id: Scalars['String']['input'];
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetQuestionOptionValueTypePayload = Payload & {
  __typename?: 'SetQuestionOptionValueTypePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionsConfigInput = {
  /** The ID of the form containing the questions to update. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the questions. */
  question_config: QuestionConfigInput;
  /** The IDs of the questions to update. */
  question_ids: Array<Scalars['String']['input']>;
};

export type SetQuestionsConfigPayload = Payload & {
  __typename?: 'SetQuestionsConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  questions: Array<Question>;
  success: Scalars['Boolean']['output'];
};

export type SetRemindersAmountInput = {
  amount: Scalars['Float']['input'];
  pathway_id: Scalars['String']['input'];
};

export type SetRemindersAmountPayload = Payload & {
  __typename?: 'SetRemindersAmountPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetRemindersDelayInput = {
  delay: ReminderDelayInput;
  pathway_id: Scalars['String']['input'];
};

export type SetRemindersDelayPayload = Payload & {
  __typename?: 'SetRemindersDelayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetRuleBooleanOperatorInput = {
  boolean_operator: BooleanOperator;
  rule_id: Scalars['String']['input'];
};

export type SetRuleBooleanOperatorPayload = Payload & {
  __typename?: 'SetRuleBooleanOperatorPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type SetRuleTypeInput = {
  rule_id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SetRuleTypePayload = Payload & {
  __typename?: 'SetRuleTypePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  rule: Rule;
  success: Scalars['Boolean']['output'];
};

export type SetSliderQuestionConfigInput = {
  /** The ID of the form the question to update belongs to. */
  form_id: Scalars['String']['input'];
  /** The new configuration for the question. */
  question_config: SliderQuestionConfigInput;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
};

export type SetSliderQuestionConfigPayload = Payload & {
  __typename?: 'SetSliderQuestionConfigPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type SetStakeholderEmailsInput = {
  language: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  stakeholders: Array<StakeholderEmailInput>;
};

export type SetStakeholderEmailsPayload = Payload & {
  __typename?: 'SetStakeholderEmailsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type SetStepCoordinatesInput = {
  coordinates: CoordinatesInput;
  step_id: Scalars['String']['input'];
};

export type SetStepCoordinatesPayload = Payload & {
  __typename?: 'SetStepCoordinatesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type SetStepDocumentationInput = {
  content: Scalars['String']['input'];
  format: Scalars['String']['input'];
  language: Language;
  step_id: Scalars['String']['input'];
};

export type SetStepDocumentationPayload = Payload & {
  __typename?: 'SetStepDocumentationPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type SetStepTitleInput = {
  step_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SetStepTitlePayload = Payload & {
  __typename?: 'SetStepTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export type SetStickyNoteCoordinatesInput = {
  coordinates: CoordinatesInput;
  sticky_note_id: Scalars['String']['input'];
};

export type SetStickyNoteCoordinatesPayload = Payload & {
  __typename?: 'SetStickyNoteCoordinatesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stickyNote: StickyNote;
  success: Scalars['Boolean']['output'];
};

export type SetTimerCoordinatesInput = {
  coordinates: CoordinatesInput;
  timer_id: Scalars['String']['input'];
};

export type SetTimerNameInput = {
  name: Scalars['String']['input'];
  timer_id: Scalars['String']['input'];
};

export type SetTimingDelayInput = {
  delay: DelayInput;
  timing_id: Scalars['String']['input'];
};

export type SetTimingDelayPayload = Payload & {
  __typename?: 'SetTimingDelayPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timing: Timing;
};

export type SetTimingReferenceInput = {
  reference: Scalars['String']['input'];
  timing_id: Scalars['String']['input'];
};

export type SetTimingReferencePayload = Payload & {
  __typename?: 'SetTimingReferencePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timing: Timing;
};

export type SetTrackDescriptionInput = {
  description: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type SetTrackDescriptionPayload = Payload & {
  __typename?: 'SetTrackDescriptionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type SetTrackEndCoordinatesInput = {
  coordinates: CoordinatesInput;
  track_id: Scalars['String']['input'];
};

export type SetTrackEndCoordinatesPayload = Payload & {
  __typename?: 'SetTrackEndCoordinatesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type SetTrackLoopConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  exit_condition?: InputMaybe<LoopExitConditionInput>;
  max_iterations?: InputMaybe<Scalars['Int']['input']>;
  track_id: Scalars['String']['input'];
};

export type SetTrackLoopConfigurationPayload = Payload & {
  __typename?: 'SetTrackLoopConfigurationPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type SetTrackStartCoordinatesInput = {
  coordinates: CoordinatesInput;
  track_id: Scalars['String']['input'];
};

export type SetTrackStartCoordinatesPayload = Payload & {
  __typename?: 'SetTrackStartCoordinatesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type SetTrackTitleInput = {
  title: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type SetTrackTitlePayload = Payload & {
  __typename?: 'SetTrackTitlePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  track: Track;
};

export type SetTransformationParamsInput = {
  dynamic_variable_id: Scalars['String']['input'];
  transformation_id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SetTransformationParamsPayload = Payload & {
  __typename?: 'SetTransformationParamsPayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetTransformationTypeInput = {
  dynamic_variable_id: Scalars['String']['input'];
  transformation_id: Scalars['String']['input'];
  type: TransformationType;
};

export type SetTransformationTypePayload = Payload & {
  __typename?: 'SetTransformationTypePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SetTransitionDestinationInput = {
  destination: DestinationInput;
  track_id: Scalars['String']['input'];
  transition_id: Scalars['String']['input'];
};

export type SetTransitionDestinationPayload = Payload & {
  __typename?: 'SetTransitionDestinationPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export type SetTriggerDataPointDefinitionInput = {
  data_point_definition_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerDelayInput = {
  delay: TriggerDelayInput;
  timer_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerSettingsInput = {
  event_based_settings: EventBasedTriggerSettingsInput;
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerStepInput = {
  step_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerTimerDataPointDefinitionInput = {
  data_point_definition_id: Scalars['String']['input'];
  timer_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerTimerStepInput = {
  step_id: Scalars['String']['input'];
  timer_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerTimerTrackInput = {
  timer_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerTimerTypeInput = {
  timer_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
  type: TriggerActivationReferenceType;
};

export type SetTriggerTrackInput = {
  track_id: Scalars['String']['input'];
  trigger_id: Scalars['String']['input'];
};

export type SetTriggerTypeInput = {
  trigger_id: Scalars['String']['input'];
  type: TriggerType;
};

export type ShareFormsInput = {
  form_ids: Array<Scalars['String']['input']>;
  team_id: Scalars['String']['input'];
};

export type SharePathwaysInput = {
  pathway_ids: Array<Scalars['String']['input']>;
  team_id: Scalars['String']['input'];
};

export type SimpleConfigInput = {
  allowed: AllowedCharsInput;
  exactLength?: InputMaybe<Scalars['Float']['input']>;
};

export type SliderConfig = {
  __typename?: 'SliderConfig';
  display_marks: Scalars['Boolean']['output'];
  is_value_tooltip_on: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  max_label: Scalars['String']['output'];
  min: Scalars['Float']['output'];
  min_label: Scalars['String']['output'];
  show_min_max_values: Scalars['Boolean']['output'];
  step_value: Scalars['Float']['output'];
};

export type SliderConfigInput = {
  /** Whether the marks should be displayed on the slider. */
  display_marks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the value tooltip should be displayed on the slider. */
  is_value_tooltip_on?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum value the user can select. */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The label for the maximum value of the slider. */
  max_label?: InputMaybe<Scalars['String']['input']>;
  /** The minimum value the user can select. */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** The label for the minimum value of the slider. */
  min_label?: InputMaybe<Scalars['String']['input']>;
  /** Whether the minimum and maximum values should be displayed on the slider. */
  show_min_max_values?: InputMaybe<Scalars['Boolean']['input']>;
  /** The step value defines the distance between each tick on the slider. It is used to control the granularity of the slider. */
  step_value?: InputMaybe<Scalars['Float']['input']>;
};

export type SliderQuestionConfigInput = {
  /** The new slider specific configuration for the question. */
  slider: SliderConfigInput;
};

export type SortingOutput = {
  __typename?: 'SortingOutput';
  direction: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type SortingParams = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type SourceControlInput = {
  access_token: Scalars['String']['input'];
  branch_name: Scalars['String']['input'];
  repo_url: Scalars['String']['input'];
};

export type SourceControlSettings = {
  __typename?: 'SourceControlSettings';
  access_token: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  repo_url: Scalars['String']['output'];
};

/**
 *
 *   Stakeholders are humans that are in any way involved in the pathway of the patient
 *   Examples of stakeholders:
 *     - caregivers
 *     - doctors
 *     - parents
 *     - friends
 *     - guardians
 *     - paramedics (e.g., revalidation coach)
 *     - ...
 *
 */
export type Stakeholder = {
  __typename?: 'Stakeholder';
  clinical_app_role: StakeholderClinicalAppRole;
  id: Scalars['ID']['output'];
  label: StakeholderLabel;
};

export enum StakeholderClinicalAppRole {
  Caregiver = 'CAREGIVER',
  Patient = 'PATIENT',
  Physician = 'PHYSICIAN'
}

export type StakeholderEmail = {
  __typename?: 'StakeholderEmail';
  definition_id: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type StakeholderEmailInput = {
  definition_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type StakeholderLabel = {
  __typename?: 'StakeholderLabel';
  en: Scalars['String']['output'];
};

export enum StakeholdersMode {
  Multiple = 'multiple',
  Single = 'single',
  Toggle = 'toggle'
}

export type StakeholdersPayload = Payload & {
  __typename?: 'StakeholdersPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stakeholders: Array<Stakeholder>;
  success: Scalars['Boolean']['output'];
};

export type StakeholdersSelectSettings = {
  __typename?: 'StakeholdersSelectSettings';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  mode: StakeholdersMode;
};

export type StartPreviewInput = {
  baseline_info?: InputMaybe<Array<BaselineInfoInput>>;
  pathway_case_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type StartPreviewPayload = Payload & {
  __typename?: 'StartPreviewPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway_case: PathwayCase;
  success: Scalars['Boolean']['output'];
};

export type StartTrackFromStepInput = {
  destination_connector_id: TransitionConnectorId;
  destination_step_id: Scalars['String']['input'];
  origin_connector_id: TransitionConnectorId;
  track_id: Scalars['String']['input'];
};

export type StartTrackFromStepPayload = Payload & {
  __typename?: 'StartTrackFromStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export type StartTransitionFromStepInput = {
  origin_connector_id?: InputMaybe<Scalars['String']['input']>;
  origin_step_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type StartTransitionFromStepPayload = Payload & {
  __typename?: 'StartTransitionFromStepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export enum Status {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

/**
 *
 *   Step is a sequence of actions.
 *   Step exist only within an track.
 *   Step represents a single procedure within an track.
 *
 *   Examples of steps:
 *
 *   1. Post operation patient follow-up with following actions
 *      - send an email to patient
 *      - patient fills in form
 *      - calculation is done
 *      - alert generated if calculation result is bad
 *
 *   2. Baseline intake with following actions
 *      - sending an email to a patient that he/she is included in the pathway
 *      - sending an email to the clinical team that new patient is included in the pathway
 *      - filling in baseline forms by the patient
 *
 */
export type Step = {
  __typename?: 'Step';
  actions?: Maybe<Array<Action>>;
  coordinates: Coordinates;
  created: AuditTrail;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<FormattedText>;
  id: Scalars['ID']['output'];
  label?: Maybe<Label>;
  last_updated?: Maybe<AuditTrail>;
  title?: Maybe<Scalars['String']['output']>;
  track_id?: Maybe<Scalars['ID']['output']>;
  transitions: Array<Transition>;
  type: StepType;
};

export type StepCompletedActivationReference = TriggerActivationReference & {
  __typename?: 'StepCompletedActivationReference';
  step_id?: Maybe<Scalars['ID']['output']>;
  track_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerActivationReferenceType>;
};

export type StepCompletedActivationReferenceInput = {
  step_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
  type: TriggerActivationReferenceType;
};

export type StepCompletedTriggerSettings = TriggerSettings & {
  __typename?: 'StepCompletedTriggerSettings';
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['ID']['output']>;
  step_id?: Maybe<Scalars['ID']['output']>;
  track_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerType>;
};

export type StepLibraryPayload = Payload & {
  __typename?: 'StepLibraryPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  steps: Array<Step>;
  success: Scalars['Boolean']['output'];
};

export type StepPayload = Payload & {
  __typename?: 'StepPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  step: Step;
  success: Scalars['Boolean']['output'];
};

export enum StepType {
  Step = 'STEP',
  Template = 'TEMPLATE'
}

export type StepsPayload = Payload & {
  __typename?: 'StepsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  steps: Array<Step>;
  success: Scalars['Boolean']['output'];
};

/**
 *
 *   Note represents text for remembrance when building pathway. It can be placed anywhere
 *   in a track.
 *   Notes exist only within a track for now.
 *   Note represents a single post-it note within a track.
 *
 */
export type StickyNote = {
  __typename?: 'StickyNote';
  body?: Maybe<StickyNoteBody>;
  coordinates: Coordinates;
  id: Scalars['ID']['output'];
};

export type StickyNoteBody = {
  __typename?: 'StickyNoteBody';
  format: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type StickyNoteBodyInput = {
  format: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type StickyNotePayload = Payload & {
  __typename?: 'StickyNotePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stickyNote: StickyNote;
  success: Scalars['Boolean']['output'];
};

export type StickyNotesInput = {
  pathway_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type StickyNotesPayload = Payload & {
  __typename?: 'StickyNotesPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stickyNotes: Array<StickyNote>;
  success: Scalars['Boolean']['output'];
};

export type StringArrayField = ExtensionActionField & {
  __typename?: 'StringArrayField';
  description?: Maybe<Scalars['String']['output']>;
  dropdownOptions?: Maybe<Array<ExtensionDropdownOption>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ExtensionActionFieldType;
  /** Value is kept as string because it can contain data point definition id in handlebars template, otherwise it is just "array of strings" */
  value?: Maybe<Scalars['String']['output']>;
};

export type StringField = ExtensionActionField & {
  __typename?: 'StringField';
  description?: Maybe<Scalars['String']['output']>;
  dropdownOptions?: Maybe<Array<ExtensionDropdownOption>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  stringType?: Maybe<StringType>;
  type: ExtensionActionFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum StringType {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Text = 'TEXT',
  Url = 'URL'
}

export type SubActivity = {
  __typename?: 'SubActivity';
  action: ActivityAction;
  date: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  error_category?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  object?: Maybe<ActivityObject>;
  scheduled_date?: Maybe<Scalars['String']['output']>;
  subject: ActivitySubject;
  text?: Maybe<TranslatedText>;
};

export type SubjectInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SubmitChecklistInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
  subject: SubjectInput;
};

export type SubmitChecklistPayload = Payload & {
  __typename?: 'SubmitChecklistPayload';
  activity: Activity;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type SubmitFormResponseInput = {
  activity_id: Scalars['String']['input'];
  pathway_case_id: Scalars['String']['input'];
  response: Array<QuestionResponseInput>;
  subject: SubjectInput;
};

export type SubmitFormResponsePayload = Payload & {
  __typename?: 'SubmitFormResponsePayload';
  activity: Activity;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  activitiesDeleted: ActivitiesDeleted;
  activityCompleted: Activity;
  activityCreated: Activity;
  activityUpdated: Activity;
  apiCallCreated: PathwayCaseApiCall;
  apiCallUpdated: PathwayCaseApiCall;
  careflowSummarizationEvent: CareflowSummarizationEvent;
  elementCompleted: Element;
  elementCreated: Element;
  elementDeleted: Element;
  elementUpdated: Element;
  eventReplayed: RebuildViewModelStatus;
  onCheckpointRestoredMessage: CheckpointMessage;
  onCodeBlockUpdated: CodeBlockPayload;
  onDataCatalogUpdated: DataCatalogUpdatedPayload;
  onExportPathwayStatusUpdate: ExportPathwayStatus;
  onExtensionActionPreview: ExtensionActionPreviewEvent;
  onImportPathwayStatusUpdate: ImportPathwayStatus;
  pathwayComponentUpdated: Pathway;
  pathwayRepaired: RepairPathwaysStatus;
  previewUpdated: PathwayCase;
  projectionError: RebuildViewModelError;
  rebuildGraphStatusUpdated: RebuildGraphStatus;
  triggerActivationCreated: TriggerActivation;
  triggerActivationUpdated: TriggerActivation;
  webhookCallCreated: PathwayCaseWebhookCall;
  webhookCallUpdated: PathwayCaseWebhookCall;
  webhookCallsDeleted: WebhookCallsDeleted;
};


export type SubscriptionActivitiesDeletedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionActivityCompletedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionActivityCreatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionActivityUpdatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionApiCallCreatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionApiCallUpdatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionElementCompletedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionElementCreatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionElementDeletedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionElementUpdatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionOnCheckpointRestoredMessageArgs = {
  careflow_id: Scalars['String']['input'];
};


export type SubscriptionOnCodeBlockUpdatedArgs = {
  code_block_id: Scalars['String']['input'];
};


export type SubscriptionOnDataCatalogUpdatedArgs = {
  pathway_definition_id: Scalars['String']['input'];
};


export type SubscriptionOnExtensionActionPreviewArgs = {
  correlation_id: Scalars['String']['input'];
};


export type SubscriptionPreviewUpdatedArgs = {
  pathway_case_id: Scalars['ID']['input'];
};


export type SubscriptionRebuildGraphStatusUpdatedArgs = {
  pathway_definition_id: Scalars['String']['input'];
};


export type SubscriptionTriggerActivationCreatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionTriggerActivationUpdatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionWebhookCallCreatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionWebhookCallUpdatedArgs = {
  pathway_case_id: Scalars['String']['input'];
};


export type SubscriptionWebhookCallsDeletedArgs = {
  pathway_case_id: Scalars['String']['input'];
};

export type SubtractDurationParameters = {
  __typename?: 'SubtractDurationParameters';
  duration?: Maybe<DurationGraphQlObjectType>;
};

export type SubtractDurationTransformation = Transformation & {
  __typename?: 'SubtractDurationTransformation';
  id: Scalars['ID']['output'];
  parameters?: Maybe<SubtractDurationParameters>;
  type: TransformationType;
};

export type SummaryRun = {
  __typename?: 'SummaryRun';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  thread_id: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  accent_color?: Maybe<Scalars['String']['output']>;
  api_call_retry_settings?: Maybe<ApiCallRetrySettings>;
  hosted_page_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  logo_path?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  public?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantPayload = Payload & {
  __typename?: 'TenantPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  tenant: Tenant;
};

export type TenantsPayload = Payload & {
  __typename?: 'TenantsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  tenants: Array<Tenant>;
};

export type TestCodeBlockError = {
  __typename?: 'TestCodeBlockError';
  message: Scalars['String']['output'];
  stack?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TestCodeBlockInput = {
  code_block_id: Scalars['String']['input'];
  /** Environment variables (constants) as key-value pairs */
  environmentVariables?: InputMaybe<Scalars['JSON']['input']>;
  /** Mock execution context (patient profile, IDs) for testing */
  mockContext?: InputMaybe<MockContextInput>;
  /** Test input values as key-value pairs */
  testInputs?: InputMaybe<Scalars['JSON']['input']>;
};

export type TestCodeBlockMeta = {
  __typename?: 'TestCodeBlockMeta';
  durationMs: Scalars['Float']['output'];
  executionId: Scalars['String']['output'];
  memoryUsedMb?: Maybe<Scalars['Float']['output']>;
};

export type TestCodeBlockOutput = {
  __typename?: 'TestCodeBlockOutput';
  data_points: Scalars['JSON']['output'];
  result: Scalars['String']['output'];
};

export type TestCodeBlockResult = {
  __typename?: 'TestCodeBlockResult';
  /** Console output from the code execution */
  consoleOutput?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<TestCodeBlockError>;
  meta?: Maybe<TestCodeBlockMeta>;
  output?: Maybe<TestCodeBlockOutput>;
  success: Scalars['Boolean']['output'];
};

export type TestSourceControlInput = {
  pathway_id: Scalars['String']['input'];
};

export type TestSourceControlPayload = Payload & {
  __typename?: 'TestSourceControlPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type TextField = ExtensionActionField & {
  __typename?: 'TextField';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  slate?: Maybe<Scalars['String']['output']>;
  type: ExtensionActionFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type Timer = {
  __typename?: 'Timer';
  config?: Maybe<TimerConfig>;
  coordinates?: Maybe<Coordinates>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  suggestions: Array<TimerConfig>;
};

export type TimerConfig = {
  description: Scalars['String']['output'];
  type: TimerType;
};

export type TimerDataPointAwaitedInput = {
  data_point_definition_id: Scalars['String']['input'];
  data_point_key: Scalars['String']['input'];
  description: Scalars['String']['input'];
  timeout: TimerDataPointAwaitedTimeoutInput;
};

export type TimerDataPointAwaitedTimeoutInput = {
  unit: DelayUnitType;
  value: Scalars['Float']['input'];
};

export type TimerDataPointReferenceInput = {
  data_point_definition_id: Scalars['String']['input'];
  data_point_key: Scalars['String']['input'];
  description: Scalars['String']['input'];
  hour?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  offsetDirection?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  usePatientTimezone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimerDelay = {
  __typename?: 'TimerDelay';
  unit: DelayUnitType;
  value: Scalars['Float']['output'];
};

export type TimerDelayInput = {
  unit: DelayUnitType;
  value: Scalars['Float']['input'];
};

export type TimerExtensionResourceUpdatedInput = {
  action_definition_id: Scalars['String']['input'];
  action_key: Scalars['String']['input'];
  description: Scalars['String']['input'];
  extension_key: Scalars['String']['input'];
  resource_id: ExtensionResourceIdInput;
  timer_key: Scalars['String']['input'];
};

export type TimerPayload = Payload & {
  __typename?: 'TimerPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timer: Timer;
};

export enum TimerType {
  DataPointAwaited = 'DATA_POINT_AWAITED',
  DataPointReference = 'DATA_POINT_REFERENCE',
  Delay = 'DELAY',
  ExtensionResourceUpdated = 'EXTENSION_RESOURCE_UPDATED'
}

export type TimersPayload = Payload & {
  __typename?: 'TimersPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timers: Array<Timer>;
};

/**
 *
 *   Timings exist in the context of a transition.
 *   It allows you to add time delays before going from one step to another.
 *   Delays can be:
 *     - static
 *     - dynamic
 *   Static delays are always the same across pathway instances.
 *   Dynamic delays vary based on data point instances.
 *
 */
export type Timing = {
  __typename?: 'Timing';
  delay?: Maybe<Delay>;
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  reference_key?: Maybe<Scalars['String']['output']>;
};

export type TimingPayload = Payload & {
  __typename?: 'TimingPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  timing: Timing;
};

/**
 *
 *   A box to put steps in, just a set of steps.
 *   It is a way to group steps together, to make pathway more understandable.
 *   Pathways are made out of tracks. (e.g. Surgery, Hormonal therapy ...)
 *   Steps in a track are not executed sequentially.
 *   Order of execution of steps within an track is defined by transitions.
 *
 *   You can transition for Track A to Track B by linking transition from any step in Track A to track's End node
 *   and configuring that transition to go to Track B.
 *
 */
export type Track = {
  __typename?: 'Track';
  agents: Array<Agent>;
  created: AuditTrail;
  description?: Maybe<Scalars['String']['output']>;
  end_coordinates: Coordinates;
  id: Scalars['ID']['output'];
  last_updated?: Maybe<AuditTrail>;
  logics: Array<Logic>;
  loop_configuration?: Maybe<LoopConfiguration>;
  start_coordinates: Coordinates;
  steps: Array<Step>;
  sticky_notes: Array<StickyNote>;
  timers: Array<Timer>;
  title: Scalars['String']['output'];
  transitions: Array<Transition>;
  triggers: Array<Trigger>;
};

export type TrackCompletedActivationReference = TriggerActivationReference & {
  __typename?: 'TrackCompletedActivationReference';
  track_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerActivationReferenceType>;
};

export type TrackCompletedActivationReferenceInput = {
  track_id: Scalars['String']['input'];
  type: TriggerActivationReferenceType;
};

export type TrackCompletedTriggerSettings = TriggerSettings & {
  __typename?: 'TrackCompletedTriggerSettings';
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['ID']['output']>;
  track_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerType>;
};

export type TrackPayload = Payload & {
  __typename?: 'TrackPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  /**
   *
   *   A box to put steps in, just a set of steps.
   *   It is a way to group steps together, to make pathway more understandable.
   *   Pathways are made out of tracks. (e.g. Surgery, Hormonal therapy ...)
   *   Steps in a track are not executed sequentially.
   *   Order of execution of steps within an track is defined by transitions.
   *
   *   You can transition for Track A to Track B by linking transition from any step in Track A to track's End node
   *   and configuring that transition to go to Track B.
   *
   */
  track: Track;
};

export type TrackStartedActivationReference = TriggerActivationReference & {
  __typename?: 'TrackStartedActivationReference';
  track_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<TriggerActivationReferenceType>;
};

export type TrackStartedActivationReferenceInput = {
  track_id: Scalars['String']['input'];
  type: TriggerActivationReferenceType;
};

export type TracksPayload = Payload & {
  __typename?: 'TracksPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  tracks: Array<Track>;
};

export type TransferPathwayInput = {
  new_user_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
};

export type Transformation = {
  id: Scalars['ID']['output'];
  type: TransformationType;
};

export type TransformationInput = {
  type: TransformationType;
  value: Scalars['String']['input'];
};

export enum TransformationType {
  AddDuration = 'ADD_DURATION',
  AddPrefix = 'ADD_PREFIX',
  AddSuffix = 'ADD_SUFFIX',
  AddWeekdays = 'ADD_WEEKDAYS',
  FormatDate = 'FORMAT_DATE',
  FormatPhoneNumber = 'FORMAT_PHONE_NUMBER',
  RoundTo = 'ROUND_TO',
  SubtractDuration = 'SUBTRACT_DURATION'
}

export type Transition = {
  __typename?: 'Transition';
  default: Scalars['Boolean']['output'];
  destination?: Maybe<TransitionNode>;
  id: Scalars['ID']['output'];
  origin: TransitionNode;
  rule?: Maybe<Rule>;
  status: ConfigurationStatus;
  timing?: Maybe<Timing>;
  type: TransitionType;
};

export enum TransitionConnectorId {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export type TransitionNode = {
  __typename?: 'TransitionNode';
  connector_id?: Maybe<Scalars['String']['output']>;
  node_id: Scalars['ID']['output'];
  node_title: Scalars['String']['output'];
  type: TransitionNodeType;
};

export type TransitionNodeInput = {
  connector_id?: InputMaybe<Scalars['String']['input']>;
  node_id: Scalars['String']['input'];
  type: TransitionNodeType;
};

export enum TransitionNodeType {
  Agent = 'AGENT',
  Logic = 'LOGIC',
  PathwayEnd = 'PATHWAY_END',
  PathwayStart = 'PATHWAY_START',
  Step = 'STEP',
  Timer = 'TIMER',
  Track = 'TRACK',
  TrackEnd = 'TRACK_END',
  TrackStart = 'TRACK_START'
}

export type TransitionPayload = Payload & {
  __typename?: 'TransitionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  transition: Transition;
};

export enum TransitionType {
  Legacy = 'LEGACY',
  Plain = 'PLAIN'
}

export type TransitionsInput = {
  pathway_id: Scalars['String']['input'];
  track_id: Scalars['String']['input'];
};

export type TransitionsPayload = Payload & {
  __typename?: 'TransitionsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  transitions: Array<Transition>;
};

export type TranslatedText = {
  __typename?: 'TranslatedText';
  en?: Maybe<Scalars['String']['output']>;
};

export type TranslatedTextInput = {
  en?: InputMaybe<Scalars['String']['input']>;
};

export type TrashPathwayInput = {
  pathway_id: Scalars['String']['input'];
};

/**
 *
 *   A pathway can be trashed.
 *   When a pathway is trashed it is not shown in the pathways list.
 *   A trashed pathway is still editable (TEMPORARY: likely to change).
 *   When a pathway is in the trash it can be:
 *   - removed from the trash. It becomes available again
 *   - permanently deleted
 *   NOTE: A pathway can be permanently deleted only if it is in the trash.
 *
 *   In summary the state transitions of a pathway:
 *   active <-> in trash -> deleted
 *
 */
export type Trashed = {
  __typename?: 'Trashed';
  is_trashed: Scalars['Boolean']['output'];
  trashed_at: Scalars['SafeDate']['output'];
  trashed_by: PathwayCollaborator;
};

export type Trigger = {
  __typename?: 'Trigger';
  created: AuditTrail;
  id: Scalars['ID']['output'];
  last_updated: AuditTrail;
  settings?: Maybe<TriggerSettings>;
  target_id: Scalars['ID']['output'];
  target_type: TriggerTargetType;
  tenant_id: Scalars['ID']['output'];
  timers?: Maybe<Array<DesignatedTriggerTimer>>;
  version: Scalars['Int']['output'];
};

export type TriggerActivation = {
  __typename?: 'TriggerActivation';
  id: Scalars['ID']['output'];
  status: TriggerActivationStatus;
  track: Track;
  trigger: Trigger;
  type: TriggerActivationType;
};

export type TriggerActivationPayload = Payload & {
  __typename?: 'TriggerActivationPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger_activation: TriggerActivation;
};

export type TriggerActivationReference = {
  type?: Maybe<TriggerActivationReferenceType>;
};

export type TriggerActivationReferenceInput = {
  data_point_collected?: InputMaybe<DataPointCollectedActivationReferenceInput>;
  pathway_started?: InputMaybe<PathwayStartedActivationReferenceInput>;
  step_completed?: InputMaybe<StepCompletedActivationReferenceInput>;
  track_completed?: InputMaybe<TrackCompletedActivationReferenceInput>;
  track_started?: InputMaybe<TrackStartedActivationReferenceInput>;
};

export enum TriggerActivationReferenceType {
  AdHoc = 'AD_HOC',
  DataPointCollected = 'DATA_POINT_COLLECTED',
  PathwayStarted = 'PATHWAY_STARTED',
  StepCompleted = 'STEP_COMPLETED',
  TrackCompleted = 'TRACK_COMPLETED',
  TrackStarted = 'TRACK_STARTED'
}

export enum TriggerActivationStatus {
  Activated = 'ACTIVATED',
  Canceled = 'CANCELED',
  Discarded = 'DISCARDED',
  Pending = 'PENDING'
}

export enum TriggerActivationType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type TriggerActivationsPayload = Payload & {
  __typename?: 'TriggerActivationsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger_activations: Array<TriggerActivation>;
};

export type TriggerApiCallInput = {
  activity_id: Scalars['String']['input'];
  mock_response_body?: InputMaybe<Scalars['String']['input']>;
  mock_response_status?: InputMaybe<Scalars['Float']['input']>;
};

export type TriggerApiCallPayload = Payload & {
  __typename?: 'TriggerApiCallPayload';
  api_call: PathwayCaseApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type TriggerDelayInput = {
  amount: Scalars['Int']['input'];
  unit: DelayUnitType;
};

export type TriggerEventConfig = {
  __typename?: 'TriggerEventConfig';
  description: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  shelly_thread_id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TriggerEventSuggestion = {
  __typename?: 'TriggerEventSuggestion';
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TriggerInput = {
  settings?: InputMaybe<TriggerSettingsInput>;
  target_type: TriggerTargetType;
  timers?: InputMaybe<Array<DesignatedTriggerTimerInput>>;
};

export type TriggerPayload = Payload & {
  __typename?: 'TriggerPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  trigger: Trigger;
};

export type TriggerSettings = {
  rule?: Maybe<Rule>;
  type?: Maybe<TriggerType>;
};

export type TriggerSettingsInput = {
  data_point_definition_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  rule_id?: InputMaybe<Scalars['String']['input']>;
  shelly_thread_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  step_id?: InputMaybe<Scalars['String']['input']>;
  track_id?: InputMaybe<Scalars['String']['input']>;
  type: TriggerType;
};

export enum TriggerTargetType {
  Pathway = 'PATHWAY',
  Track = 'TRACK'
}

export enum TriggerType {
  AdHoc = 'AD_HOC',
  DataPointCollected = 'DATA_POINT_COLLECTED',
  DataPointNotCollected = 'DATA_POINT_NOT_COLLECTED',
  EventBased = 'EVENT_BASED',
  ExtensionWebhook = 'EXTENSION_WEBHOOK',
  PathwayStarted = 'PATHWAY_STARTED',
  StepCompleted = 'STEP_COMPLETED',
  TrackCompleted = 'TRACK_COMPLETED'
}

export type UpdateAgentConfigInput = {
  agent_id: Scalars['String']['input'];
  config: AgentConfigInput;
};

export type UpdateApiCallMappingDataPointInput = {
  api_call_id: Scalars['String']['input'];
  data_point_definition_id?: InputMaybe<Scalars['String']['input']>;
  mapping_id: Scalars['String']['input'];
};

export type UpdateApiCallMappingDataPointPayload = Payload & {
  __typename?: 'UpdateApiCallMappingDataPointPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateApiCallMappingFirstMatchOnlyInput = {
  api_call_id: Scalars['String']['input'];
  first_match_only: Scalars['Boolean']['input'];
  mapping_id: Scalars['String']['input'];
};

export type UpdateApiCallMappingFirstMatchOnlyPayload = Payload & {
  __typename?: 'UpdateApiCallMappingFirstMatchOnlyPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateApiCallMappingKeyInput = {
  api_call_id: Scalars['String']['input'];
  mapping_id: Scalars['String']['input'];
  response_key: Scalars['String']['input'];
};

export type UpdateApiCallMappingKeyPayload = Payload & {
  __typename?: 'UpdateApiCallMappingKeyPayload';
  api_call: ApiCall;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCareFlowApiCallRetrySettingsInput = {
  api_call_retry_settings: ApiCallRetrySettingsInput;
  pathway_id: Scalars['String']['input'];
};

export type UpdateCareFlowApiCallRetrySettingsPayload = Payload & {
  __typename?: 'UpdateCareFlowApiCallRetrySettingsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type UpdateCareFlowSourceControlSettingsInput = {
  pathway_id: Scalars['String']['input'];
  source_control: SourceControlInput;
};

export type UpdateCareFlowSourceControlSettingsPayload = Payload & {
  __typename?: 'UpdateCareFlowSourceControlSettingsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type UpdateClinicalNoteContextInput = {
  clinical_note_id: Scalars['String']['input'];
  context: Array<ClinicalNoteContextFieldInput>;
};

export type UpdateClinicalNoteContextPayload = Payload & {
  __typename?: 'UpdateClinicalNoteContextPayload';
  clinical_note: ClinicalNote;
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateClinicalNoteNarrativeBodyInput = {
  body: Scalars['String']['input'];
  clinical_note_id: Scalars['String']['input'];
  html_body: Scalars['String']['input'];
  narrative_id: Scalars['ID']['input'];
};

export type UpdateConstantInput = {
  constant_id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  obfuscated: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateConstantPayload = Payload & {
  __typename?: 'UpdateConstantPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateDataPointDefinitionInput = {
  data_point_definition_id: Scalars['String']['input'];
  fields: DataPointDefinitionInput;
  pathway_id: Scalars['String']['input'];
};

export type UpdateDataPointDefinitionPayload = Payload & {
  __typename?: 'UpdateDataPointDefinitionPayload';
  code: Scalars['String']['output'];
  data_point_definition: DataPointDefinition;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDynamicVariableInput = {
  data_point_definition_id: Scalars['String']['input'];
  data_point_property?: InputMaybe<DataPointPropertyType>;
  fallback: Scalars['String']['input'];
  id: Scalars['String']['input'];
  is_hyperlink?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  transformations: Array<TransformationInput>;
};

export type UpdateDynamicVariablePayload = Payload & {
  __typename?: 'UpdateDynamicVariablePayload';
  code: Scalars['String']['output'];
  dynamic_variable: DynamicVariable;
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
};

export type UpdateEmailNotificationStatusInput = {
  allow_email_notifications: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
};

export type UpdateEmailNotificationStatusPayload = Payload & {
  __typename?: 'UpdateEmailNotificationStatusPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  settings: PathwaySettings;
  success: Scalars['Boolean']['output'];
};

export type UpdateLabelTextInput = {
  label_id: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type UpdateLabelTextPayload = Payload & {
  __typename?: 'UpdateLabelTextPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  label: Label;
  success: Scalars['Boolean']['output'];
};

export type UpdateLogicConfigInput = {
  config_id?: InputMaybe<Scalars['String']['input']>;
  logic_id: Scalars['String']['input'];
};

export type UpdateLogicNameInput = {
  logic_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateQuestionInput = {
  /** The ID of the form containing the question. */
  form_id: Scalars['String']['input'];
  /** A short display name for the question. Used as the card label for description fields. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The new options for the question. */
  options?: InputMaybe<Array<OptionInput>>;
  /** The ID of the question to update. */
  question_id: Scalars['String']['input'];
  /** The new title for the question. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The HTML version of the title for the question. */
  title_html?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionPayload = Payload & {
  __typename?: 'UpdateQuestionPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  question: Question;
  success: Scalars['Boolean']['output'];
};

export type UpdateStickyNoteBodyInput = {
  body: StickyNoteBodyInput;
  sticky_note_id: Scalars['String']['input'];
};

export type UpdateStickyNoteBodyPayload = Payload & {
  __typename?: 'UpdateStickyNoteBodyPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  stickyNote: StickyNote;
  success: Scalars['Boolean']['output'];
};

export type UpdateTimerConfigInput = {
  data_point_awaited_config?: InputMaybe<TimerDataPointAwaitedInput>;
  data_point_reference_config?: InputMaybe<TimerDataPointReferenceInput>;
  delay_config?: InputMaybe<TimerDelayInput>;
  extension_resource_updated_config?: InputMaybe<TimerExtensionResourceUpdatedInput>;
  timer_id: Scalars['String']['input'];
};

export type UpdateWebhookEndpointInput = {
  endpoint: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookEndpointPayload = Payload & {
  __typename?: 'UpdateWebhookEndpointPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookHeadersInput = {
  headers?: Array<WebhookHeaderInput>;
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookHeadersPayload = Payload & {
  __typename?: 'UpdateWebhookHeadersPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookInput = {
  pathway_id: Scalars['String']['input'];
  webhook: ExistingWebhookInput;
};

export type UpdateWebhookNameInput = {
  name: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookNamePayload = Payload & {
  __typename?: 'UpdateWebhookNamePayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookPayload = Payload & {
  __typename?: 'UpdateWebhookPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookStatusInput = {
  enabled: Scalars['Boolean']['input'];
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookStatusPayload = Payload & {
  __typename?: 'UpdateWebhookStatusPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookSubscribedEventsInput = {
  pathway_id: Scalars['String']['input'];
  subscribed_events?: InputMaybe<Array<Scalars['String']['input']>>;
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookSubscribedEventsPayload = Payload & {
  __typename?: 'UpdateWebhookSubscribedEventsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UpdateWebhookTestEndpointInput = {
  endpoint_test: Scalars['String']['input'];
  pathway_id: Scalars['String']['input'];
  webhook_id: Scalars['String']['input'];
};

export type UpdateWebhookTestEndpointPayload = Payload & {
  __typename?: 'UpdateWebhookTestEndpointPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  pathway: Pathway;
  success: Scalars['Boolean']['output'];
};

export type UsageContext = {
  __typename?: 'UsageContext';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 *
 *   A user is a person who is going to login and interact with pathway studio.
 *   A user can belong to multiple teams.
 *
 *   A team is a:
 *   - Group of users, and
 *   - Group of resources i.e. Pathways and Forms
 *
 *   Inside a team:
 *   - Each user has a role or list of roles.
 *   - Each user has access to the group of resources.
 *
 *   A role is a group of permissions which define how users interact (i.e. create, read, update, delete) with each resource
 *
 *   Example permission: "read:pathways", "create:forms"
 *   Example role: "editor", "owner", "viewer"
 *
 *   The model definitions look like this.
 *
 *   Team: {
 *     id: string
 *     name: string
 *   }
 *
 *   TeamRelations {
 *     team_id: stirng
 *     team_name: string
 *     roles: [string]
 *   }
 *
 *   User: {
 *     id: string
 *     name: string
 *     ....
 *     teams: [TeamRelations]
 *   }
 *
 *   Pathway: {
 *     id: string
 *     ....
 *     teams: [{
 *       team_id: string
 *     }]
 *   }
 *
 *
 */
export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intercom_hash: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pending_invitation_id?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  tenant?: Maybe<Tenant>;
};

export type UserPayload = Payload & {
  __typename?: 'UserPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  user: User;
};

export enum UserQuestionType {
  Date = 'DATE',
  Description = 'DESCRIPTION',
  Email = 'EMAIL',
  File = 'FILE',
  Icd10Classification = 'ICD10_CLASSIFICATION',
  Image = 'IMAGE',
  LongText = 'LONG_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultipleChoiceGrid = 'MULTIPLE_CHOICE_GRID',
  MultipleSelect = 'MULTIPLE_SELECT',
  Number = 'NUMBER',
  ShortText = 'SHORT_TEXT',
  Signature = 'SIGNATURE',
  Slider = 'SLIDER',
  Telephone = 'TELEPHONE',
  YesNo = 'YES_NO'
}

export type UsesContextItem = {
  __typename?: 'UsesContextItem';
  component_type?: Maybe<Scalars['String']['output']>;
  definition_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum VersionStatus {
  Archived = 'Archived',
  Live = 'Live'
}

export type Webhook = {
  __typename?: 'Webhook';
  created_at: Scalars['SafeDate']['output'];
  enabled: Scalars['Boolean']['output'];
  endpoint: Scalars['String']['output'];
  endpoint_test?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Array<WebhookHeader>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  signing_key?: Maybe<Scalars['String']['output']>;
  subscribed_events?: Maybe<Array<Scalars['String']['output']>>;
};

export type WebhookCall = {
  __typename?: 'WebhookCall';
  created_at: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pathway?: Maybe<ApiPathwayContext>;
  request: WebhookCallRequest;
  responses: Array<WebhookCallResponse>;
  status: Scalars['String']['output'];
  webhook_id: Scalars['String']['output'];
  webhook_name: Scalars['String']['output'];
};

export type WebhookCallHeader = {
  __typename?: 'WebhookCallHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WebhookCallRequest = {
  __typename?: 'WebhookCallRequest';
  body: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  headers: Array<WebhookCallHeader>;
  method: Scalars['String']['output'];
};

export type WebhookCallResponse = {
  __typename?: 'WebhookCallResponse';
  body: Scalars['String']['output'];
  date: Scalars['String']['output'];
  status: Scalars['Float']['output'];
};

export type WebhookCallsDeleted = {
  __typename?: 'WebhookCallsDeleted';
  webhook_call_ids: Array<Scalars['String']['output']>;
};

export type WebhookDataPointGraphQlType = {
  __typename?: 'WebhookDataPointGraphQLType';
  key: Scalars['String']['output'];
  valueType: Scalars['String']['output'];
};

export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  created: CreatedByGraphQlType;
  data_points: Array<WebhookDataPointGraphQlType>;
  extension_slug?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization_slug: Scalars['String']['output'];
  resources: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tenant_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  webhook_key?: Maybe<Scalars['String']['output']>;
};

export type WebhookEndpointsPayload = {
  __typename?: 'WebhookEndpointsPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhookEndpoints: Array<WebhookEndpoint>;
};

export type WebhookHeader = {
  __typename?: 'WebhookHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WebhookHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type WebhookInput = {
  pathway_id: Scalars['String']['input'];
  webhook_id?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookPayload = Payload & {
  __typename?: 'WebhookPayload';
  code: Scalars['String']['output'];
  error?: Maybe<ErrorObject>;
  success: Scalars['Boolean']['output'];
  webhook?: Maybe<Webhook>;
};

export type WorkerAgent = {
  __typename?: 'WorkerAgent';
  agent_uuid: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inputs: Array<AgentConfigMapping>;
  name: Scalars['String']['output'];
  outputs: Array<AgentConfigMapping>;
  stakeholders: Array<AgentStakeholder>;
  tools: AgentTool;
  version: Scalars['Float']['output'];
};

export type WorkerAgentsPayload = {
  __typename?: 'WorkerAgentsPayload';
  workerAgents: Array<WorkerAgent>;
};

export type EventsQueryVariables = Exact<{
  input: EventsInput;
}>;


export type EventsQuery = { __typename?: 'Query', events: { __typename?: 'DomainEventsPayload', events: Array<{ __typename?: 'DomainEvent', id: string, stream: string, event_type: string, data?: string | null, metadata: { __typename?: 'DomainEventMetadata', user_id: string, caused_by?: string | null, saga_id?: string | null, timestamp: string, version: number } }> } };

export type ExportPathwayMutationVariables = Exact<{
  input: ExportPathwayInput;
}>;


export type ExportPathwayMutation = { __typename?: 'Mutation', exportPathway: { __typename?: 'EmptyPayload', success: boolean } };

export type OnExportPathwayStatusUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnExportPathwayStatusUpdateSubscription = { __typename?: 'Subscription', onExportPathwayStatusUpdate: { __typename?: 'ExportPathwayStatus', message: string, url?: string | null, content?: string | null, count?: { __typename?: 'ExportPathwayEventsCount', event_count: number, exported_count: number } | null } };

export type ImportPathwayMutationVariables = Exact<{
  input: ImportPathwayInput;
}>;


export type ImportPathwayMutation = { __typename?: 'Mutation', importPathway: { __typename?: 'EmptyPayload', success: boolean } };

export type OnImportPathwayStatusUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnImportPathwayStatusUpdateSubscription = { __typename?: 'Subscription', onImportPathwayStatusUpdate: { __typename?: 'ImportPathwayStatus', message: string, count?: { __typename?: 'ImportPathwayEventsCount', event_count: number, imported_count: number, event_id: string } | null } };

export type ListPathwaysQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPathwaysQuery = { __typename?: 'Query', listPathways: { __typename?: 'PathwaysPayload', pathways: Array<{ __typename?: 'Pathway', id: string, title: string }> } };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsPayload', tenants: Array<{ __typename?: 'Tenant', id: string, name: string }> } };


export const EventsDocument = gql`
    query Events($input: EventsInput!) {
  events(input: $input) {
    events {
      id
      stream
      event_type
      data
      metadata {
        user_id
        caused_by
        saga_id
        timestamp
        version
      }
    }
  }
}
    `;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables> & ({ variables: EventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export function useEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const ExportPathwayDocument = gql`
    mutation ExportPathway($input: ExportPathwayInput!) {
  exportPathway(input: $input) {
    success
  }
}
    `;
export type ExportPathwayMutationFn = Apollo.MutationFunction<ExportPathwayMutation, ExportPathwayMutationVariables>;

/**
 * __useExportPathwayMutation__
 *
 * To run a mutation, you first call `useExportPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPathwayMutation, { data, loading, error }] = useExportPathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportPathwayMutation(baseOptions?: Apollo.MutationHookOptions<ExportPathwayMutation, ExportPathwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPathwayMutation, ExportPathwayMutationVariables>(ExportPathwayDocument, options);
      }
export type ExportPathwayMutationHookResult = ReturnType<typeof useExportPathwayMutation>;
export type ExportPathwayMutationResult = Apollo.MutationResult<ExportPathwayMutation>;
export type ExportPathwayMutationOptions = Apollo.BaseMutationOptions<ExportPathwayMutation, ExportPathwayMutationVariables>;
export const OnExportPathwayStatusUpdateDocument = gql`
    subscription OnExportPathwayStatusUpdate {
  onExportPathwayStatusUpdate {
    message
    url
    content
    count {
      event_count
      exported_count
    }
  }
}
    `;

/**
 * __useOnExportPathwayStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useOnExportPathwayStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnExportPathwayStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnExportPathwayStatusUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnExportPathwayStatusUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnExportPathwayStatusUpdateSubscription, OnExportPathwayStatusUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnExportPathwayStatusUpdateSubscription, OnExportPathwayStatusUpdateSubscriptionVariables>(OnExportPathwayStatusUpdateDocument, options);
      }
export type OnExportPathwayStatusUpdateSubscriptionHookResult = ReturnType<typeof useOnExportPathwayStatusUpdateSubscription>;
export type OnExportPathwayStatusUpdateSubscriptionResult = Apollo.SubscriptionResult<OnExportPathwayStatusUpdateSubscription>;
export const ImportPathwayDocument = gql`
    mutation ImportPathway($input: ImportPathwayInput!) {
  importPathway(input: $input) {
    success
  }
}
    `;
export type ImportPathwayMutationFn = Apollo.MutationFunction<ImportPathwayMutation, ImportPathwayMutationVariables>;

/**
 * __useImportPathwayMutation__
 *
 * To run a mutation, you first call `useImportPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPathwayMutation, { data, loading, error }] = useImportPathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPathwayMutation(baseOptions?: Apollo.MutationHookOptions<ImportPathwayMutation, ImportPathwayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPathwayMutation, ImportPathwayMutationVariables>(ImportPathwayDocument, options);
      }
export type ImportPathwayMutationHookResult = ReturnType<typeof useImportPathwayMutation>;
export type ImportPathwayMutationResult = Apollo.MutationResult<ImportPathwayMutation>;
export type ImportPathwayMutationOptions = Apollo.BaseMutationOptions<ImportPathwayMutation, ImportPathwayMutationVariables>;
export const OnImportPathwayStatusUpdateDocument = gql`
    subscription OnImportPathwayStatusUpdate {
  onImportPathwayStatusUpdate {
    message
    count {
      event_count
      imported_count
      event_id
    }
  }
}
    `;

/**
 * __useOnImportPathwayStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useOnImportPathwayStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnImportPathwayStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnImportPathwayStatusUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnImportPathwayStatusUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnImportPathwayStatusUpdateSubscription, OnImportPathwayStatusUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnImportPathwayStatusUpdateSubscription, OnImportPathwayStatusUpdateSubscriptionVariables>(OnImportPathwayStatusUpdateDocument, options);
      }
export type OnImportPathwayStatusUpdateSubscriptionHookResult = ReturnType<typeof useOnImportPathwayStatusUpdateSubscription>;
export type OnImportPathwayStatusUpdateSubscriptionResult = Apollo.SubscriptionResult<OnImportPathwayStatusUpdateSubscription>;
export const ListPathwaysDocument = gql`
    query ListPathways {
  listPathways {
    pathways {
      id
      title
    }
  }
}
    `;

/**
 * __useListPathwaysQuery__
 *
 * To run a query within a React component, call `useListPathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPathwaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPathwaysQuery(baseOptions?: Apollo.QueryHookOptions<ListPathwaysQuery, ListPathwaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPathwaysQuery, ListPathwaysQueryVariables>(ListPathwaysDocument, options);
      }
export function useListPathwaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPathwaysQuery, ListPathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPathwaysQuery, ListPathwaysQueryVariables>(ListPathwaysDocument, options);
        }
export function useListPathwaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPathwaysQuery, ListPathwaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPathwaysQuery, ListPathwaysQueryVariables>(ListPathwaysDocument, options);
        }
export type ListPathwaysQueryHookResult = ReturnType<typeof useListPathwaysQuery>;
export type ListPathwaysLazyQueryHookResult = ReturnType<typeof useListPathwaysLazyQuery>;
export type ListPathwaysSuspenseQueryHookResult = ReturnType<typeof useListPathwaysSuspenseQuery>;
export type ListPathwaysQueryResult = Apollo.QueryResult<ListPathwaysQuery, ListPathwaysQueryVariables>;
export const GetTenantsDocument = gql`
    query GetTenants {
  tenants {
    tenants {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
      }
export function useGetTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export function useGetTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsSuspenseQuery>;
export type GetTenantsQueryResult = Apollo.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;